const es = {
    'chatAiDevis.qualityIncell': 'InCell',
    'chatAiDevis.qualityOled': 'OLED',
    'chatAiDevis.qualityOriginal': 'Original / OEM',
    'chatAiDevis.qualityCompatible': 'Compatible',
    'chatAiDevis.qualityReconditionné': 'Reacondicionado',
    'chatAiDevis.qualityPremium': 'Premium',
    'chatAiDevis.qualityStandard': 'Estándar',
    'chatAiDevis.fieldName': 'nombre',
    'chatAiDevis.fieldPhone': 'teléfono',
    'chatAiDevis.fieldEmail': 'correo',
    'chatAiDevis.familyAccessoryStock': 'Accesorio · stock',
    'chatAiDevis.familyAccessoryCapped': 'Accesorio · ≤49 €',
    'chatAiDevis.familyAccessory': 'Accesorio',
    'chatAiDevis.familyPart': 'Pieza',
    'chatAiDevis.familyScreen': 'Pantalla',
    'chatAiDevis.badgeFallback': 'Precio estimado (alternativo)',
    'chatAiDevis.badgeModelScore': 'Puntuación modelo {{score}}',
    'chatAiDevis.badgeModelScoreShort': 'Puntuación modelo',
    'chatAiDevis.badgeNeedsReview': 'Por verificar',
    'chatAiDevis.altOtherParts': 'Otras piezas (todos los proveedores)',
    'chatAiDevis.altSelected': 'Seleccionada',
    'chatAiDevis.useBtn': 'Usar',
    'chatAiDevis.compareTitle': 'Comparativa Jens / Mobilax / LCD-Phone',
    'chatAiDevis.compareCurrentLabel': 'Actual:',
    'chatAiDevis.htSuffix': 'sin IVA',
    'chatAiDevis.compareNoneFound': 'No se encontró ninguna pieza en los 3 proveedores.',
    'chatAiDevis.colSupplier': 'Proveedor',
    'chatAiDevis.colPart': 'Pieza',
    'chatAiDevis.colPurchaseHt': 'Compra sin IVA',
    'chatAiDevis.colTtcEst': 'Est. con IVA',
    'chatAiDevis.colStock': 'Stock',
    'chatAiDevis.colExactModel': 'Modelo exacto',
    'chatAiDevis.badgeCheapest': 'más barato',
    'chatAiDevis.badgeCurrent': 'actual',
    'chatAiDevis.scoreInline': 'puntuación {{score}}',
    'chatAiDevis.compareNoResultFor': 'Sin resultado: {{suppliers}}',
    'chatAiDevis.cadbotEmptyCache': 'Solicitud CADBOT — caché de proveedor vacía. Introduzca el precio de compra sin IVA y pulse Validar para enviar el presupuesto.',
    'chatAiDevis.purchaseMissingZero': 'Falta el precio de compra (0 €) — Actualice la pieza o introduzca el precio de compra manualmente.',
    'chatAiDevis.supplierPrimary': 'principal',
    'chatAiDevis.supplierAlternate': 'alternativo',
    'chatAiDevis.defaultRepair': 'Reparación',
    'chatAiDevis.defaultPart': 'Pieza',
    'chatAiDevis.defaultClient': 'Cliente',
    'chatAiDevis.identityIncompleteInline': 'Ficha de cliente incompleta ({{fields}}) — obligatoria antes de validar',
    'chatAiDevis.willSendTo': 'El presupuesto se enviará a {{email}}',
    'chatAiDevis.phName': 'Nombre y apellidos *',
    'chatAiDevis.phPhone': 'Teléfono *',
    'chatAiDevis.phEmail': 'Correo *',
    'chatAiDevis.saveIdentityBtn': 'Guardar ficha de cliente',
    'chatAiDevis.ttcCalcul': 'con IVA · /calcul',
    'chatAiDevis.selectedPart': 'Pieza seleccionada',
    'chatAiDevis.purchasePriceHt': 'Precio de compra sin IVA',
    'chatAiDevis.labor': 'Mano de obra',
    'chatAiDevis.recalcTotal': 'Recalcular el total',
    'chatAiDevis.hideCompare': 'Ocultar comparativa',
    'chatAiDevis.compareBtn': 'Comparar Jens / Mobilax / LCD-Phone',
    'chatAiDevis.showAlternatives': 'Ver alternativas (lista)',
    'chatAiDevis.hideAlternatives': 'Ocultar alternativas (lista)',
    'chatAiDevis.botStaff': 'Bot de personal',
    'chatAiDevis.bestPartAuto': 'Mejor pieza (auto)',
    'chatAiDevis.pdf': 'PDF',
    'chatAiDevis.approveSingle': 'Validar (individual)',
    'chatAiDevis.reject': 'Rechazar',
    'chatAiDevis.print': 'Imprimir',
    'chatAiDevis.dirAdminTitle': 'Dirección / admin de tienda',
    'chatAiDevis.delete': 'Eliminar',
    'chatAiDevis.approvedShort': 'Validado',
    'chatAiDevis.rejectedShort': 'Rechazado',
    'chatAiDevis.batchLabel': 'Lote {{count}} presupuestos',
    'chatAiDevis.clientChat': 'Chat del cliente',
    'chatAiDevis.approveAllSend': 'Validar los {{count}} y enviar',
    'chatAiDevis.deleteBatch': 'Eliminar el lote',
    'chatAiDevis.pageTitle': 'Presupuestos IA — validación',
    'chatAiDevis.pageSubtitle': '4 opciones por solicitud de pantalla · InCell · OLED · Reacondicionado · Original',
    'chatAiDevis.filterPending': 'Pendientes',
    'chatAiDevis.filterApproved': 'Validados',
    'chatAiDevis.filterRejected': 'Rechazados',
    'chatAiDevis.filterAll': 'Todos',
    'chatAiDevis.infoTitle': 'Chat IA y Auto-Devis — proveedores',
    'chatAiDevis.infoJensPrimary': 'es el proveedor principal (prioridad en la puntuación).',
    'chatAiDevis.infoAnd': 'y',
    'chatAiDevis.infoMobilaxLcd': 'se consultan si hay una mejor coincidencia o si Jens no tiene la pieza.',
    'chatAiDevis.infoEachRange': 'Cada gama (InCell, OLED, etc.) puede provenir de un proveedor diferente — verifique antes de validar.',
    'chatAiDevis.infoCompareExplain': '«Comparar Jens / Mobilax / LCD-Phone» muestra el precio de compra sin IVA, el total con IVA estimado, el stock y el modelo exacto en cada proveedor — «Usar» cambia el borrador.',
    'chatAiDevis.infoBadgesLabel': 'Etiquetas:',
    'chatAiDevis.infoBadgesCheck': '— controle la pieza antes de validar.',
    'chatAiDevis.infoBotStaffExplain': '(panel derecho) — describa una reparación para crear los borradores, o escriba «comparer» para ver todos los proveedores.',
    'chatAiDevis.loading': 'Cargando…',
    'chatAiDevis.noQuotesPending': 'No hay presupuestos pendientes.',
    'chatAiDevis.noQuotes': 'No hay presupuestos.',
    'chatAiDevis.emptyHint': 'Use el Bot Auto-Devis de la derecha para crear uno (p. ej. «Pantalla iPhone 14»).',
    'chatAiDevis.backToStaff': '← Volver al espacio del personal',
    'chatAiDevis.botAutoDevis': 'Bot Auto-Devis',
    'chatAiDevis.staffSpace': '← Espacio del personal',
    'chatAiDevis.errPdfPreview': 'Error de vista previa del PDF',
    'chatAiDevis.alertPurchaseMissingPrint': 'Falta el precio de compra — introduzca un precio o actualice la pieza antes de imprimir.',
    'chatAiDevis.errPrintTicket': 'Error al imprimir el ticket de 80 mm',
    'chatAiDevis.errRecalc': 'Error de recálculo',
    'chatAiDevis.errPartNotFound': 'Pieza no encontrada en la caché del proveedor',
    'chatAiDevis.errCompare': 'Error en la comparación de proveedores',
    'chatAiDevis.errAlternatives': 'Error al cargar las alternativas',
    'chatAiDevis.errSaveIdentity': 'Error al guardar la ficha de cliente',
    'chatAiDevis.alertIdentityIncomplete': 'Ficha de cliente incompleta: {{fields}}. El nombre, el teléfono y el correo son obligatorios antes de validar y enviar el presupuesto.',
    'chatAiDevis.mailWillSend': 'Se enviará un correo con el PDF a: {{email}}',
    'chatAiDevis.noClientEmail': '(Sin correo del cliente — validación solo por chat)',
    'chatAiDevis.confirmApprove': '¿Validar este presupuesto y enviarlo al cliente?',
    'chatAiDevis.sumupWarn': 'Atención: no se pudo crear el enlace de pago SumUp ({{error}}). El botón del correo ofrecerá el pago al hacer clic; verifique la clave API de SumUp en la configuración.',
    'chatAiDevis.sumupUnavailable': 'SumUp no disponible',
    'chatAiDevis.approvedMailSent': 'Presupuesto validado — correo enviado a {{email}}.',
    'chatAiDevis.approvedSent': 'Presupuesto validado y enviado al cliente.',
    'chatAiDevis.errApprove': 'Error de validación',
    'chatAiDevis.confirmApproveBatch': '¿Validar los {{count}} presupuestos y enviar el resumen al cliente?',
    'chatAiDevis.batchApproved': '{{count}} presupuestos validados y enviados al cliente.',
    'chatAiDevis.errApproveBatch': 'Error al validar el lote',
    'chatAiDevis.promptRejectReason': 'Motivo del rechazo (opcional):',
    'chatAiDevis.errGeneric': 'Error',
    'chatAiDevis.confirmDeleteDevis': '¿Eliminar definitivamente el presupuesto {{ref}}?\n\nAcción irreversible.',
    'chatAiDevis.errDelete': 'Error al eliminar',
    'chatAiDevis.confirmDeleteBatch': '¿Eliminar definitivamente los {{count}} presupuestos del lote?\n\nAcción irreversible.',
    'chatAiDevis.errDeleteBatch': 'Error al eliminar el lote',
    'saLayout.nav_dashboard': 'Panel de control',
    'saLayout.nav_analytics': 'Analíticas',
    'saLayout.nav_companies': 'Empresas',
    'saLayout.nav_subscriptions': 'Suscripciones',
    'saLayout.nav_users': 'Usuarios',
    'saLayout.nav_stats': 'Estadísticas',
    'saLayout.nav_communications': 'Comunicaciones',
    'saLayout.nav_impersonation': 'Modo Soporte',
    'saLayout.nav_config': 'Configuración',
    'saLayout.nav_integrations': 'Integraciones API',
    'saLayout.nav_security': 'Seguridad (2FA)',
    'saLayout.nav_logs': 'Registro y auditoría',
    'saLayout.super_admin': 'Súper Admin',
    'saLayout.role_super_admin': 'Súper Administrador',
    'saLayout.logout': 'Cerrar sesión',
    'saLayout.top_bar_title': 'Panel Súper Admin',
    'saConfig.error': 'Error',
    'saConfig.confirmMaintenance': '¿Activar el modo de mantenimiento? Los clientes ya no podrán acceder a la plataforma.',
    'saConfig.title': 'Configuración',
    'saConfig.subtitle': 'Ajustes globales de la plataforma',
    'saConfig.saved': 'Guardado',
    'saConfig.saving': 'Guardando...',
    'saConfig.save': 'Guardar',
    'saConfig.maintenanceTitle': 'Modo de mantenimiento',
    'saConfig.maintenanceDesc': 'Bloquear temporalmente el acceso de los clientes',
    'saConfig.generalSettings': 'Ajustes generales',
    'saConfig.platformName': 'Nombre de la plataforma',
    'saConfig.gracePeriod': 'Periodo de gracia (días)',
    'saConfig.plans': 'Planes de precios',
    'saConfig.planPrice': 'Precio (EUR/mes)',
    'saConfig.maxShops': 'Máx. tiendas',
    'saConfig.maxUsers': 'Máx. usuarios',
    'saConfig.features': 'Funcionalidades',
    'saImpersonation.title': 'Modo Soporte (Suplantación)',
    'saImpersonation.subtitle': 'Acceder temporalmente a la cuenta de una empresa',
    'saImpersonation.confirmEnter': '¿Entrar en modo soporte para esta empresa?',
    'saImpersonation.errorGeneric': 'Error',
    'saImpersonation.activeBannerTitle': 'Modo Soporte activo',
    'saImpersonation.connectedAs': 'Conectado como: {{name}}',
    'saImpersonation.stopSupport': 'Salir del modo soporte',
    'saImpersonation.warningTitle': 'Atención — Función sensible',
    'saImpersonation.warningText': 'La suplantación le da acceso completo a la cuenta del cliente. Todas sus acciones quedan registradas. La contraseña del cliente nunca se modificará.',
    'saImpersonation.searchPlaceholder': 'Buscar una empresa...',
    'saImpersonation.emptyList': 'No se encontró ninguna empresa',
    'saImpersonation.companyMeta': '{{email}} - Plan {{plan}}',
    'saImpersonation.enterBtn': 'Entrar',
    'saPackages.title': 'Gestión de paquetes',
    'saPackages.subtitle': 'Reemplaza directamente los ZIP y el agente de Windows servidos en producción.',
    'saPackages.refresh': 'Actualizar',
    'saPackages.statAvailable': 'Artefactos disponibles',
    'saPackages.statTotalSize': 'Tamaño total',
    'saPackages.statAlert': 'Alerta',
    'saPackages.alertText': 'Los reemplazos sobrescriben el archivo en vivo. No existe una eliminación independiente.',
    'saPackages.statusAvailable': 'Disponible',
    'saPackages.statusMissing': 'Faltante',
    'saPackages.download': 'Descargar',
    'saPackages.activeFile': 'Archivo activo',
    'saPackages.size': 'Tamaño',
    'saPackages.lastUpdate': 'Última actualización',
    'saPackages.uploadedBy': 'Subido por',
    'saPackages.replaceLiveFile': 'Reemplazar el archivo en vivo',
    'saPackages.uploading': 'Subiendo…',
    'saPackages.replace': 'Reemplazar',
    'saPackages.replaceHint': 'El archivo elegido reemplaza directamente el que se sirve a los usuarios en remobiles.com.',
    'saPackages.selectedFile': 'Archivo seleccionado: {{name}}',
    'saPackages.errorLoad': 'Error al cargar los archivos',
    'saPackages.downloadLinkUnavailable': 'Enlace de descarga no disponible',
    'saPackages.downloadFailed': 'No se pudo descargar',
    'saPackages.selectFileFor': 'Selecciona un archivo para {{label}}.',
    'saPackages.confirmReplace': '¿Reemplazar ahora {{label}} por {{name}}?',
    'saPackages.replaceSuccess': '{{label}} reemplazado correctamente.',
    'saPackages.errorUpload': 'Error durante la subida',
    'saPackages.superAdminOnly': 'Acceso solo para superadministradores',
    'saPackages.superAdminDesc': 'Esta página permite actualizar los archivos que actualmente sirve remobiles.com. Los enlaces de descarga públicos siguen gestionados por las rutas firmadas del backend.',
    'saDashboard.title': 'Panel de control',
    'saDashboard.subtitle': 'Vista general de la plataforma {{brand}}',
    'saDashboard.companies': 'Empresas',
    'saDashboard.activeCount': '{{count}} activas',
    'saDashboard.users': 'Usuarios',
    'saDashboard.shops': 'Tiendas',
    'saDashboard.mrr': 'MRR',
    'saDashboard.mrrSub': 'Ingresos recurrentes mensuales',
    'saDashboard.newThisMonth': 'Nuevos este mes',
    'saDashboard.expired': 'Vencidos',
    'saDashboard.suspended': 'Suspendidas',
    'saDashboard.recentCompanies': 'Empresas recientes',
    'saDashboard.viewAll': 'Ver todo',
    'saDashboard.noCompanies': 'Aún no hay empresas',
    'saDashboard.recentActivity': 'Actividad reciente',
    'saDashboard.noActivity': 'Sin actividad reciente',
    'saAnalytics.title': 'Analíticas de la plataforma',
    'saAnalytics.subtitle': 'KPIs globales y rendimiento por empresa',
    'saAnalytics.kpiRepairsToday': 'Reparaciones hoy',
    'saAnalytics.kpiActiveRepairs': 'Reparaciones activas',
    'saAnalytics.kpiRevenueMonth': 'Ingresos este mes',
    'saAnalytics.kpiClientsTotal': 'Clientes totales',
    'saAnalytics.kpiRepairsWeek': 'Reparaciones semana',
    'saAnalytics.kpiRepairsMonth': 'Reparaciones mes',
    'saAnalytics.kpiRepairsTotal': 'Reparaciones total',
    'saAnalytics.kpiRevenueTotal': 'Ingresos totales',
    'saAnalytics.kpiActiveCompanies': 'Empresas activas',
    'saAnalytics.companyPerformance': 'Rendimiento por empresa',
    'saAnalytics.companiesCount': '{{count}} empresas',
    'saAnalytics.emptyCompanies': 'Ninguna empresa activa',
    'saAnalytics.colCompany': 'Empresa',
    'saAnalytics.colPlan': 'Plan',
    'saAnalytics.colRepairs': 'Reparaciones',
    'saAnalytics.colActive': 'Activas',
    'saAnalytics.colClients': 'Clientes',
    'saAnalytics.colStock': 'Stock',
    'saAnalytics.colSales': 'Ventas',
    'saAnalytics.colRevenue': 'Ingresos',
    'saAnalytics.colAvgTime': 'Tiempo prom.',
    'saAnalytics.daysShort': '{{n}}d',
    'saLogs.title': 'Registro y Seguridad',
    'saLogs.subtitle': 'Auditoría de acciones y estado del sistema',
    'saLogs.systemHealth': 'Estado del Sistema',
    'saLogs.database': 'Base de datos',
    'saLogs.statusOk': 'OK',
    'saLogs.statusError': 'Error',
    'saLogs.filterAll': 'Todas las acciones',
    'saLogs.filterCreateCompany': 'Creación de empresa',
    'saLogs.filterUpdateCompany': 'Modificación de empresa',
    'saLogs.filterSuspend': 'Suspensión',
    'saLogs.filterActivate': 'Reactivación',
    'saLogs.filterImpersonate': 'Suplantación',
    'saLogs.filterCreateUser': 'Creación de usuario',
    'saLogs.filterDeleteUser': 'Eliminación de usuario',
    'saLogs.filterResetPassword': 'Restablecer contraseña',
    'saLogs.filterUpdateSubscription': 'Modificación de suscripción',
    'saLogs.filterUpdateConfig': 'Modificación de config',
    'saLogs.entriesCount': '{{count}} entradas',
    'saLogs.empty': 'No hay entradas en el registro',
    'saLogs.onTarget': 'en {{target}}',
    'saLogs.byUserAt': 'por {{user}} - {{date}}',
    'saComm.title': 'Comunicaciones',
    'saComm.messagesSent': '{{count}} mensajes enviados',
    'saComm.newMessage': 'Nuevo mensaje',
    'saComm.emptyList': 'No se ha enviado ninguna comunicación',
    'saComm.noSubject': 'Sin asunto',
    'saComm.allClients': 'Todos los clientes',
    'saComm.companiesCount': '{{count}} empresa(s)',
    'saComm.modalTitle': 'Enviar una comunicación',
    'saComm.typeLabel': 'Tipo',
    'saComm.typeNotification': 'Notificación',
    'saComm.typeMaintenance': 'Mantenimiento',
    'saComm.typeUpdate': 'Actualización',
    'saComm.recipients': 'Destinatarios',
    'saComm.targetSelected': 'Selección',
    'saComm.targetedCompanies': 'Empresas seleccionadas',
    'saComm.subjectLabel': 'Asunto *',
    'saComm.messageLabel': 'Mensaje *',
    'saComm.cancel': 'Cancelar',
    'saComm.send': 'Enviar',
    'saComm.errorGeneric': 'Error',
    'saSecurity.pageTitle': 'Seguridad de la cuenta',
    'saSecurity.pageSubtitle': '2FA, restricción de IP y ajustes de seguridad',
    'saSecurity.errorGeneric': 'Error',
    'saSecurity.twoFAEnabledSuccess': '¡2FA activado con éxito!',
    'saSecurity.invalidCode': 'Código no válido',
    'saSecurity.twoFADisabled': '2FA desactivado',
    'saSecurity.saveError': 'Error al guardar',
    'saSecurity.twoFATitle': 'Autenticación de dos factores (2FA)',
    'saSecurity.statusEnabled': 'Activado',
    'saSecurity.statusDisabled': 'Desactivado',
    'saSecurity.setupBtn': 'Configurar 2FA',
    'saSecurity.scanQrInstruction': 'Escanea este código QR con Google Authenticator:',
    'saSecurity.qrCodeAlt': 'Código QR',
    'saSecurity.manualKeyInstruction': 'O introduce esta clave manualmente:',
    'saSecurity.verificationCodeLabel': 'Código de verificación',
    'saSecurity.verifyBtn': 'Verificar',
    'saSecurity.disableInstruction': 'Para desactivar el 2FA, introduce tu código actual:',
    'saSecurity.ipRestrictionTitle': 'Restricción de IP (opcional)',
    'saSecurity.ipRestrictionSubtitle': 'Limitar el acceso de superadministrador a ciertas direcciones IP',
    'saSecurity.ipPlaceholder': 'Una IP por línea (ej.: 192.168.1.1)',
    'saSecurity.saved': 'Guardado',
    'saSecurity.save': 'Guardar',
    'saStats.title': 'Estadísticas de negocio',
    'saStats.subtitle': 'Análisis y proyecciones financieras',
    'saStats.mrrTitle': 'Ingresos recurrentes mensuales (MRR)',
    'saStats.planDistTitle': 'Distribución de planes',
    'saStats.emptyData': 'Sin datos',
    'saStats.churnTitle': 'Tasa de cancelación (Churn)',
    'saStats.cancelledCount': '{{count}} cancelado(s)',
    'saStats.growthTitle': 'Crecimiento - Nuevas empresas',
    'repairUi.repairs': 'Reparaciones',
    'repairUi.repairSheet': 'Ficha de reparación',
    'repairUi.edit': 'Editar',
    'repairUi.print': 'Imprimir',
    'repairUi.backToRepairs': 'Volver a reparaciones',
    'repairUi.editRepair': 'Editar reparación',
    'repairUi.newDeposit': 'Nuevo ingreso',
    'repairUi.ref': 'Ref',
    'saSubscriptions.title': 'Suscripciones',
    'saSubscriptions.count': '{{count}} suscripciones',
    'saSubscriptions.filter_all_statuses': 'Todos los estados',
    'saSubscriptions.filter_all_plans': 'Todos los planes',
    'saSubscriptions.status_active': 'Activo',
    'saSubscriptions.status_suspended': 'Suspendido',
    'saSubscriptions.status_expired': 'Expirado',
    'saSubscriptions.status_overdue': 'Atrasado',
    'saSubscriptions.status_cancelled': 'Cancelado',
    'saSubscriptions.col_company': 'Empresa',
    'saSubscriptions.col_plan': 'Plan',
    'saSubscriptions.col_price': 'Precio',
    'saSubscriptions.col_status': 'Estado',
    'saSubscriptions.col_next_billing': 'Próxima facturación',
    'saSubscriptions.col_discount': 'Descuento',
    'saSubscriptions.col_actions': 'Acciones',
    'saSubscriptions.empty': 'Sin suscripciones',
    'saSubscriptions.action_edit': 'Editar',
    'saSubscriptions.action_extend': 'Prolongar',
    'saSubscriptions.modal_title': 'Editar la suscripción',
    'saSubscriptions.label_discount': 'Descuento (%)',
    'saSubscriptions.plan_option_start': 'Start ({{price}})',
    'saSubscriptions.plan_option_pro': 'Pro ({{price}})',
    'saSubscriptions.plan_option_super': 'Super ({{price}})',
    'saSubscriptions.cancel': 'Cancelar',
    'saSubscriptions.save': 'Guardar',
    'saSubscriptions.prompt_extend_days': 'Número de días a añadir:',
    'saSubscriptions.error': 'Error',
    'saUsers.title': 'Usuarios',
    'saUsers.totalUsers': '{{count}} usuarios',
    'saUsers.newUser': 'Nuevo usuario',
    'saUsers.searchPlaceholder': 'Buscar...',
    'saUsers.filterAllRoles': 'Todos los roles',
    'saUsers.roleSuperAdmin': 'Súper Admin',
    'saUsers.roleAdmin': 'Admin',
    'saUsers.roleUser': 'Empleado',
    'saUsers.roleTechnicien': 'Técnico',
    'saUsers.roleClient': 'Cliente',
    'saUsers.roleB2b': 'B2B',
    'saUsers.emptyState': 'No se encontraron usuarios',
    'saUsers.colUser': 'Usuario',
    'saUsers.colRole': 'Rol',
    'saUsers.colCompany': 'Empresa',
    'saUsers.colCreatedAt': 'Creado el',
    'saUsers.colActions': 'Acciones',
    'saUsers.resetPassword': 'Restablecer contraseña',
    'saUsers.delete': 'Eliminar',
    'saUsers.labelUsername': 'Nombre de usuario',
    'saUsers.labelEmail': 'Correo electrónico',
    'saUsers.labelPassword': 'Contraseña',
    'saUsers.companyNone': 'Ninguna',
    'saUsers.cancel': 'Cancelar',
    'saUsers.create': 'Crear',
    'saUsers.labelNewPassword': 'Nueva contraseña',
    'saUsers.reset': 'Restablecer',
    'saUsers.error': 'Error',
    'saUsers.resetSuccess': 'Contraseña restablecida con éxito',
    'saUsers.confirmDelete': '¿Eliminar al usuario {{username}}?',
    'saCompanies.status_active': 'Activo',
    'saCompanies.status_suspended': 'Suspendido',
    'saCompanies.status_overdue': 'Atrasado',
    'saCompanies.status_archived': 'Archivado',
    'saCompanies.error': 'Error',
    'saCompanies.confirm_suspend': '¿Suspender esta empresa?',
    'saCompanies.suspend_reason_manual': 'Suspendido manualmente',
    'saCompanies.confirm_archive': '¿Archivar esta empresa? Esta acción es irreversible.',
    'saCompanies.reminder_sent': 'Correo de recordatorio enviado',
    'saCompanies.reminder_error': 'Error al enviar',
    'saCompanies.title': 'Empresas',
    'saCompanies.total_companies': '{{count}} empresas en total',
    'saCompanies.new_company': 'Nueva empresa',
    'saCompanies.search_placeholder': 'Buscar...',
    'saCompanies.filter_all_status': 'Todos los estados',
    'saCompanies.filter_overdue': 'Atrasado',
    'saCompanies.filter_all_plans': 'Todos los planes',
    'saCompanies.empty': 'No se encontró ninguna empresa',
    'saCompanies.col_company': 'Empresa',
    'saCompanies.col_plan': 'Plan',
    'saCompanies.col_status': 'Estado',
    'saCompanies.col_users': 'Usuarios',
    'saCompanies.col_registered': 'Registrado el',
    'saCompanies.col_actions': 'Acciones',
    'saCompanies.action_view': 'Ver',
    'saCompanies.action_reminder': 'Enviar un recordatorio de pago',
    'saCompanies.action_suspend': 'Suspender',
    'saCompanies.action_reactivate': 'Reactivar',
    'saCompanies.action_archive': 'Archivar',
    'saCompanies.field_company_name': 'Nombre de la empresa',
    'saCompanies.field_contact': 'Contacto principal',
    'saCompanies.field_email': 'Correo electrónico',
    'saCompanies.field_phone': 'Teléfono',
    'saCompanies.field_address': 'Dirección',
    'saCompanies.field_plan': 'Plan de suscripción',
    'saCompanies.plan_option_start': 'Start ({{price}}/mes)',
    'saCompanies.plan_option_pro': 'Pro ({{price}}/mes)',
    'saCompanies.plan_option_super': 'Super ({{price}}/mes)',
    'saCompanies.field_shop_count': 'Número de tiendas',
    'saCompanies.admin_account': 'Cuenta de administrador de la empresa',
    'saCompanies.field_admin_email': 'Correo del administrador',
    'saCompanies.field_password': 'Contraseña',
    'saCompanies.field_notes': 'Notas internas',
    'saCompanies.cancel': 'Cancelar',
    'saCompanies.create_company': 'Crear la empresa',
    'saCompanies.users_count': '{{count}} usuarios',
    'saCompanies.subscription': 'Suscripción',
    'saCompanies.monthly_price': 'Precio mensual',
    'saCompanies.next_billing': 'Próxima facturación',
    'saCompanies.no_users': 'Ningún usuario',
    'qrRouter.redirecting': 'Redirigiendo...',
    'subscriptionPages.verifyingPayment': 'Verificando el pago...',
    'subscriptionPages.successTitle': '¡Pago realizado!',
    'subscriptionPages.successBody': 'Tu suscripción ya está activa.',
    'subscriptionPages.goToDashboard': 'Ir al panel',
    'subscriptionPages.processingPayment': 'Procesando el pago...',
    'subscriptionPages.errorTitle': 'Error',
    'subscriptionPages.errorBody': 'No se pudo verificar el pago.',
    'subscriptionPages.backToDashboard': 'Volver al panel',
    'subscriptionPages.cancelTitle': 'Pago cancelado',
    'subscriptionPages.cancelBody': 'El pago fue cancelado. Puedes intentarlo de nuevo cuando quieras.',
    'common.error': 'Error',
    'notes.uploadError': 'Error al subir el archivo',
    'notes.downloadError': 'Error al descargar',
    'notes.confirmDeleteFile': '¿Eliminar este archivo?',
    'notes.uploading': 'Subiendo...',
    'notes.attach': 'Adjuntar',
    'notes.addedBy': 'Añadido por {{author}} — {{date}}',
    'notes.sizeBytes': '{{size}} B',
    'notes.sizeKb': '{{size}} KB',
    'notes.sizeMb': '{{size}} MB',
    'historique.subtitle': 'Ventas, tickets y anticipos',
    'historique.centreActivite': 'Centro de actividad',
    'historique.filtresRecherche': 'Filtros y búsqueda',
    'historique.rechercher': 'Buscar',
    'historique.searchPlaceholder': 'Artículo, referencia…',
    'historique.vendeur': 'Vendedor',
    'historique.tous': 'Todos',
    'historique.dateDebut': 'Fecha de inicio',
    'historique.dateFin': 'Fecha de fin',
    'historique.magasin': 'Tienda',
    'historique.filtrer': 'Filtrar',
    'historique.reinitialiser': 'Restablecer',
    'historique.totalVentes': 'Total ventas',
    'historique.totalAcomptes': 'Total anticipos',
    'historique.totalRetraits': 'Total retiros',
    'historique.totalGlobal': 'Total global',
    'historique.commVentes': 'Com. ventas ({{pct}}%)',
    'historique.commReparations': 'Com. reparaciones ({{pct}}%)',
    'historique.commCommandes': 'Com. pedidos ({{pct}}%)',
    'historique.totalCommissions': 'Total comisiones',
    'historique.popupsAutoriser': 'Permita las ventanas emergentes para imprimir.',
    'historique.erreurTelechargement': 'Error al descargar',
    'historique.vendeurDatesRequis': 'Indique vendedor y fechas',
    'historique.erreurImpressionRapport': 'Error al imprimir el informe',
    'historique.erreurConfirmationSumup': 'Error al confirmar SumUp',
    'historique.confirmRefusPaiement': '¿Marcar este pago como rechazado / cancelado?',
    'historique.erreurRefusSumup': 'Error al rechazar SumUp',
    'dash.forceOpen': 'Apertura forzada',
    'dash.force': 'Forzar',
    'dash.forceOpenTitle': 'Forzar apertura de caja {{magasin}}',
    'dash.forceOpenWarning': 'Toda caja abierta se cerrará automáticamente. Se creará una nueva caja con el importe indicado.',
    'dash.noOpenCaisseToForce': 'No hay ninguna caja abierta para cerrar de forma forzada en {{magasin}}.',
    'dash.thisMagasin': 'esta tienda',
    'dash.statusOpenF': 'Abierta',
    'dash.statusClosedF': 'Cerrada',
    'dash.openMagasin': 'Abrir {{magasin}}',
    'dash.forceOpenShort': 'Forzar apertura',
    'dash.closeMagasin': 'Cerrar {{magasin}}',
    'dash.forceCloseShort': 'Forzar cierre',
    'dash.subtitleNetwork': 'Vista de red · caja · KPIs',
    'dash.subtitleWorkshop': 'Taller · reparaciones',
    'dash.subtitleDefault': 'Panel · ventas y actividad',
    'dash.caisseActionsByStore': 'Acciones de caja por tienda',
    'devisFactures.printPopupBlocked': 'Permita las ventanas emergentes para imprimir.',
    'devisFactures.errorPrintTicket': 'Error al imprimir el tique',
    'devisFactures.errorPrintA4': 'Error al imprimir en A4',
    'devisFactures.errorConvert': 'Error al convertir en pedido',
    'devisFactures.errorDelete': 'Error al eliminar',
    'devisFactures.errorInvalidEmail': 'Dirección de correo electrónico no válida',
    'devisFactures.emailSent': '{{type}} enviado a {{email}}',
    'devisFactures.errorSendEmail': 'Error al enviar el correo electrónico',
    'devisFactures.linkedTo': 'Vinculado a {{ref}}',
    'devisFactures.sendByEmail': 'Enviar por correo electrónico',
    'devisFactures.detachConfirm': '¿Desvincular este presupuesto de {{ref}}?',
    'devisFactures.error': 'Error',
    'devisFactures.attachToRepair': 'Vincular a una reparación',
    'devisFactures.emailModalTitle': 'Enviar {{type}} por correo electrónico',
    'devisFactures.refLabel': 'Ref.:',
    'devisFactures.a4PdfNote': 'El documento se enviará en formato PDF A4',
    'devisFactures.clientEmailLabel': 'Dirección de correo electrónico del cliente',
    'devisFactures.emailPlaceholder': 'cliente@ejemplo.com',
    'devisFactures.labelDevis': 'Presupuesto',
    'devisFactures.labelFacture': 'Factura',
    'devisFactures.labelCommande': 'Pedido',
    'devisFactures.labelAvoir': 'Nota de crédito',
    'devisFactures.labelPaye': 'Pagado',
    'devisFactures.labelAnnule': 'Cancelado',
    'devisFactures.labelEnAttente': 'Pendiente',
    'clients.tabPins': 'PIN / Contraseñas',
    'clients.pin': 'PIN',
    'clients.error': 'Error',
    'clients.loadError': 'Error al cargar',
    'clients.saveError': 'Error al guardar',
    'clients.sendError': 'Error de envío',
    'clients.noIdLegacy': 'Este cliente no tiene ID (antiguo). Modifíquelo para actualizarlo.',
    'clients.ficheAccessDenied': 'Acceso denegado: solo el administrador puede ver la ficha del cliente.',
    'clients.pinGenerated': 'PIN {{pin}} generado para {{nom}}',
    'clients.ficheClient': 'Ficha del cliente',
    'clients.optional': 'Opcional',
    'clients.genNewPin': 'Generar nuevo PIN',
    'clients.sendPinEmail': 'Enviar PIN por correo',
    'clients.loyaltyLine': 'Fidelidad: {{level}} — {{points}} pts — {{purchases}} compras',
    'clients.repairs': 'Reparaciones',
    'clients.commandes': 'Pedidos',
    'clients.devis': 'Presupuestos',
    'clients.ventesPos': 'Ventas POS',
    'clients.acomptes': 'Anticipos',
    'clients.noneFem': 'Ninguna',
    'clients.noneMasc': 'Ninguno',
    'cmd.clientPartsTitle': 'Pedidos de piezas de clientes',
    'cmd.pageIntro': 'Añade piezas (en stock o por pedir) como en una reparación. Los anticipos se deducen del total.',
    'cmd.deposits': 'Anticipos',
    'cmd.remainingShort': 'Resto',
    'cmd.statusConverting': 'En conversión',
    'cmd.repairBadge': 'Reparación {{ref}}',
    'cmd.toOrderShort': 'a pedir',
    'cmd.stockOutShort': 'salido de stock',
    'cmd.inStockShort': 'en stock',
    'cmd.view': 'Ver',
    'cmd.addDeposit': '+ Anticipo',
    'cmd.settled': 'Saldado',
    'cmd.convertToRepair': 'Convertir en reparación',
    'cmd.trackingWith': 'Seguimiento: {{num}}',
    'cmd.trackingNumber': 'Número de seguimiento',
    'cmd.newClientParts': 'Nuevo pedido de piezas',
    'cmd.partsSectionTitle': 'Piezas (como en reparación)',
    'cmd.searchStockPlaceholder': 'Buscar una pieza en stock…',
    'cmd.noRef': 'sin ref.',
    'cmd.toOrder': 'a pedir',
    'cmd.stock': 'stock',
    'cmd.qtyShort': 'Cant.',
    'cmd.unitPriceLabel': 'Precio U. (€)',
    'cmd.stockSection': 'Stock',
    'cmd.alreadyOut': 'Ya retirada del stock',
    'cmd.decrementOnSave': 'Se descuenta al guardar',
    'cmd.stillInStock': 'Aún en stock',
    'cmd.outOnConvert': 'Salida al convertir en reparación',
    'cmd.addPendingBtn': 'Pieza a pedir (fuera de stock)',
    'cmd.pendingTitle': 'Pieza a pedir',
    'cmd.designationPlaceholder': 'Designación *',
    'cmd.refOptPlaceholder': 'Ref. (opc.)',
    'cmd.salePricePlaceholder': 'Precio venta €',
    'cmd.partsTotal': 'Total piezas',
    'cmd.depositsPaid': 'Anticipos ya pagados',
    'cmd.addDepositTitle': 'Añadir un anticipo',
    'cmd.orderLabel': 'Pedido',
    'cmd.alreadyPaid': 'Ya pagado',
    'cmd.depositAmount': 'Importe del anticipo (€)',
    'cmd.paymentMode': 'Método de pago',
    'cmd.payCash': 'Efectivo',
    'cmd.payCard': 'Tarjeta',
    'cmd.payTransfer': 'Transferencia',
    'cmd.payCheck': 'Cheque',
    'cmd.newRemainingAfter': 'Nuevo resto tras el anticipo:',
    'cmd.depositsPaidTitle': 'Anticipos pagados',
    'cmd.noDeposits': 'Ningún anticipo pagado',
    'cmd.trackingPlaceholder': 'Ej. 8R123456789FR',
    'cmd.trackingEmailNote': 'Se enviará un correo al cliente si hay un email registrado.',
    'cmd.error': 'Error',
    'cmd.errDesignationRequired': 'Designación requerida para la pieza a pedir',
    'cmd.errClientPhoneRequired': 'Cliente y teléfono obligatorios',
    'cmd.errAddPart': 'Añade al menos una pieza (búsqueda en stock o pieza a pedir)',
    'cmd.errDelete': 'Error al eliminar',
    'cmd.cancelConfirm': '¿Anular este pedido?',
    'cmd.errInvalidAmount': 'Importe no válido',
    'cmd.errDepositExceeds': 'El anticipo no puede superar el importe pendiente ({{reste}})',
    'cmd.errPrintTicket': 'Error al imprimir el tique',
    'cmd.errPrintDepositTicket': 'Error al imprimir el tique de anticipo',
    'cmd.convertConfirm': '¿Convertir este pedido en reparación?',
    'cmd.errConvert': 'Error de conversión en reparación',
    'cmd.promptClientEmail': 'Email del cliente:',
    'cmd.emailSent': 'Orden de pedido enviada a {{email}}',
    'cmd.errSendEmail': 'Error al enviar el correo',
    'cmd.errTracking': 'Error de seguimiento',
    'pos.insufficientStock': 'Stock insuficiente',
    'pos.partialPaymentConfirm': 'El importe pagado ({{paid}}) es inferior al total ({{total}}).\n\nPendiente de pago: {{remaining}}\n\n¿Validar como pago parcial?',
    'pos.loyaltyRewardEarned': '\n\nFIDELIDAD: ¡Enhorabuena! ¡Recompensa desbloqueada! ¡15 % en la próxima compra o 10 % en la próxima reparación!',
    'pos.loyaltyRewardPending': '\n\nFIDELIDAD: Recompensa pendiente (15 % en la próxima compra en caja o 10 % en una reparación)',
    'pos.loyaltyProgress': '\n\nFIDELIDAD: {{points}}/10 compras. ¡Solo {{remaining}} compra(s) para la recompensa!',
    'pos.partialPaymentLine': '\nPAGO PARCIAL - Pendiente de pago: {{remaining}}',
    'pos.invoiceSentAuto': '\nFactura enviada automáticamente a {{email}}',
    'pos.offlineSaleMsg': '\n\nMODO SIN CONEXIÓN - Venta guardada localmente.\nLa sincronización se hará automáticamente en cuanto vuelva Internet.\n(El envío del correo y la actualización del stock se harán en ese momento.)',
    'pos.refLabel': 'Ref.: {{ref}}',
    'pos.totalLabel': 'Total: {{total}}',
    'pos.saleError': 'Error durante la venta.\nCódigo HTTP: {{code}}\nPuede que la venta no se haya guardado. Revisa el historial.',
    'pos.unknownStatus': 'desconocido',
    'pos.invalidEmailEnter': 'Introduce una dirección de correo electrónico válida',
    'pos.accountCreated': '¡Cuenta de cliente creada! Las credenciales se han enviado por correo electrónico.',
    'pos.accountCreateError': 'Error al crear la cuenta',
    'pos.invalidAmount': 'Importe no válido',
    'pos.acompteDesignation': 'Anticipo de reparación {{ref}}',
    'pos.designationPriceRequired': 'Descripción y precio obligatorios',
    'pos.manualAddError': 'Error al añadir manualmente',
    'pos.adminValidationFailed': 'Error de validación de administrador',
    'pos.printTicketError': 'Error al imprimir el ticket',
    'pos.notAllTicketsPrintedConfirm': '⚠️ No has impreso todos los tickets.\n\nEl cliente debe tener cada ticket. ¿Cerrar de todos modos?',
    'pos.invalidEmail': 'Dirección de correo electrónico no válida',
    'pos.invoiceSentTo': 'Factura enviada a {{email}}',
    'pos.sendEmailError': 'Error al enviar el correo electrónico',
    'pos.caisseClosedOffline': 'Caja cerrada. Conéctate a Internet y abre la caja desde el panel para realizar ventas.',
    'pos.caisseCachedHint': 'Estado de la caja recuperado de la caché local (modo sin conexión). La verificación final se hará cuando vuelva Internet.',
    'pos.catalog': 'Catálogo',
    'pos.available': '{{count}} disp.',
    'pos.outOfStockShort': 'Agotado',
    'pos.acompteRepair': 'Anticipo de reparación',
    'pos.rewardAvailable': '¡Recompensa disponible!',
    'pos.rewardAutoApplied': '-15 % aplicado automáticamente',
    'pos.purchases': 'compras',
    'pos.beforeReward': '({{count}} antes de la recompensa)',
    'pos.searchClientPlaceholder': 'Buscar...',
    'pos.clientName': 'Nombre del cliente',
    'pos.phone': 'Teléfono',
    'pos.emailOptional': 'Correo electrónico (opcional)',
    'pos.totalCaps': 'TOTAL',
    'pos.willGenerateTickets': 'Esta venta generará {{count}} tickets separados:',
    'pos.neutralItems': 'neutros',
    'pos.attachedToSession': '(vinculados a la sesión)',
    'pos.clientEmailPlaceholder': 'Correo electrónico del cliente',
    'pos.sent': 'Enviado',
    'pos.send': 'Enviar',
    'pos.alsoAddToStock': 'Añadir también al stock',
    'pos.offlineCbHint': 'Modo sin conexión — pago con tarjeta desactivado (el terminal necesita la red).',
    'pos.whichMagasinTitle': '¿En qué tienda se registra la venta?',
    'pos.close': 'Cerrar',
    'pos.magasinChoiceHelp': 'Elige la tienda donde registrar esta venta. La tienda seleccionada se usará para la venta y para los artículos sin tienda explícita.',
    'pos.magasinLabel': 'Tienda {{code}}',
    'pos.currentPosSessionFull': 'Sesión TPV actual: {{code}}. Si eliges otra tienda, la sesión TPV cambiará a ella para la venta.',
    'pos.validateFor': 'Validar para {{magasin}}',
    'pos.createClientAccount': '¿Crear una cuenta de cliente?',
    'pos.createAccountPrompt': 'Este cliente aún no tiene cuenta. ¿Deseas crearle una cuenta para que acceda a sus facturas en línea?',
    'pos.creating': 'Creando...',
    'pos.yesSendCredentials': 'Sí, enviar las credenciales',
    'pos.noThanks': 'No, gracias',
    'pos.searchRepair': 'Buscar la reparación',
    'pos.searchRepairPlaceholder': 'REP0047, nombre del cliente, modelo...',
    'pos.priceLabel': 'Precio: {{price}}',
    'pos.alreadyPaid': 'Ya pagado: {{amount}}',
    'pos.remainingDue': 'Saldo pendiente: {{amount}}',
    'pos.changeSelection': 'Cambiar',
    'pos.totalPrice': 'Precio total',
    'pos.alreadyPaidShort': 'Ya pagado',
    'pos.remainingDueShort': 'Saldo pendiente',
    'pos.acompteAmountLabel': 'Importe del anticipo (EUR)',
    'pos.addToCart': 'Añadir al carrito',
    'pos.saleRecordedTickets': 'Venta registrada — {{count}} tickets generados',
    'pos.printAllForClient': 'Imprime los {{count}} tickets para el cliente.',
    'pos.printed': 'Impreso',
    'pos.scanToFind': 'Escanea para encontrar {{ref}}',
    'pos.detailUnavailable': 'Detalle no disponible (¿modo sin conexión?)',
    'pos.payment': 'Pago',
    'pos.printing': 'Imprimiendo...',
    'pos.printTicketFor': 'Imprimir ticket {{magasin}}',
    'pos.allTicketsSentToPrint': 'Todos los tickets se han enviado a imprimir.',
    'pos.ticketsPrintedCount': '{{printed}} / {{total}} ticket(s) impreso(s).',
    'pos.printAllTickets': 'Imprimir todos los tickets',
    'pos.articlesCount': '{{count}} artículo(s)',
    'activite.pageTitle': 'Centro de actividad',
    'activite.pageSubtitle': 'Cronología unificada · ventas · pagos · caja · stock · reparaciones',
    'activite.historiqueDetaille': 'Historial detallado',
    'remcaches.err_connexion': 'Error de conexión con el servidor',
    'remcaches.err_champs_requis': 'El nombre de usuario y el código PIN son obligatorios',
    'remcaches.err_pin_court': 'El código PIN debe tener al menos 4 dígitos',
    'remcaches.err_creation': 'Error durante la creación',
    'remcaches.config_initiale': 'Configuración inicial',
    'remcaches.deja_config': 'Configuración ya realizada',
    'remcaches.admin_existe': 'Ya existe un administrador. Esta página está desactivada.',
    'remcaches.aller_connexion': 'Ir al inicio de sesión',
    'remcaches.admin_cree': '¡Administrador creado con éxito!',
    'remcaches.label_utilisateur': 'Usuario:',
    'remcaches.label_role': 'Rol:',
    'remcaches.conserver_identifiants': 'Guarde estas credenciales en un lugar seguro. Esta página ya no estará accesible.',
    'remcaches.se_connecter': 'Iniciar sesión',
    'remcaches.label_username': 'Nombre de usuario *',
    'remcaches.ph_username': 'ej.: carlos',
    'remcaches.label_pin': 'Código PIN (contraseña) *',
    'remcaches.ph_pin': '4 a 6 dígitos',
    'remcaches.label_email': 'Correo electrónico (opcional)',
    'remcaches.label_telephone': 'Teléfono (opcional)',
    'remcaches.btn_creer_admin': 'Crear el administrador',
    'remcaches.footer': 'R.E.Mobiles - Configuración segura',
    'blog.page_title': 'Blog de Reparación de Teléfonos',
    'blog.subtitle': 'Consejos, trucos y novedades sobre la reparación de smartphones en la Guayana Francesa.',
    'blog.cta_title': '¿Necesitas una reparación?',
    'blog.cta_desc': 'Contacta con Resurrection Mobile para un presupuesto gratuito.',
    'blog.loading': 'Cargando...',
    'blog.article_not_found': 'Artículo no encontrado',
    'blog.back_to_blog': 'Volver al blog',
    'blog.home': 'Inicio',
    'blog.see_pricing': 'Ver nuestras tarifas',
    'blog.footer_pricing': 'Nuestras tarifas',
    'blog.empty_title': 'Aún no hay artículos',
    'blog.empty_subtitle': '¡Vuelve pronto para descubrir nuestros consejos!',
    'brandsModels.error': 'Error',
    'brandsModels.deleteBrandConfirm': '¿Eliminar la marca «{{name}}» y todos sus modelos?',
    'brandsModels.noModels': 'Sin modelos.',
    'brandsModels.home': 'Inicio',
    'brandsModels.title': 'Marcas y modelos',
    'brandsModels.countBrands': '{{count}} marcas',
    'brandsModels.countSeries': '{{count}} series',
    'brandsModels.countModels': '{{count}} modelos',
    'brandsModels.searchPlaceholder': 'Buscar una marca, serie o modelo...',
    'brandsModels.newBrandPlaceholder': 'Nueva marca...',
    'brandsModels.addBrand': 'Añadir',
    'brandsModels.loading': 'Cargando...',
    'brandsModels.rename': 'Renombrar',
    'brandsModels.delete': 'Eliminar',
    'brandsModels.addModelPlaceholder': 'Añadir un modelo {{brand}}...',
    'brandsModels.addModel': 'Modelo',
    'brandsModels.deleteModel': 'Eliminar este modelo',
    'brandsModels.noResults': 'Sin resultados para esta búsqueda',
    'brandsModels.empty': 'Ninguna marca. Añade una arriba.',
    'allDocs.title': 'Todos los documentos',
    'allDocs.docsCount': '{{count}} documentos',
    'allDocs.stat.devis': 'Presupuestos',
    'allDocs.stat.factures': 'Facturas',
    'allDocs.stat.bonsCmd': 'Órdenes',
    'allDocs.stat.tickets': 'Tickets',
    'allDocs.stat.total': 'Total',
    'allDocs.searchPlaceholder': 'Buscar por ref., cliente, teléfono...',
    'allDocs.filter': 'Filtrar',
    'allDocs.filterAll': 'Todos',
    'allDocs.type.devis': 'Presupuesto',
    'allDocs.type.facture': 'Factura',
    'allDocs.type.bonCommande': 'Orden de compra',
    'allDocs.type.ticket': 'Ticket',
    'allDocs.col.reference': 'Referencia',
    'allDocs.col.type': 'Tipo',
    'allDocs.col.client': 'Cliente',
    'allDocs.col.telephone': 'Teléfono',
    'allDocs.col.total': 'Total',
    'allDocs.col.statut': 'Estado',
    'allDocs.col.liaisons': 'Vínculos',
    'allDocs.col.date': 'Fecha',
    'allDocs.col.actions': 'Acciones',
    'allDocs.loading': 'Cargando...',
    'allDocs.empty': 'Ningún documento encontrado',
    'allDocs.status.devis': 'Presupuesto',
    'allDocs.status.enAttente': 'En espera',
    'allDocs.status.accepte': 'Aceptado',
    'allDocs.status.refuse': 'Rechazado',
    'allDocs.status.payee': 'Pagada',
    'allDocs.status.commande': 'Pedido',
    'allDocs.status.enCours': 'En curso',
    'allDocs.status.recu': 'Recibido',
    'allDocs.status.livre': 'Entregado',
    'allDocs.status.termine': 'Terminado',
    'allDocs.action.print': 'Imprimir / Ver PDF',
    'allDocs.action.download': 'Descargar PDF',
    'allDocs.action.email': 'Enviar por correo',
    'allDocs.footerCount': '{{count}} documento mostrado',
    'allDocs.footerCountPlural': '{{count}} documentos mostrados',
    'allDocs.printUnavailable': 'Impresión de tique de 80 mm no disponible para este documento (source={{source}}).',
    'allDocs.downloadUnavailable': 'Descarga no disponible para este tipo de documento (source={{source}}).',
    'allDocs.emailUnavailable': 'Envío por correo no disponible para este tipo de documento (source={{source}}).',
    'allDocs.emailPrompt': 'Correo del destinatario:',
    'allDocs.emailSent': '¡Correo enviado!',
    'allDocs.error': 'Error: {{msg}}',
    'themeSettings.title': 'Personalización de colores',
    'themeSettings.subtitle': 'Adapta la apariencia de tu plataforma',
    'themeSettings.cancel': 'Cancelar',
    'themeSettings.saved': 'Guardado',
    'themeSettings.saving': 'Guardando...',
    'themeSettings.save': 'Guardar',
    'themeSettings.presetsTitle': 'Paletas predefinidas',
    'themeSettings.customTitle': 'Colores personalizados',
    'themeSettings.previewTitle': 'Vista previa en vivo',
    'themeSettings.previewCompany': 'Mi Empresa',
    'themeSettings.previewPrimaryBtn': 'Botón Principal',
    'themeSettings.previewSecondaryBtn': 'Botón Secundario',
    'themeSettings.previewNavDashboard': 'Panel',
    'themeSettings.previewNavRepairs': 'Reparaciones',
    'themeSettings.previewNavStock': 'Stock',
    'themeSettings.previewNavClients': 'Clientes',
    'themeSettings.previewStatusInProgress': 'En curso',
    'themeSettings.previewStatusPending': 'En espera',
    'themeSettings.fieldPrimaryLabel': 'Color Principal',
    'themeSettings.fieldPrimaryDesc': 'Botones, enlaces, acentos principales',
    'themeSettings.fieldSecondaryLabel': 'Color Secundario',
    'themeSettings.fieldSecondaryDesc': 'Insignias, indicadores, acentos secundarios',
    'themeSettings.fieldAccentLabel': 'Color de Acento',
    'themeSettings.fieldAccentDesc': 'Fondo de los encabezados, texto contrastado',
    'themeSettings.fieldSidebarBgLabel': 'Fondo de la Barra Lateral',
    'themeSettings.fieldSidebarBgDesc': 'Fondo del menú lateral',
    'themeSettings.fieldSidebarTextLabel': 'Texto de la Barra Lateral',
    'themeSettings.fieldSidebarTextDesc': 'Color del texto en el menú',
    'themeSettings.fieldHeaderBgLabel': 'Fondo del Encabezado',
    'themeSettings.fieldHeaderBgDesc': 'Fondo de la barra superior',
    'themeSettings.presetRougeJaune': 'Rojo y Amarillo',
    'themeSettings.presetGuyane': 'Guyane',
    'themeSettings.presetOceanBleu': 'Océano Azul',
    'themeSettings.presetRoyalViolet': 'Violeta Real',
    'themeSettings.presetEmeraude': 'Esmeralda',
    'themeSettings.presetSunset': 'Atardecer',
    'boutiqueCmd.pageTitle': 'Pedidos E-shop',
    'boutiqueCmd.deleteSelection': 'Eliminar selección ({{count}})',
    'boutiqueCmd.confirmDelete': '¿Eliminar {{count}} pedido(s)?',
    'boutiqueCmd.errUpdate': 'Error al actualizar',
    'boutiqueCmd.errDelete': 'Error al eliminar',
    'boutiqueCmd.noteSent': '✅ Nota enviada al cliente correctamente',
    'boutiqueCmd.errSendNote': 'Error al enviar la nota',
    'boutiqueCmd.trackingSavedEmail': '✅ ¡Número de seguimiento guardado y correo enviado al cliente!',
    'boutiqueCmd.trackingSaved': '✅ ¡Número de seguimiento guardado!',
    'boutiqueCmd.errSaveTracking': 'Error al guardar',
    'boutiqueCmd.confirmValidateProof': '¿Validar este comprobante de pago?',
    'boutiqueCmd.confirmRejectProof': '¿Rechazar este comprobante de pago?',
    'boutiqueCmd.errGeneric': 'Error',
    'boutiqueCmd.errDownload': 'Error al descargar',
    'boutiqueCmd.statutEnAttente': 'Pendiente',
    'boutiqueCmd.statutProofUploaded': 'Comprobante enviado',
    'boutiqueCmd.statutPayee': 'Pagado',
    'boutiqueCmd.statutConfirmee': 'Confirmado',
    'boutiqueCmd.statutPreparee': 'Preparado',
    'boutiqueCmd.statutExpediee': 'Enviado',
    'boutiqueCmd.statutLivree': 'Entregado',
    'boutiqueCmd.statutAnnulee': 'Cancelado',
    'boutiqueCmd.colReference': 'Referencia',
    'boutiqueCmd.colClient': 'Cliente',
    'boutiqueCmd.colArticles': 'Artículos',
    'boutiqueCmd.colTotal': 'Total',
    'boutiqueCmd.colAdresse': 'Dirección',
    'boutiqueCmd.colStatut': 'Estado',
    'boutiqueCmd.colSuivi': 'Seguimiento',
    'boutiqueCmd.colPaiement': 'Pago',
    'boutiqueCmd.colDate': 'Fecha',
    'boutiqueCmd.colActions': 'Acciones',
    'boutiqueCmd.noOrders': 'Sin pedidos',
    'boutiqueCmd.editTracking': 'Modificar',
    'boutiqueCmd.addTrackingTitle': 'Añadir número de seguimiento',
    'boutiqueCmd.addTrackingBtn': '+ Seguimiento',
    'boutiqueCmd.viewProof': 'Ver comprobante',
    'boutiqueCmd.validatePayment': 'Validar pago',
    'boutiqueCmd.rejectProof': 'Rechazar comprobante',
    'boutiqueCmd.validated': 'Validado',
    'boutiqueCmd.notesMessages': 'Notas/Mensajes',
    'boutiqueCmd.notesModalTitle': 'Notas y mensajes - Pedido {{ref}}',
    'boutiqueCmd.clientLabel': 'Cliente:',
    'boutiqueCmd.phoneLabel': 'Teléfono:',
    'boutiqueCmd.deliveryAddressLabel': 'Dirección de entrega:',
    'boutiqueCmd.notSpecified': 'No especificada',
    'boutiqueCmd.exchangeHistory': 'Historial de intercambios',
    'boutiqueCmd.noNote': 'Sin notas para este pedido',
    'boutiqueCmd.staff': '👤 Personal',
    'boutiqueCmd.client': '👥 Cliente',
    'boutiqueCmd.clientResponse': 'Respuesta del cliente:',
    'boutiqueCmd.sendMessageTitle': '✉️ Enviar un mensaje al cliente',
    'boutiqueCmd.notePlaceholder': 'Ej.: Hola, ¿puede confirmar su dirección de entrega? Gracias.',
    'boutiqueCmd.noteHint': '💡 El cliente recibirá este mensaje y podrá responder desde su área de cliente',
    'boutiqueCmd.close': 'Cerrar',
    'boutiqueCmd.sending': 'Enviando...',
    'boutiqueCmd.sendToClient': 'Enviar al cliente',
    'boutiqueCmd.trackingNumber': 'Número de seguimiento',
    'boutiqueCmd.orderShortLabel': 'Pedido:',
    'boutiqueCmd.clientShortLabel': 'Cliente:',
    'boutiqueCmd.trackingPlaceholder': 'Ej.: LA123456789FR',
    'boutiqueCmd.trackingHint': 'El cliente verá este número en su área',
    'boutiqueCmd.cancel': 'Cancelar',
    'boutiqueCmd.saving': 'Guardando...',
    'boutiqueCmd.save': 'Guardar',
    'blogAdmin.confirmDelete': '¿Eliminar este artículo?',
    'blogAdmin.pageTitle': 'Blog y artículos SEO',
    'blogAdmin.pageSubtitle': 'Publica artículos y gestiona el contenido del blog',
    'blogAdmin.viewBlog': 'Ver el blog',
    'blogAdmin.newArticle': 'Nuevo artículo',
    'blogAdmin.tabArticles': 'Artículos',
    'blogAdmin.tabContent': 'Contenido de la página',
    'blogAdmin.editArticle': 'Editar artículo',
    'blogAdmin.fieldTitle': 'Título *',
    'blogAdmin.titlePlaceholder': 'ej.: Reparación de pantalla de iPhone en Cayenne: precios y plazos',
    'blogAdmin.fieldExcerpt': 'Extracto (vista previa)',
    'blogAdmin.excerptPlaceholder': 'Descripción breve para la lista...',
    'blogAdmin.fieldContent': 'Contenido * (Markdown compatible)',
    'blogAdmin.contentPlaceholder': 'Escribe tu artículo aquí...',
    'blogAdmin.fieldTags': 'Etiquetas (separadas por comas)',
    'blogAdmin.tagsPlaceholder': 'reparación, iphone, cayenne',
    'blogAdmin.fieldMeta': 'Meta descripción SEO',
    'blogAdmin.metaPlaceholder': 'Descripción para Google (160 car. máx.)',
    'blogAdmin.publishNow': 'Publicar inmediatamente',
    'blogAdmin.update': 'Actualizar',
    'blogAdmin.save': 'Guardar',
    'blogAdmin.loading': 'Cargando...',
    'blogAdmin.noArticles': 'Ningún artículo',
    'blogAdmin.noArticlesHint': 'Crea tu primer artículo para mejorar el SEO',
    'blogAdmin.statusPublished': 'PUBLICADO',
    'blogAdmin.statusDraft': 'BORRADOR',
    'blogAdmin.byAuthor': 'Por {{author}}',
    'blogAdmin.unpublish': 'Despublicar',
    'blogAdmin.publish': 'Publicar',
    'blogAdmin.loadingContent': 'Cargando contenido...',
    'blogAdmin.contentNotice1': 'Edita aquí el contenido mostrado en la página pública ',
    'blogAdmin.contentNotice2': '. Los cambios serán visibles inmediatamente.',
    'blogAdmin.blogHeader': 'Encabezado del blog',
    'blogAdmin.mainTitle': 'Título principal',
    'blogAdmin.accentWord': 'Palabra en color (acento)',
    'blogAdmin.description': 'Descripción',
    'blogAdmin.ctaSection': 'Llamada a la acción (CTA en los artículos)',
    'blogAdmin.ctaTitle': 'Título del CTA',
    'blogAdmin.ctaDescription': 'Descripción del CTA',
    'blogAdmin.footerSection': 'Pie de página',
    'blogAdmin.footerText': 'Texto del pie de página',
    'blogAdmin.hidePreview': 'Ocultar vista previa',
    'blogAdmin.livePreview': 'Vista previa en vivo',
    'blogAdmin.savedSuccess': '¡Guardado con éxito!',
    'blogAdmin.saving': 'Guardando...',
    'blogAdmin.saveContent': 'Guardar contenido',
    'blogAdmin.previewLabel': 'Vista previa de la página del blog',
    'businessCard.title': 'Tarjetas de visita',
    'businessCard.subtitle': 'Plantillas, edición e impresión A4 (10 tarjetas)',
    'businessCard.previewBtn': 'Vista previa',
    'businessCard.edit': 'Editar',
    'businessCard.printA4': 'Imprimir A4 (10 tarjetas)',
    'businessCard.chooseTemplate': 'Elegir una plantilla ({{count}} disponibles)',
    'businessCard.tplName.classic': 'Clásico',
    'businessCard.tplName.modern': 'Moderno',
    'businessCard.tplName.gradient': 'Degradado',
    'businessCard.tplName.minimal': 'Minimalista',
    'businessCard.tplName.gold': 'Oro Premium',
    'businessCard.tplName.ocean': 'Océano',
    'businessCard.tplName.forest': 'Bosque',
    'businessCard.tplName.sunset': 'Atardecer',
    'businessCard.tplName.corporate': 'Corporativo',
    'businessCard.tplName.pastel': 'Rosa Pastel',
    'businessCard.tplDesc.classic': 'Sobrio y profesional',
    'businessCard.tplDesc.modern': 'Depurado con acento cian',
    'businessCard.tplDesc.gradient': 'Fondo degradado vibrante',
    'businessCard.tplDesc.minimal': 'Blanco y nítido',
    'businessCard.tplDesc.gold': 'Negro y oro lujoso',
    'businessCard.tplDesc.ocean': 'Azul profundo relajante',
    'businessCard.tplDesc.forest': 'Verde natural elegante',
    'businessCard.tplDesc.sunset': 'Naranja cálido',
    'businessCard.tplDesc.corporate': 'Azul marino profesional',
    'businessCard.tplDesc.pastel': 'Suave y femenino',
    'businessCard.logoTransparent': 'Logotipo con fondo transparente',
    'businessCard.cardInfo': 'Información de la tarjeta',
    'businessCard.field.companyName': 'Nombre de la empresa',
    'businessCard.field.subtitle': 'Subtítulo / Actividad',
    'businessCard.field.ownerName': 'Nombre del responsable',
    'businessCard.field.ownerTitle': 'Cargo / Función',
    'businessCard.field.phone': 'Teléfono',
    'businessCard.field.email': 'Correo electrónico',
    'businessCard.field.address': 'Dirección',
    'businessCard.field.city': 'Ciudad / Código postal',
    'businessCard.field.website': 'Sitio web',
    'businessCard.field.siret': 'SIRET',
    'businessCard.reset': 'Restablecer',
    'businessCard.previewTitle': 'Vista previa — {{name}}',
    'businessCard.viewFront': 'Ver anverso',
    'businessCard.viewBack': 'Ver reverso',
    'businessCard.standardFormat': 'Formato estándar: 85 x 55 mm',
    'businessCard.allTemplates': 'Todas las plantillas',
    'businessCard.printTitle': 'Tarjetas de Visita',
    'businessCard.recto': 'ANVERSO',
    'businessCard.verso': 'REVERSO',
    'hub.title': 'Centro',
    'hub.refresh': 'Actualizar',
    'hub.kpiTicketsOpen': '{{n}} tickets abiertos',
    'hub.kpiFacturesToday': '{{n}} facturas del día ({{total}})',
    'hub.kpiDevisOpen': '{{n}} presupuestos abiertos',
    'hub.magasinDefaultName': 'Tienda 1',
    'hub.magasinBadgeTitle': 'Tienda actual (TPV) — {{name}}',
    'hub.counterViewDetailed': 'Vista detallada',
    'hub.counterViewCompact': 'Vista compacta',
    'hub.counterMagasinTitle': '{{name}} — {{tickets}} tickets · {{devis}} presupuestos · {{total}}',
    'hub.counterCompact': '{{tickets}}T·{{devis}}P·{{total}}',
    'hub.counterTickets': 'tickets',
    'hub.counterDevis': 'presupuestos',
    'hub.counterPerDay': '€/día',
    'hub.searchPlaceholder': 'Buscar una REF (REM0143, POS-..., DEV-00002), un cliente, un teléfono…',
    'hub.filterAll': 'Todos',
    'hub.filterToday': 'Hoy',
    'hub.filterOverdue': 'Atrasados',
    'hub.filterPaid': 'Pagados',
    'hub.filterUnpaid': 'No pagados',
    'hub.columnReparations': 'Reparaciones',
    'hub.columnFactures': 'Facturas',
    'hub.columnDevis': 'Presupuestos',
    'hub.seeAll': 'Ver todo',
    'hub.empty': 'Sin elementos',
    'hub.actionView': 'Ver',
    'hub.actionPrint': 'Imprimir',
    'hub.actionMail': 'Enviar por correo',
    'hub.actionMarkReady': 'Marcar como listo',
    'hub.walkinClient': 'Cliente ocasional',
    'hub.invoicedAs': '→ Facturado: {{ref}}',
    'hub.errorPrint': 'Error al imprimir',
    'hub.errorPopupBlocked': 'Permita las ventanas emergentes para imprimir.',
    'hub.statusWaiting': 'En espera',
    'hub.statusInProgress': 'En curso',
    'hub.statusReady': 'Listo',
    'hub.statusDelivered': 'Entregado',
    'hub.statusPaid': 'Pagada',
    'hub.statusInvoiced': 'Facturado',
    'hub.statusSent': 'Enviado',
    'hub.statusAccepted': 'Aceptado',
    'hub.statusCancelled': 'Cancelado',
    'hub.statusDone': 'Finalizado',
    'subscription.title': 'Mi suscripción',
    'subscription.subtitle': 'Gestiona tu plan y tu facturación',
    'subscription.currentPlan': 'Plan actual',
    'subscription.status': 'Estado',
    'subscription.statusActive': 'Activo',
    'subscription.statusTrial': 'Prueba gratuita',
    'subscription.monthlyPrice': 'Precio mensual',
    'subscription.perMonth': '/mes',
    'subscription.nextBilling': 'Próximo pago',
    'subscription.changePlan': 'Cambiar de plan',
    'subscription.redirecting': 'Redirigiendo...',
    'subscription.upgrade': 'Mejorar',
    'subscription.downgrade': 'Bajar de plan',
    'subscription.upgradeTitle': 'Mejora de plan',
    'subscription.downgradeTitle': 'Baja de plan',
    'subscription.newPlan': 'Nuevo plan',
    'subscription.newMonthlyPrice': 'Nuevo precio mensual',
    'subscription.upgradeDiffNow': 'Diferencia a pagar ahora',
    'subscription.changeFee': 'Cargo por cambio',
    'subscription.downgradeFeeNotice': 'Se aplica una tarifa fija de {{amount}} a cualquier baja de plan.',
    'subscription.cancel': 'Cancelar',
    'subscription.confirmWithAmount': 'Confirmar ({{amount}})',
    'subscription.toastChanged': '¡Tu plan se cambió correctamente!',
    'subscription.toastCancelled': 'El cambio de plan se canceló.',
    'subscription.errorPreview': 'Error durante la vista previa',
    'subscription.errorChange': 'Error al cambiar de plan',
    'subscription.featStartRepairs': 'Gestión de reparaciones',
    'subscription.featStartClients': 'Seguimiento de clientes',
    'subscription.featStartQuotesInvoices': 'Presupuestos y facturas',
    'subscription.featStartOnePos': '1 punto de venta',
    'subscription.featProAllStart': 'Todo el plan Start',
    'subscription.featProMultiUsers': 'Multiusuario',
    'subscription.featProAdvancedStats': 'Estadísticas avanzadas',
    'subscription.featProThreePos': '3 puntos de venta',
    'subscription.featProPrioritySupport': 'Soporte prioritario',
    'subscription.featSuperAllPro': 'Todo el plan Pro',
    'subscription.featSuperUnlimitedPos': 'Puntos de venta ilimitados',
    'subscription.featSuperCustomApi': 'API personalizada',
    'subscription.featSuperDedicatedSupport': 'Soporte dedicado 24/7',
    'subscription.featSuperWhiteLabel': 'Marca blanca',
    'terms.title': 'Condiciones generales de uso',
    'terms.edition': 'Junio de 2026',
    'terms.introBefore': 'Las presentes condiciones rigen el uso del sitio',
    'terms.introMiddle': ', del área de cliente, del chat de soporte y de los servicios de reparación ofrecidos por',
    'terms.introAfter': ', SASU, Cayena, Guayana Francesa.',
    'terms.acceptIntro': 'Al crear una cuenta o al contactarnos (sitio web, chat, WhatsApp), usted acepta estas condiciones, así como nuestra',
    'terms.privacyPolicy': 'política de privacidad',
    'terms.servicesTitle': 'Servicios',
    'terms.servicesBody': 'Reparación y venta de teléfonos, seguimiento posventa, presupuestos, pagos en línea cuando estén activados, asistencia por chat o WhatsApp Business.',
    'terms.pricingTitle': 'Tarifas',
    'terms.pricingBody': 'Los presupuestos y precios comunicados (tienda, chat, WhatsApp) son orientativos hasta su validación en el punto de venta.',
    'terms.dataTitle': 'Datos personales',
    'terms.dataBefore': 'Sus datos se tratan de conformidad con el RGPD. Solicitud de supresión:',
    'terms.dataAfter': 'o consulte la sección «Sus derechos» de la política de privacidad.',
    'terms.contactTitle': 'Contacto',
    'notifSettings.title': 'Notificaciones push',
    'notifSettings.intro': 'Recibe una alerta nativa (Windows / macOS / Android) en cuanto ocurre un evento importante en la tienda. Reservado al personal de R.E.Mobiles.',
    'notifSettings.statusUnsupported': 'No compatible (requiere iOS 16.4+)',
    'notifSettings.statusBlocked': 'Bloqueadas (permiso denegado)',
    'notifSettings.statusEnabled': 'Activadas en este navegador',
    'notifSettings.statusDisabled': 'No activadas',
    'notifSettings.activeCount': '{{count}} suscripción(es) activa(s)',
    'notifSettings.enableBtn': 'Activar notificaciones',
    'notifSettings.testBtn': 'Enviar notif. de prueba',
    'notifSettings.disableBtn': 'Desactivar',
    'notifSettings.iosHintPre': 'En iPhone, las notificaciones push web requieren',
    'notifSettings.iosHintPost': 'y la app instalada en la pantalla de inicio (PWA). Actualiza tu iPhone y vuelve a instalar la app.',
    'notifSettings.blockedHint': 'Permiso denegado. Abre la configuración del sitio en el navegador, permite las notificaciones para este dominio y recarga la página.',
    'notifSettings.categoriesTitle': 'Categorías',
    'notifSettings.categoriesHint': 'Desactiva lo que no quieras recibir. Se aplica de inmediato, para esta cuenta.',
    'notifSettings.catNewTicketLabel': 'Nuevo ticket de reparación',
    'notifSettings.catNewTicketDesc': 'Se registra un depósito en la tienda.',
    'notifSettings.catTicketReadyLabel': 'Ticket marcado como «Listo»',
    'notifSettings.catTicketReadyDesc': 'El técnico marca la reparación como lista. Acuérdate de avisar al cliente.',
    'notifSettings.catNewInvoiceLabel': 'Nueva factura POS',
    'notifSettings.catNewInvoiceDesc': 'Se acaba de cobrar una venta.',
    'notifSettings.catNewChatLabel': 'Nuevo mensaje en el chat',
    'notifSettings.catNewChatDesc': 'MD de staff, cliente o B2B.',
    'notifSettings.catDevisLabel': 'Presupuesto creado o aceptado',
    'notifSettings.catDevisDesc': 'Se genera un nuevo presupuesto o un cliente hace clic en Aceptar.',
    'notifSettings.accountLabel': 'Cuenta',
    'notifSettings.roleLabel': 'Rol',
    'notifSettings.totalSubsLabel': 'Suscripciones totales',
    'notifSettings.errPermDenied': 'Permiso denegado. Activa las notificaciones en la configuración del navegador.',
    'notifSettings.errPermNotGranted': 'Permiso no concedido.',
    'notifSettings.errVapidUnavailable': 'Clave VAPID no disponible en el servidor.',
    'notifSettings.infoEnabled': 'Notificaciones activadas en este navegador.',
    'notifSettings.errEnableFailed': 'Error al activar.',
    'notifSettings.infoDisabled': 'Notificaciones desactivadas en este navegador.',
    'notifSettings.errDisableFailed': 'Error al desactivar.',
    'notifSettings.errPrefsUpdate': 'Error al actualizar las preferencias.',
    'notifSettings.infoTestSent': 'Notificación de prueba enviada ({{sent}}/{{subs}}). Revisa el centro de notificaciones de tu SO.',
    'notifSettings.errNoneSent': 'No se envió ninguna notificación. Verifica que las notificaciones estén activadas en este navegador.',
    'notifSettings.errTestFailed': 'Error en la prueba.',
    'guyarepairLogin.subscriberSpace': 'Área de suscriptor',
    'guyarepairLogin.businessLoginTitle': 'Acceso empresa',
    'guyarepairLogin.businessLoginSubtitle': 'Accede a tu panel GUYAREPAIR',
    'guyarepairLogin.emailLabel': 'Correo electrónico',
    'guyarepairLogin.emailPlaceholder': 'tu@email.com',
    'guyarepairLogin.passwordLabel': 'Contraseña',
    'guyarepairLogin.passwordPlaceholder': 'Tu contraseña',
    'guyarepairLogin.loggingIn': 'Conectando...',
    'guyarepairLogin.loginButton': 'Iniciar sesión',
    'guyarepairLogin.twoFATitle': 'Verificación 2FA',
    'guyarepairLogin.twoFASubtitle': 'Introduce el código de tu aplicación de autenticación',
    'guyarepairLogin.otpLabel': 'Código de 6 dígitos',
    'guyarepairLogin.verifying': 'Verificando...',
    'guyarepairLogin.verifyButton': 'Verificar',
    'guyarepairLogin.backToLogin': 'Volver al inicio de sesión',
    'guyarepairLogin.notSubscribedYet': '¿Todavía no estás suscrito?',
    'guyarepairLogin.freeTrial': 'Prueba gratuita',
    'guyarepairLogin.secureConnection': 'Conexión segura',
    'guyarepairLogin.guyarepairHome': 'Inicio GUYAREPAIR',
    'guyarepairLogin.errInvalidCredentials': 'Credenciales incorrectas',
    'guyarepairLogin.err2FAInvalid': 'Código 2FA inválido',
    'analytics.period_today': 'Hoy',
    'analytics.period_7d': '7 días',
    'analytics.period_30d': '30 días',
    'analytics.period_90d': '90 días',
    'analytics.period_365d': '1 año',
    'analytics.alert_suspicious_found': '¡{{count}} IP(s) sospechosa(s) detectada(s)!',
    'analytics.alert_no_suspicious': 'No se detectó ninguna IP sospechosa.',
    'analytics.page_title': 'Analíticas — Visitas',
    'analytics.page_subtitle': 'Seguimiento de visitas en todos tus sitios',
    'analytics.refresh': 'Actualizar',
    'analytics.tab_dashboard': 'Panel',
    'analytics.tab_visits': 'Visitas',
    'analytics.tab_blocked': 'IP bloqueadas',
    'analytics.tab_alerts': 'Alertas de IP',
    'analytics.all_sites': 'Todos los sitios',
    'analytics.kpi_total_visits': 'Visitas totales',
    'analytics.kpi_unique_visitors': 'Visitantes únicos',
    'analytics.kpi_active_sites': 'Sitios activos',
    'analytics.kpi_countries': 'Países',
    'analytics.visits_per_day': 'Visitas por día',
    'analytics.by_site': 'Por sitio',
    'analytics.by_country': 'Por país',
    'analytics.top_pages': 'Páginas más visitadas',
    'analytics.visits_per_hour': 'Visitas por hora',
    'analytics.empty_no_visits': 'No hay visitas registradas para este período',
    'analytics.empty_install_script': 'El script de seguimiento debe instalarse en tus sitios',
    'analytics.search_placeholder': 'Buscar por IP, página, país...',
    'analytics.col_date': 'Fecha',
    'analytics.col_site': 'Sitio',
    'analytics.col_page': 'Página',
    'analytics.col_country_city': 'País / Ciudad',
    'analytics.col_screen': 'Pantalla',
    'analytics.col_action': 'Acción',
    'analytics.no_visits': 'Sin visitas',
    'analytics.blocked_inline': '(BLOQUEADA)',
    'analytics.unblock': 'Desbloquear',
    'analytics.block': 'Bloquear',
    'analytics.visits_count': '{{count}} visitas',
    'analytics.blocked_ips_title': 'Direcciones IP bloqueadas',
    'analytics.active_count': '{{count}} activa(s)',
    'analytics.col_status': 'Estado',
    'analytics.col_reason': 'Motivo',
    'analytics.col_blocked_by': 'Bloqueada por',
    'analytics.no_blocked_ips': 'Ninguna IP bloqueada',
    'analytics.status_blocked': 'BLOQUEADA',
    'analytics.status_inactive': 'INACTIVA',
    'analytics.reblock': 'Volver a bloquear',
    'analytics.alert_config_title': 'Configuración de alertas',
    'analytics.checking': 'Verificando...',
    'analytics.check_now': 'Verificar ahora',
    'analytics.saving': 'Guardando...',
    'analytics.save': 'Guardar',
    'analytics.alerts_enabled': 'Alertas activadas',
    'analytics.alerts_enabled_desc': 'Supervisa las IP sospechosas cada 15 min',
    'analytics.threshold_label': 'Umbral (visitas/hora)',
    'analytics.alert_email_label': 'Correo de alerta',
    'analytics.autoblock': 'Bloqueo automático',
    'analytics.autoblock_desc': 'Bloquear automáticamente las IP que superen el umbral',
    'analytics.alert_history_title': 'Historial de alertas',
    'analytics.alerts_count': '{{count}} alerta(s)',
    'analytics.no_alerts': 'No se activó ninguna alerta',
    'analytics.col_visits_per_hour': 'Visitas/h',
    'analytics.col_sites': 'Sitios',
    'analytics.col_autoblocked': 'Bloqueada automáticamente',
    'analytics.col_email': 'Correo',
    'analytics.yes': 'SÍ',
    'analytics.no': 'NO',
    'analytics.sent': 'ENVIADO',
    'analytics.confirm_block_title': '¿Bloquear esta IP?',
    'analytics.confirm_block_ip_prefix': 'La IP ',
    'analytics.confirm_block_ip_suffix': ' será bloqueada en todos los sitios',
    'analytics.block_reason_placeholder': 'Motivo del bloqueo (opcional)...',
    'analytics.cancel': 'Cancelar',
    'analytics.blocking': 'Bloqueando...',
    'analytics.confirm_block': 'Confirmar bloqueo',
    'guyarepairLanding.navTarifs': 'Precios',
    'guyarepairLanding.navAnnuaire': 'Directorio',
    'guyarepairLanding.navMaReparation': 'Mi reparación',
    'guyarepairLanding.navConnexion': 'Iniciar sesión',
    'guyarepairLanding.navEssaiGratuit': 'Prueba gratuita',
    'guyarepairLanding.heroBadge': 'Plataforma SaaS de gestión de reparaciones',
    'guyarepairLanding.heroTitleLine1': 'Gestione su taller de',
    'guyarepairLanding.heroTitleLine2': 'reparación',
    'guyarepairLanding.heroTitleHighlight': 'fácilmente',
    'guyarepairLanding.heroSubtitle': 'GUYAREPAIR es la solución todo en uno para talleres de reparación. TPV, seguimiento de reparaciones, gestión de stock, facturación y fidelización de clientes: todo en una sola plataforma.',
    'guyarepairLanding.heroCtaStart': 'Empezar gratis',
    'guyarepairLanding.heroCtaPricing': 'Ver precios',
    'guyarepairLanding.repairLookupTitle': 'Encontrar mi reparación',
    'guyarepairLanding.repairLookupSubtitle': 'Introduzca su referencia de reparación para seguir su progreso',
    'guyarepairLanding.repairLookupPlaceholder': 'Ej.: TFX0001, MBR0012...',
    'guyarepairLanding.rechercher': 'Buscar',
    'guyarepairLanding.repairErrorDefault': 'Error durante la búsqueda',
    'guyarepairLanding.repairFoundAt': 'Reparación encontrada en',
    'guyarepairLanding.statutTermine': 'Terminado',
    'guyarepairLanding.statutEnCours': 'En curso',
    'guyarepairLanding.statutEnAttente': 'Pendiente',
    'guyarepairLanding.labelReference': 'Referencia',
    'guyarepairLanding.labelAppareil': 'Dispositivo',
    'guyarepairLanding.labelProbleme': 'Problema',
    'guyarepairLanding.voirPageDe': 'Ver la página de {{nom}}',
    'guyarepairLanding.directoryTitle': 'Encuentre su reparador',
    'guyarepairLanding.directorySubtitle': 'Busque una tienda de reparación asociada a GUYAREPAIR',
    'guyarepairLanding.searchPlaceholder': 'Nombre de la tienda, ciudad...',
    'guyarepairLanding.resultats': '{{count}} resultado(s)',
    'guyarepairLanding.featuresTitle': 'Todo lo que necesita',
    'guyarepairLanding.featuresSubtitle': 'Un conjunto completo de herramientas para su taller',
    'guyarepairLanding.feature1Title': 'Gestión de reparaciones',
    'guyarepairLanding.feature1Desc': 'Seguimiento completo de cada reparación, del diagnóstico a la entrega',
    'guyarepairLanding.feature2Title': 'Punto de Venta (TPV)',
    'guyarepairLanding.feature2Desc': 'Cobros, cálculo de precios, gestión de caja integrada',
    'guyarepairLanding.feature3Title': 'Stock e inventario',
    'guyarepairLanding.feature3Desc': 'Movimientos de stock, alertas, proveedores y pedidos',
    'guyarepairLanding.feature4Title': 'Clientes y fidelización',
    'guyarepairLanding.feature4Desc': 'Base de clientes, programa de fidelización con recompensas',
    'guyarepairLanding.feature5Title': 'Presupuestos y facturas',
    'guyarepairLanding.feature5Desc': 'Creación rápida de presupuestos, conversión en factura, envío por correo electrónico',
    'guyarepairLanding.feature6Title': 'Multitienda',
    'guyarepairLanding.feature6Desc': 'Gestione varias tiendas desde un solo panel',
    'guyarepairLanding.pricingTitle': 'Precios simples y transparentes',
    'guyarepairLanding.pricingSubtitle': 'Elija el plan adecuado para su negocio',
    'guyarepairLanding.popular': 'POPULAR',
    'guyarepairLanding.perMonth': 'EUR/mes',
    'guyarepairLanding.commencer': 'Empezar',
    'guyarepairLanding.copyright': '© {{year}} REMCOMPANY. Todos los derechos reservados.',
    'guyarepairLanding.trademarkNotice': 'GUYAREPAIR es la marca comercial del servicio.',
    'guyarepairLanding.passwordTooShort': 'La contraseña debe tener al menos 6 caracteres',
    'guyarepairLanding.registerErrorDefault': 'Error durante el registro',
    'guyarepairLanding.registerSuccessTitle': '¡Registro exitoso!',
    'guyarepairLanding.successAccountCreated': 'Su cuenta se ha creado con una',
    'guyarepairLanding.successTrial': 'prueba gratuita de 5 días',
    'guyarepairLanding.successLoginHint': 'Inicie sesión para configurar su espacio. Se ha enviado un correo de bienvenida.',
    'guyarepairLanding.seConnecter': 'Iniciar sesión',
    'guyarepairLanding.createAccountTitle': 'Cree su cuenta',
    'guyarepairLanding.planLine': 'Plan {{nom}} — {{prix}} EUR/mes',
    'guyarepairLanding.planLabel': 'Plan',
    'guyarepairLanding.companyNameLabel': 'Nombre de la empresa',
    'guyarepairLanding.contactNameLabel': 'Nombre del contacto',
    'guyarepairLanding.phoneLabel': 'Teléfono',
    'guyarepairLanding.emailLabel': 'Correo electrónico',
    'guyarepairLanding.passwordLabel': 'Contraseña',
    'guyarepairLanding.cityLabel': 'Ciudad',
    'guyarepairLanding.addressLabel': 'Dirección',
    'guyarepairLanding.directoryToggle': 'Aparecer en el directorio público de GUYAREPAIR',
    'guyarepairLanding.creating': 'Creando...',
    'guyarepairLanding.createMyAccount': 'Crear mi cuenta',
    'guyarepairLanding.alreadyRegistered': '¿Ya está registrado?',
    'alertsConfig.saved': 'Configuración de alertas guardada',
    'alertsConfig.error': 'Error',
    'alertsConfig.title': 'Alertas automáticas',
    'alertsConfig.subtitle': 'Configure las alertas automáticas para su empresa. Recibirá un correo diario si se cumplen las condiciones.',
    'alertsConfig.emailAlertsLabel': 'Alertas por correo electrónico',
    'alertsConfig.emailAlertsDesc': 'Activar las alertas automáticas por correo electrónico (reparaciones pendientes, falta de existencias)',
    'alertsConfig.repairAlertsTitle': 'Alertas de reparaciones pendientes',
    'alertsConfig.repairAlertsDesc': 'Reciba un correo cuando una reparación lleve pendiente más de X días.',
    'alertsConfig.delayLabel': 'Plazo (días)',
    'alertsConfig.daysShort': '{{n}}d',
    'alertsConfig.stockAlertsTitle': 'Alertas de stock',
    'alertsConfig.stockAlertsDesc': 'Reciba un correo cuando los artículos estén agotados o por debajo de un umbral.',
    'alertsConfig.lowStockThresholdLabel': 'Umbral de stock bajo',
    'alertsConfig.clientNotifLabel': 'Notificaciones a clientes',
    'alertsConfig.clientNotifDesc': 'Enviar un correo al cliente cuando cambie el estado de su reparación (terminada, en curso, etc.)',
    'alertsConfig.emailSenderInfo': 'El correo se enviará desde la dirección que haya configurado, o desde GUYAREPAIR de forma predeterminada.',
    'alertsConfig.saving': 'Guardando...',
    'alertsConfig.save': 'Guardar',
    'companyAnalytics.title': 'Analíticas',
    'companyAnalytics.subtitle': 'Visión general del rendimiento de tu empresa',
    'companyAnalytics.loadError': 'Error al cargar',
    'companyAnalytics.kpiRepairsToday': 'Reparaciones hoy',
    'companyAnalytics.kpiThisWeek': '{{count}} esta semana',
    'companyAnalytics.kpiRevenueToday': 'Ingresos hoy',
    'companyAnalytics.kpiThisMonthAmount': '{{amount}} este mes',
    'companyAnalytics.kpiClients': 'Clientes',
    'companyAnalytics.kpiNewThisMonth': '{{count}} nuevos este mes',
    'companyAnalytics.kpiAvgTime': 'Tiempo medio',
    'companyAnalytics.daysShort': '{{count}}d',
    'companyAnalytics.kpiPerRepair': 'por reparación',
    'companyAnalytics.statTotalRepairs': 'Total reparaciones',
    'companyAnalytics.statActive': 'Activas',
    'companyAnalytics.statCompleted': 'Completadas',
    'companyAnalytics.statStockItems': 'Artículos en stock',
    'companyAnalytics.statOutOfStock': 'Sin stock',
    'companyAnalytics.repairsByStore': 'Reparaciones en curso por tienda',
    'companyAnalytics.repairsM1Explicit': '{{count}} reparaciones M1 explícitas',
    'companyAnalytics.repairsLegacy': '{{count}} reparaciones heredadas (pre-M2)',
    'companyAnalytics.totalShown': 'Total mostrado: {{count}}',
    'companyAnalytics.repairsM2': '{{count}} reparaciones M2',
    'companyAnalytics.repairsTrend14Days': 'Reparaciones (últimos 14 días)',
    'companyAnalytics.statusDistribution': 'Distribución de estados',
    'companyAnalytics.noRepairs': 'Sin reparaciones',
    'companyAnalytics.revenue': 'Ingresos',
    'companyAnalytics.revToday': 'Hoy',
    'companyAnalytics.revThisWeek': 'Esta semana',
    'companyAnalytics.revThisMonth': 'Este mes',
    'companyAnalytics.revTotal': 'Total',
    'companyAnalytics.statusPending': 'En espera',
    'companyAnalytics.statusInProgress': 'En curso',
    'companyAnalytics.statusCompleted': 'Terminado',
    'companyAnalytics.statusDelivered': 'Entregado',
    'companyAnalytics.statusCancelled': 'Cancelado',
    'staffCommissions.title': 'Mis comisiones',
    'staffCommissions.pdfDownloadError': 'Error al descargar el PDF',
    'staffCommissions.downloadMonthSheet': 'Descargar mi ficha del mes:',
    'staffCommissions.generating': 'Generando…',
    'staffCommissions.downloadPdf': 'Descargar PDF',
    'staffCommissions.toReceive': 'Por recibir',
    'staffCommissions.alreadyReceived': 'Ya recibido',
    'staffCommissions.totalCumulative': 'Total acumulado',
    'staffCommissions.detailByType': 'Detalle por tipo',
    'staffCommissions.toPay': 'Por pagar: {{amount}}',
    'staffCommissions.paidDetail': 'Pagado: {{amount}}',
    'staffCommissions.noCommissionYet': 'Aún no hay comisiones',
    'staffCommissions.filterAll': 'Todas',
    'staffCommissions.filterPending': 'Por pagar',
    'staffCommissions.filterPaid': 'Pagadas',
    'staffCommissions.filterCancelled': 'Anuladas',
    'staffCommissions.colDate': 'Fecha',
    'staffCommissions.colType': 'Tipo',
    'staffCommissions.colTransaction': 'Transacción',
    'staffCommissions.colAmountTtc': 'Importe con IVA',
    'staffCommissions.colCommission': 'Comisión',
    'staffCommissions.colStatus': 'Estado',
    'staffCommissions.noCommission': 'Sin comisiones',
    'staffCommissions.month1': 'Enero',
    'staffCommissions.month2': 'Febrero',
    'staffCommissions.month3': 'Marzo',
    'staffCommissions.month4': 'Abril',
    'staffCommissions.month5': 'Mayo',
    'staffCommissions.month6': 'Junio',
    'staffCommissions.month7': 'Julio',
    'staffCommissions.month8': 'Agosto',
    'staffCommissions.month9': 'Septiembre',
    'staffCommissions.month10': 'Octubre',
    'staffCommissions.month11': 'Noviembre',
    'staffCommissions.month12': 'Diciembre',
    'staffCommissions.typeVentes': 'Venta TPV',
    'staffCommissions.typeCommandes': 'Pedido',
    'staffCommissions.typeAcomptes': 'Anticipo',
    'staffCommissions.typeReparations': 'Reparación',
    'staffCommissions.typeFactures': 'Factura',
    'staffCommissions.typeDevis': 'Presupuesto',
    'staffCommissions.typeB2b': 'B2B',
    'staffCommissions.typeDeplacement': 'Desplazamiento',
    'labelConfig.title': 'Configuración de etiquetas',
    'labelConfig.subtitle': 'Ajuste los márgenes y las dimensiones para su impresora',
    'labelConfig.reset': 'Valores por defecto',
    'labelConfig.save': 'Guardar',
    'labelConfig.saving': 'Guardando...',
    'labelConfig.saved': 'Guardado',
    'labelConfig.save_error': 'Error al guardar: {{error}}',
    'labelConfig.global_dimensions': 'Dimensiones generales',
    'labelConfig.label_width': 'Ancho de etiqueta',
    'labelConfig.label_height': 'Alto de etiqueta',
    'labelConfig.cols': 'Columnas',
    'labelConfig.rows': 'Filas',
    'labelConfig.margins_spacing': 'Márgenes y espaciado',
    'labelConfig.left_margin': 'Margen izquierdo',
    'labelConfig.top_margin': 'Margen superior',
    'labelConfig.h_spacing': 'Espaciado H',
    'labelConfig.v_spacing': 'Espaciado V',
    'labelConfig.col_offset_title': 'Desplazamiento por columna',
    'labelConfig.cols_count': '({{count}} columnas)',
    'labelConfig.col_n': 'Col {{n}}',
    'labelConfig.col_offset_hint': 'Valores positivos = desplazamiento a la derecha. Negativos = a la izquierda.',
    'labelConfig.row_offset_title': 'Desplazamiento por fila',
    'labelConfig.rows_count': '({{count}} filas)',
    'labelConfig.row_n': 'Fila {{n}}',
    'labelConfig.row_offset_hint': 'Valores positivos = desplazamiento hacia arriba. Negativos = hacia abajo.',
    'labelConfig.preview_title': 'Vista previa hoja A4',
    'labelConfig.preview_count': '{{cols}} x {{rows}} = {{total}} etiquetas/hoja',
    'labelConfig.preview_dims': '{{width}} x {{height}} mm',
    'paymentConfig.title': 'Configuración de pagos',
    'paymentConfig.statusActiveTitle': 'Pagos en línea activos',
    'paymentConfig.providerLabel': 'Proveedor: {{name}}',
    'paymentConfig.statusInactiveTitle': 'Pagos en línea desactivados',
    'paymentConfig.statusInactiveDesc': 'Configure un proveedor para aceptar pagos en línea. Solo están disponibles los pagos fuera de línea (efectivo, tarjeta en tienda).',
    'paymentConfig.chooseProvider': 'Elija su proveedor de pago:',
    'paymentConfig.apiKeysTitle': 'Claves API de {{name}}',
    'paymentConfig.savedPlaceholder': 'Guardada: {{value}}',
    'paymentConfig.save': 'Guardar',
    'paymentConfig.testConnection': 'Probar la conexión',
    'paymentConfig.infoTitle': 'Información importante',
    'paymentConfig.info1': 'Los pagos en línea se depositan directamente en su cuenta de comerciante.',
    'paymentConfig.info2': 'Sus claves API están cifradas y almacenadas de forma segura.',
    'paymentConfig.info3': 'Sin una configuración válida, solo están disponibles los pagos fuera de línea.',
    'paymentConfig.info4': 'Cada empresa gestiona sus propias claves de forma independiente.',
    'paymentConfig.saveError': 'Error al guardar',
    'paymentConfig.testError': 'Error de prueba',
    'paymentConfig.disableConfirm': '¿Desactivar los pagos en línea?',
    'paymentConfig.stripeDesc': 'Pagos con tarjeta, Apple Pay, Google Pay',
    'paymentConfig.sumupDesc': 'Terminal de pago POS V2 + pagos en línea (merchant_code, client_id/secret)',
    'paymentConfig.fieldPublicKey': 'Clave pública (pk_...)',
    'paymentConfig.fieldSecretKey': 'Clave secreta (sk_...)',
    'paymentConfig.fieldWebhookSecret': 'Secreto del webhook (whsec_...)',
    'paymentConfig.fieldApiKey': 'Clave API',
    'paymentConfig.fieldMerchantCode': 'Código de comerciante',
    'paymentConfig.fieldClientId': 'Client ID',
    'paymentConfig.fieldClientSecret': 'Client Secret',
    'loyaltyAdmin.title': 'Programa de Fidelización',
    'loyaltyAdmin.subtitle': 'Seguimiento de puntos y recompensas de clientes',
    'loyaltyAdmin.refresh': 'Actualizar',
    'loyaltyAdmin.kpiMembers': 'Miembros',
    'loyaltyAdmin.kpiPendingRewards': 'Recompensas pendientes',
    'loyaltyAdmin.kpiRedeemed': 'Recompensas canjeadas',
    'loyaltyAdmin.kpiThreshold': 'Umbral de recompensa',
    'loyaltyAdmin.purchasesSuffix': 'compras',
    'loyaltyAdmin.rewardRule': '-{{pos}}% POS / -{{repair}}% reparación',
    'loyaltyAdmin.topClients': 'Principales clientes fieles',
    'loyaltyAdmin.clientFallback': 'Cliente',
    'loyaltyAdmin.flashOffers': 'Ofertas Flash',
    'loyaltyAdmin.newOffer': 'Nueva oferta',
    'loyaltyAdmin.createFlashOffer': 'Crear una oferta flash',
    'loyaltyAdmin.offerTitlePlaceholder': 'Título de la oferta (ej.: Weekend Special)',
    'loyaltyAdmin.offerDescPlaceholder': 'Descripción (ej.: Reparación de pantalla a precio reducido)',
    'loyaltyAdmin.discountLabel': 'Descuento (%)',
    'loyaltyAdmin.endDateLabel': 'Fecha de fin',
    'loyaltyAdmin.targetLevelsLabel': 'Niveles objetivo',
    'loyaltyAdmin.creating': 'Creando...',
    'loyaltyAdmin.createOffer': 'Crear oferta',
    'loyaltyAdmin.noOffers': 'No se ha creado ninguna oferta flash',
    'loyaltyAdmin.offerMeta': 'Objetivos: {{levels}} | Correos: {{emails}}',
    'loyaltyAdmin.offerEnd': ' | Fin: {{date}}',
    'loyaltyAdmin.deactivate': 'Desactivar',
    'loyaltyAdmin.activate': 'Activar',
    'loyaltyAdmin.sendByEmail': 'Enviar por correo',
    'loyaltyAdmin.delete': 'Eliminar',
    'loyaltyAdmin.allMembers': 'Todos los miembros ({{count}})',
    'loyaltyAdmin.searchPlaceholder': 'Buscar...',
    'loyaltyAdmin.colClient': 'Cliente',
    'loyaltyAdmin.colPhone': 'Teléfono',
    'loyaltyAdmin.colPurchases': 'Compras',
    'loyaltyAdmin.colPoints': 'Puntos',
    'loyaltyAdmin.colTotalSpent': 'Total gastado',
    'loyaltyAdmin.colStatus': 'Estado',
    'loyaltyAdmin.colRewards': 'Recompensas',
    'loyaltyAdmin.noMembers': 'Sin miembros',
    'loyaltyAdmin.rewardAvailable': 'Recompensa disponible',
    'loyaltyAdmin.purchasesRemaining': '{{count}} compras restantes',
    'loyaltyAdmin.pageOf': 'Página {{page}} / {{total}}',
    'loyaltyAdmin.confirmDeleteOffer': '¿Eliminar esta oferta?',
    'loyaltyAdmin.emailsSent': 'Correos enviados',
    'loyaltyAdmin.levelBronze': 'Bronce',
    'loyaltyAdmin.levelArgent': 'Plata',
    'loyaltyAdmin.levelOr': 'Oro',
    'emailConfig.pageTitle': 'Configuración de correo',
    'emailConfig.pageSubtitle': 'Configura el servidor SMTP para el envío de facturas, presupuestos y notificaciones por correo.',
    'emailConfig.smtpSection': 'Servidor SMTP',
    'emailConfig.fieldHost': 'Host SMTP',
    'emailConfig.fieldPort': 'Puerto',
    'emailConfig.fieldUser': 'Usuario SMTP (correo)',
    'emailConfig.fieldPassword': 'Contraseña del correo',
    'emailConfig.passwordPlaceholderExisting': '•••••••• (deja vacío para conservar)',
    'emailConfig.passwordPlaceholderNew': 'Contraseña del correo Hostinger',
    'emailConfig.useSsl': 'Usar SSL/TLS (recomendado en el puerto 465)',
    'emailConfig.enableEmails': 'Activar el envío de correos',
    'emailConfig.tipTitle': 'Consejo de Hostinger:',
    'emailConfig.tipBody': 'la contraseña del correo es diferente de la contraseña de hPanel. Puedes verificarla o restablecerla en hPanel → Correos → Cuentas de correo → Administrar.',
    'emailConfig.senderSection': 'Remitente',
    'emailConfig.fieldSenderName': 'Nombre del remitente',
    'emailConfig.fieldSenderEmail': 'Correo del remitente',
    'emailConfig.saving': 'Guardando…',
    'emailConfig.save': 'Guardar',
    'emailConfig.testing': 'Enviando…',
    'emailConfig.testConnection': 'Probar la conexión',
    'emailConfig.disable': 'Desactivar',
    'emailConfig.loadError': 'Error de carga (HTTP {{status}})',
    'emailConfig.saveSuccess': 'Configuración guardada. Ahora puedes hacer clic en «Probar la conexión».',
    'emailConfig.saveErrorFallback': 'Error al guardar',
    'emailConfig.testSuccess': 'Correo de prueba enviado. Revisa tu bandeja de entrada.',
    'emailConfig.testErrorFallback': 'Falló la prueba SMTP. Verifica la contraseña del correo Hostinger (diferente de la contraseña de hPanel).',
    'emailConfig.disableConfirm': '¿Desactivar la configuración personalizada? El servidor volverá a la configuración .env predeterminada.',
    'emailConfig.disableSuccess': 'Configuración personalizada desactivada.',
    'emailConfig.disableErrorFallback': 'Error al desactivar',
    'promosCalendar.title': 'Calendario de promociones',
    'promosCalendar.subtitle': 'Promociones programadas por día',
    'promosCalendar.empty': 'No hay promociones programadas para este mes.',
    'adminIntegrations.supplierCredentials': 'Credenciales de proveedores (Mobilax · Jens · LCD-Phone)',
    'adminIntegrations.generateStockPhotos': 'Generar fotos de stock (IA) — M1 / M2',
    'adminIntegrations.stockCategoryAudit': 'Auditoría de categorías de stock — teléfono / IMEI / accesorios',
    'printerTokens.title': 'Tokens del agente de impresión',
    'printerTokens.desc': 'Gestión de los tokens que usa el agente de Windows para autenticarse con el backend. Un token por equipo (recomendado) o un token compartido para instalaciones pequeñas.',
    'printerTokens.newBtn': 'Nuevo token',
    'printerTokens.includeRevoked': 'Incluir tokens revocados',
    'printerTokens.refresh': 'Actualizar',
    'printerTokens.loading': 'Cargando…',
    'printerTokens.emptyPre': 'Ningún token. Haz clic en',
    'printerTokens.emptyPost': 'para crear uno.',
    'printerTokens.colLabel': 'Etiqueta',
    'printerTokens.colType': 'Tipo',
    'printerTokens.colPreview': 'Vista previa',
    'printerTokens.colCreated': 'Creado el',
    'printerTokens.colLastUsed': 'Último uso',
    'printerTokens.colStatus': 'Estado',
    'printerTokens.colActions': 'Acciones',
    'printerTokens.typeShared': 'Compartido',
    'printerTokens.typePersonal': 'Personal',
    'printerTokens.createdBy': 'por {{user}}',
    'printerTokens.statusRevoked': 'Revocado',
    'printerTokens.statusActive': 'Activo',
    'printerTokens.revoke': 'Revocar',
    'printerTokens.securityTitle': 'Seguridad',
    'printerTokens.securityHashPre': 'Los tokens se almacenan como hash (SHA-256). El token completo',
    'printerTokens.securityHashEmph': 'nunca se vuelve a mostrar',
    'printerTokens.securityHashPost': 'después de su creación. Si lo pierdes, revócalo y crea uno nuevo.',
    'printerTokens.securityAudit': 'Toda creación y revocación queda registrada en el registro de auditoría de administrador.',
    'printerTokens.createTitle': 'Nuevo token de agente',
    'printerTokens.createLabelField': 'Etiqueta (p. ej. PC Caja, Portátil de Carlos)',
    'printerTokens.createLabelPlaceholder': 'PC Caja',
    'printerTokens.createSharedLabel': 'Token compartido (utilizable por varios equipos)',
    'printerTokens.createSharedHint': 'Solo un token compartido activo a la vez. Por seguridad, es preferible un token por equipo.',
    'printerTokens.cancel': 'Cancelar',
    'printerTokens.create': 'Crear',
    'printerTokens.revealTitle': 'Token creado — cópialo ahora',
    'printerTokens.revealLabelPrefix': 'Etiqueta:',
    'printerTokens.revealConfigPre': 'Configura tu agente de Windows con este token en el encabezado',
    'printerTokens.revealConfigPost': '.',
    'printerTokens.copied': 'Copiado',
    'printerTokens.copy': 'Copiar',
    'printerTokens.revealClose': 'He guardado el token',
    'printerTokens.revokeTitle': '¿Revocar este token?',
    'printerTokens.revokeMsgPre': 'El token',
    'printerTokens.revokeMsgPost': 'ya no podrá autenticar ningún agente. Esta operación se conserva en el registro y no elimina el token (puedes mostrarlo marcando «Incluir tokens revocados»).',
    'printerTokens.actionError': 'Error: {{detail}}',
    'servicePrices.pageTitle': 'Tarifas de reparación',
    'servicePrices.pageSubtitle': 'Gestiona los precios y el contenido de la página pública',
    'servicePrices.viewPublicPage': 'Ver página pública',
    'servicePrices.add': 'Añadir',
    'servicePrices.tabPrices': 'Tarifas',
    'servicePrices.tabContent': 'Contenido de la página',
    'servicePrices.editPriceTitle': 'Editar tarifa',
    'servicePrices.newPriceTitle': 'Nueva tarifa',
    'servicePrices.brand': 'Marca *',
    'servicePrices.choose': 'Elegir...',
    'servicePrices.model': 'Modelo',
    'servicePrices.modelPlaceholder': 'ej.: iPhone 14 Pro',
    'servicePrices.repairType': 'Tipo de reparación *',
    'servicePrices.delay': 'Plazo',
    'servicePrices.delayPlaceholder': 'ej.: 30 min',
    'servicePrices.priceMin': 'Precio mín. (EUR)',
    'servicePrices.priceMax': 'Precio máx. (EUR)',
    'servicePrices.order': 'Orden',
    'servicePrices.visiblePublic': 'Visible al público',
    'servicePrices.btnUpdate': 'Modificar',
    'servicePrices.btnSave': 'Guardar',
    'servicePrices.loading': 'Cargando...',
    'servicePrices.noPrices': 'Ninguna tarifa registrada',
    'servicePrices.noPricesHint': 'Añade tus primeras tarifas para mostrarlas en la página pública',
    'servicePrices.colRepair': 'Reparación',
    'servicePrices.colPrice': 'Precio',
    'servicePrices.colVisible': 'Visible',
    'servicePrices.colActions': 'Acciones',
    'servicePrices.allModels': 'Todos los modelos',
    'servicePrices.contentLoading': 'Cargando el contenido...',
    'servicePrices.contentBannerPre': 'Modifica aquí el contenido mostrado en la página pública',
    'servicePrices.contentBannerPost': '. Los cambios se verán inmediatamente después de guardar.',
    'servicePrices.headerSection': 'Encabezado de la página',
    'servicePrices.mainTitle': 'Título principal',
    'servicePrices.accentWord': 'Palabra en color (acento)',
    'servicePrices.seoDescription': 'Descripción SEO',
    'servicePrices.contactInfo': 'Información de contacto',
    'servicePrices.phone': 'Teléfono',
    'servicePrices.phoneDisplay': 'Tel. mostrado',
    'servicePrices.whatsappLabel': 'WhatsApp (con prefijo)',
    'servicePrices.address': 'Dirección',
    'servicePrices.hours': 'Horario',
    'servicePrices.trustBadges': 'Insignias de confianza',
    'servicePrices.addShort': '+ Añadir',
    'servicePrices.titleField': 'Título',
    'servicePrices.description': 'Descripción',
    'servicePrices.faqTitle': 'Preguntas frecuentes (FAQ)',
    'servicePrices.question': 'Pregunta',
    'servicePrices.answer': 'Respuesta',
    'servicePrices.ctaSection': 'Sección de llamada a la acción (CTA)',
    'servicePrices.ctaTitle': 'Título del CTA',
    'servicePrices.ctaDescription': 'Descripción del CTA',
    'servicePrices.footer': 'Pie de página',
    'servicePrices.line1': 'Línea 1',
    'servicePrices.line2': 'Línea 2',
    'servicePrices.hidePreview': 'Ocultar vista previa',
    'servicePrices.livePreview': 'Vista previa en vivo',
    'servicePrices.savedSuccess': '¡Guardado con éxito!',
    'servicePrices.saving': 'Guardando...',
    'servicePrices.saveContent': 'Guardar contenido',
    'servicePrices.previewLabel': 'Vista previa de la página pública',
    'servicePrices.faqShort': 'FAQ',
    'servicePrices.confirmDelete': '¿Eliminar esta tarifa?',
    'servicePrices.repairTypes.ecran': 'Pantalla',
    'servicePrices.repairTypes.batterie': 'Batería',
    'servicePrices.repairTypes.connecteurCharge': 'Conector de carga',
    'servicePrices.repairTypes.cameraArriere': 'Cámara trasera',
    'servicePrices.repairTypes.cameraAvant': 'Cámara frontal',
    'servicePrices.repairTypes.hautParleur': 'Altavoz',
    'servicePrices.repairTypes.micro': 'Micrófono',
    'servicePrices.repairTypes.boutonPower': 'Botón de encendido',
    'servicePrices.repairTypes.boutonVolume': 'Botón de volumen',
    'servicePrices.repairTypes.vitreArriere': 'Cristal trasero',
    'servicePrices.repairTypes.nappeFaceId': 'Cable flex Face ID',
    'servicePrices.repairTypes.carteMere': 'Placa base',
    'servicePrices.repairTypes.diagnostique': 'Diagnóstico',
    'servicePrices.repairTypes.desoxydation': 'Desoxidación',
    'servicePrices.repairTypes.autre': 'Otro',
    'companySettings.toast.loadError': 'Error al cargar los ajustes',
    'companySettings.toast.saveSuccess': 'Ajustes guardados correctamente',
    'companySettings.toast.saveError': 'Error al guardar',
    'companySettings.toast.notImage': 'El archivo debe ser una imagen',
    'companySettings.toast.tooLarge': 'El archivo no debe superar los 5 MB',
    'companySettings.toast.logoSuccess': 'Logotipo actualizado correctamente',
    'companySettings.toast.logoError': 'Error al subir el logotipo',
    'companySettings.toast.previewError': 'Error al generar la vista previa',
    'companySettings.tabs.info': 'Información',
    'companySettings.tabs.documents': 'Documentos (Facturas, Presupuestos, Pedidos)',
    'companySettings.tabs.payment': 'Pago',
    'companySettings.tabs.logo': 'Logotipo',
    'companySettings.tabs.preview': 'Vista previa PDF',
    'companySettings.tabs.security': 'Seguridad',
    'companySettings.title': 'Ajustes de la empresa',
    'companySettings.subtitle': 'Configure la información de su empresa y sus documentos',
    'companySettings.save': 'Guardar',
    'companySettings.info.sectionTitle': 'Información de la empresa',
    'companySettings.info.companyNameLabel': 'Nombre de la empresa',
    'companySettings.info.companyNamePlaceholder': 'Ej.: Mi Empresa S.L.',
    'companySettings.info.legalFormLabel': 'Forma jurídica',
    'companySettings.info.legalFormPlaceholder': 'Ej.: S.A., S.L., autónomo...',
    'companySettings.info.capitalLabel': 'Capital social',
    'companySettings.info.capitalPlaceholder': 'Ej.: 1.000 EUR',
    'companySettings.info.siretLabel': 'SIRET',
    'companySettings.info.siretPlaceholder': 'Ej.: 123 456 789 00014',
    'companySettings.info.rcsLabel': 'RCS',
    'companySettings.info.rcsPlaceholder': 'Ej.: Paris B 123 456 789',
    'companySettings.info.phoneLabel': 'Teléfono',
    'companySettings.info.phonePlaceholder': 'Ej.: +594 694 XX XX XX',
    'companySettings.info.emailLabel': 'Correo electrónico',
    'companySettings.info.emailPlaceholder': 'Ej.: contacto@miempresa.com',
    'companySettings.info.postalLabel': 'Código postal',
    'companySettings.info.postalPlaceholder': 'Ej.: 97300',
    'companySettings.info.addressLabel': 'Dirección',
    'companySettings.info.addressPlaceholder': 'Ej.: Calle Principal 10',
    'companySettings.info.cityLabel': 'Ciudad',
    'companySettings.info.cityPlaceholder': 'Ej.: Cayena',
    'companySettings.info.tvaLabel': 'Mención de IVA',
    'companySettings.info.tvaPlaceholder': 'Mención fiscal en los documentos',
    'companySettings.documents.devisSectionTitle': 'Ajustes de presupuestos',
    'companySettings.documents.devisValidityLabel': 'Validez del presupuesto',
    'companySettings.documents.devisValidityPlaceholder': 'Periodo de validez del presupuesto',
    'companySettings.documents.devisConditionsLabel': 'Condiciones generales (presupuesto)',
    'companySettings.documents.devisConditionsPlaceholder': 'Condiciones generales mostradas en los presupuestos',
    'companySettings.documents.bcSectionTitle': 'Ajustes de pedidos de compra',
    'companySettings.documents.bcConditionsLabel': 'Condiciones del pedido de compra',
    'companySettings.documents.bcConditionsPlaceholder': 'Condiciones de ejecución de los servicios',
    'companySettings.documents.factureSectionTitle': 'Ajustes de facturas',
    'companySettings.documents.facturePaymentLabel': 'Condiciones de pago',
    'companySettings.documents.facturePaymentPlaceholder': 'Ej.: Pago al recibir...',
    'companySettings.documents.facturePenaltiesLabel': 'Penalizaciones por demora',
    'companySettings.documents.facturePenaltiesPlaceholder': 'Cláusula de penalización por demora',
    'companySettings.documents.factureRecoveryLabel': 'Indemnización por cobro',
    'companySettings.documents.factureRecoveryPlaceholder': 'Cláusula de indemnización a tanto alzado',
    'companySettings.documents.factureReserveLabel': 'Reserva de dominio',
    'companySettings.documents.factureReservePlaceholder': 'Cláusula de reserva de dominio',
    'companySettings.documents.warrantySectionTitle': 'Garantía',
    'companySettings.documents.warrantyLabel': 'Mención de garantía',
    'companySettings.documents.warrantyPlaceholder': 'Ej.: Garantía de 6 meses sobre piezas y mano de obra a partir de la fecha de reparación.',
    'companySettings.documents.warrantyHint': 'Esta mención se mostrará al pie de las facturas si se completa.',
    'companySettings.payment.sectionTitle': 'Pago en línea',
    'companySettings.payment.disableTitle': 'Desactivar el pago en línea',
    'companySettings.payment.disableDesc': 'Cuando está activado, las opciones de pago en línea (Stripe) se ocultan en todos los presupuestos. Los clientes solo podrán solicitar un enlace de pago SumUp.',
    'companySettings.payment.statusDisabled': 'Pago en línea DESACTIVADO - Los clientes solo verán el formulario de solicitud SumUp',
    'companySettings.payment.statusEnabled': 'Pago en línea ACTIVADO - Los clientes pueden pagar directamente en línea',
    'companySettings.payment.howTitle': '¿Cómo funciona?',
    'companySettings.payment.step1': '1. El cliente recibe el presupuesto por correo y lo acepta',
    'companySettings.payment.step2': '2. En lugar de pagar en línea, rellena un formulario con su correo/teléfono',
    'companySettings.payment.step3': '3. Usted recibe una notificación con la solicitud de pago',
    'companySettings.payment.step4': '4. Usted envía manualmente el enlace de pago SumUp al cliente',
    'companySettings.logo.sectionTitle': 'Logotipo de la empresa',
    'companySettings.logo.description': 'Este logotipo se mostrará en sus facturas, presupuestos y pedidos de compra (formatos PNG, JPG, máx. 5 MB).',
    'companySettings.logo.alt': 'Logotipo',
    'companySettings.logo.none': 'Sin logotipo',
    'companySettings.logo.uploading': 'Subiendo...',
    'companySettings.logo.choose': 'Elegir un logotipo',
    'companySettings.logo.hint': 'El logotipo se redimensionará automáticamente en los documentos PDF.',
    'companySettings.preview.sectionTitle': 'Vista previa de sus documentos',
    'companySettings.preview.description': 'Visualice un ejemplo de factura o presupuesto con sus ajustes actuales (logotipo, información, menciones legales).',
    'companySettings.preview.saveReminder': 'Recuerde guardar sus cambios antes de generar la vista previa.',
    'companySettings.preview.facture': 'Factura',
    'companySettings.preview.devis': 'Presupuesto',
    'companySettings.preview.generating': 'Generando...',
    'companySettings.preview.generate': 'Generar vista previa',
    'companySettings.preview.iframeTitle': 'Vista previa PDF',
    'companySettings.security.genericError': 'Error',
    'companySettings.security.invalidCode': 'Código no válido',
    'companySettings.security.enabledToast': '¡2FA activado correctamente!',
    'companySettings.security.disabledToast': '2FA desactivado',
    'companySettings.security.sectionTitle': 'Seguridad de la cuenta',
    'companySettings.security.twoFaTitle': 'Autenticación de dos factores (2FA)',
    'companySettings.security.statusActive': 'Activado',
    'companySettings.security.statusInactive': 'Desactivado',
    'companySettings.security.intro': 'Proteja su cuenta con una verificación en dos pasos. En cada inicio de sesión se le pedirá un código de 6 dígitos además de su contraseña.',
    'companySettings.security.configureBtn': 'Configurar 2FA',
    'companySettings.security.step1ScanPrefix': '1. Escanee este código QR con',
    'companySettings.security.step1ScanSuffix': ':',
    'companySettings.security.qrAlt': 'Código QR 2FA',
    'companySettings.security.manualKeyLabel': 'O introduzca esta clave manualmente:',
    'companySettings.security.step2Enter': '2. Introduzca el código que aparece en la aplicación:',
    'companySettings.security.activate': 'Activar',
    'companySettings.security.protectedMsg': 'Su cuenta está protegida por 2FA',
    'companySettings.security.disablePrompt': 'Para desactivar, introduzca su código actual:',
    'companySettings.security.disable': 'Desactivar',
    'docTimezone.title': 'Horarios de documentos',
    'docTimezone.intro': 'Configure la zona horaria utilizada para las fechas y horas en sus documentos (tickets, facturas, presupuestos, órdenes de compra).',
    'docTimezone.sectionTimezone': 'Zona horaria',
    'docTimezone.selectLabel': 'Seleccione su zona horaria',
    'docTimezone.currentLabel': 'Zona actual:',
    'docTimezone.selectHint': 'Esta zona horaria se aplicará a todas las fechas mostradas en sus documentos. La hora de registro de los tickets nunca cambiará una vez guardada.',
    'docTimezone.save': 'Guardar',
    'docTimezone.importantTitle': 'Importante',
    'docTimezone.importantBody': 'De forma predeterminada, todos los documentos utilizan la zona horaria de la Guayana Francesa (Cayena, UTC-3). Si modifica este parámetro, los documentos futuros utilizarán la nueva zona horaria. Los documentos ya creados conservarán su hora de registro original.',
    'docTimezone.toastUpdated': 'Zona horaria actualizada',
    'docTimezone.errUpdate': 'Error al actualizar',
    'docTimezone.errNetwork': 'Error de red',
    'docTimezone.tzCayenne': 'Guayana Francesa (Cayena)',
    'docTimezone.tzMartinique': 'Martinica / Guadalupe',
    'docTimezone.tzGuadeloupe': 'Guadalupe',
    'docTimezone.tzParis': 'Francia metropolitana (París)',
    'docTimezone.tzReunion': 'Reunión',
    'docTimezone.tzNoumea': 'Nueva Caledonia',
    'docTimezone.tzTahiti': 'Polinesia Francesa (Tahití)',
    'flashOffers.confirmDelete': '¿Eliminar esta oferta?',
    'flashOffers.emailsSentFallback': 'Correos enviados',
    'flashOffers.pageTitle': 'Ofertas flash y promociones',
    'flashOffers.pageSubtitle': 'Gestiona tus promociones temporales y envíalas a los clientes fieles',
    'flashOffers.newOffer': 'Nueva oferta',
    'flashOffers.createTitle': 'Crear una oferta flash',
    'flashOffers.labelTitle': 'Título *',
    'flashOffers.placeholderTitle': 'Ej.: Especial de fin de semana',
    'flashOffers.labelDiscount': 'Descuento (%)',
    'flashOffers.labelDescription': 'Descripción',
    'flashOffers.placeholderDescription': 'Ej.: Reparación de pantalla a precio reducido',
    'flashOffers.labelEndDate': 'Fecha de fin',
    'flashOffers.labelTargetLevels': 'Niveles objetivo',
    'flashOffers.levelBronze': 'Bronce',
    'flashOffers.levelSilver': 'Plata',
    'flashOffers.levelGold': 'Oro',
    'flashOffers.creating': 'Creando...',
    'flashOffers.createOffer': 'Crear oferta',
    'flashOffers.emptyTitle': 'No se ha creado ninguna oferta flash',
    'flashOffers.emptyHint': 'Haz clic en «{{btn}}» para empezar',
    'flashOffers.badgeExpired': 'Caducada',
    'flashOffers.badgeDisabled': 'Desactivada',
    'flashOffers.endLabel': 'Fin: {{date}}',
    'flashOffers.emailsCount': 'Correos: {{count}}',
    'flashOffers.lastSent': 'Último envío: {{date}}',
    'flashOffers.deactivate': 'Desactivar',
    'flashOffers.activate': 'Activar',
    'flashOffers.sendByEmail': 'Enviar por correo',
    'flashOffers.delete': 'Eliminar',
    'mailsAi.oauthDenied': 'Autorización de Google denegada.',
    'mailsAi.sessionExpired': 'Sesión expirada, vuelva a intentarlo.',
    'mailsAi.tokenExchangeFailed': 'Error de conexión con Google, vuelva a intentarlo.',
    'mailsAi.missingParams': 'Faltan parámetros.',
    'mailsAi.googleConnectError': 'Error de conexión con Google.',
    'mailsAi.errorWith': 'Error: {{msg}}',
    'mailsAi.aiAnalysisError': 'Error de análisis IA: {{msg}}',
    'mailsAi.confirmDeleteAccount': '¿Eliminar esta cuenta de correo y todos sus mensajes almacenados?',
    'mailsAi.confirmRefetch': 'Esto eliminará todos los correos en caché y los volverá a descargar con la representación HTML completa. ¿Continuar?',
    'mailsAi.confirmBulkAnalyze': '¿Analizar {{count}} correos sin analizar? (Usa créditos de IA)',
    'mailsAi.fetchAnalyzedHeader': '{{count}} correos nuevos recuperados y analizados.',
    'mailsAi.alertsDetected': '{{count}} alerta(s) detectada(s):',
    'mailsAi.fetchAnalyzedNoThreat': '{{count}} correos nuevos recuperados y analizados automáticamente. No se detectaron amenazas.',
    'mailsAi.fetchRetrieved': '{{count}} correos nuevos recuperados.',
    'mailsAi.noNewEmail': 'No hay correos nuevos.',
    'mailsAi.refetchDone': '¡Resincronización completada! {{count}} correos recuperados con la representación HTML.',
    'mailsAi.allVisibleAnalyzed': '¡Todos los correos visibles ya están analizados!',
    'mailsAi.bulkAnalyzeDone': '¡Análisis completado! {{done}}/{{total}} correos analizados.',
    'mailsAi.emailSent': '¡Correo enviado con éxito!',
    'mailsAi.subtitle': 'Gestión inteligente de sus correos profesionales',
    'mailsAi.autoRefresh': 'Actualización automática',
    'mailsAi.refresh': 'Actualizar',
    'mailsAi.analyzeAll': 'Analizar todo',
    'mailsAi.compose': 'Correo nuevo',
    'mailsAi.addAccount': 'Añadir una cuenta',
    'mailsAi.loadingAccounts': 'Cargando cuentas...',
    'mailsAi.noAccountTitle': 'Ninguna cuenta de correo conectada',
    'mailsAi.noAccountDesc': 'Conecte su primera cuenta de correo para empezar.',
    'mailsAi.fetchingAll': 'Recuperando todos los correos...',
    'mailsAi.fetchingAllHint': 'Esto puede tardar unos minutos',
    'mailsAi.noEmail': 'No hay correos.',
    'mailsAi.noSubject': '(sin asunto)',
    'mailsAi.prev': 'Ant.',
    'mailsAi.next': 'Sig.',
    'mailsAi.pageOf': '{{page}} / {{total}}',
    'sumupTerminal.title': 'Terminal SumUp (TPV)',
    'sumupTerminal.subtitle': 'Un terminal por tienda — M1 y M2 son independientes. El POS V2 usa el terminal de la tienda seleccionada.',
    'sumupTerminal.hintM1': 'Terminal Resurrection Mobile (SOLO)',
    'sumupTerminal.hintM2': 'Por configurar cuando el 2º TPV esté vinculado con SumUp',
    'sumupTerminal.m2NotConfigured': 'M2 aún no está configurado — es normal si el 2º TPV todavía no está vinculado. Cuando lo esté, rellena los campos de abajo (cuenta SumUp M2 separada).',
    'sumupTerminal.step1Lead': 'En SumUp Cloud → Terminales → copia el',
    'sumupTerminal.step1Merchant': 'código de comercio',
    'sumupTerminal.step1And': ' y el ',
    'sumupTerminal.step1Reader': 'ID de lector',
    'sumupTerminal.step2Lead': 'Pega la',
    'sumupTerminal.step2Secret': 'clave SECRETA',
    'sumupTerminal.step2Mid': '(sup_sk_…) —',
    'sumupTerminal.step2Public': 'no la clave pública sup_pk_',
    'sumupTerminal.step3Lead': 'Haz clic en',
    'sumupTerminal.step3Verify': 'Verificar la clave API',
    'sumupTerminal.step3Rest': '→ el código de comercio se rellena automáticamente',
    'sumupTerminal.step4Lead': 'Selecciona el terminal en la lista y luego',
    'sumupTerminal.step4Save': 'Guardar',
    'sumupTerminal.labelName': 'Nombre del terminal (opcional)',
    'sumupTerminal.namePlaceholder': 'Ej.: MI TPV M1',
    'sumupTerminal.labelApiKey': 'Clave API secreta de SumUp (sup_sk_…) *',
    'sumupTerminal.savedKeyPlaceholder': 'Guardada: {{masked}}',
    'sumupTerminal.apiKeyHint': 'Solo la clave secreta sup_sk_. SumUp solo la muestra una vez, al crearla.',
    'sumupTerminal.verifyKeyBtn': '1. Verificar la clave API',
    'sumupTerminal.keyConfirmed': '✓ Clave confirmada por SumUp',
    'sumupTerminal.labelMerchantCode': 'Código de comercio *',
    'sumupTerminal.labelReaderId': 'ID de lector (reader) *',
    'sumupTerminal.discoverBtn': 'Buscar mis terminales',
    'sumupTerminal.readerFallback': 'TPV SumUp',
    'sumupTerminal.labelDeviceId': 'Identificador del dispositivo (opcional)',
    'sumupTerminal.saveBtn': 'Guardar {{mag}}',
    'sumupTerminal.testBtn': 'Prueba de {{amount}} en el terminal',
    'sumupTerminal.checklistTitle': 'Lista de verificación del terminal',
    'sumupTerminal.checklistWifi': 'Terminal encendido y conectado al Wi‑Fi',
    'sumupTerminal.checklistPaired': 'Estado «Vinculado» en SumUp Cloud',
    'sumupTerminal.checklistSolo': 'Software Solo ≥ 3.3.24',
    'sumupTerminal.checklistBluetooth': 'El Bluetooth y la API no funcionan juntos — desactiva el Bluetooth en el SOLO si usas el POS',
    'sumupTerminal.checklistCancel': 'Si el importe aparece y luego se cancela solo: vuelve a conectar la API en el terminal (no es un fallo del POS)',
    'sumupTerminal.openCloud': 'Abrir SumUp Cloud',
    'sumupTerminal.errLoad': 'No se pudo cargar la configuración',
    'sumupTerminal.msgMerchantChanged': 'Cuenta de comercio modificada — verifica la clave API y luego selecciona el terminal.',
    'sumupTerminal.errPasteSecret': 'Primero pega la clave secreta de SumUp (sup_sk_…), no la clave pública sup_pk_.',
    'sumupTerminal.keyOkReaders': 'Clave OK — cuenta {{mc}} · {{count}} terminal(es) encontrado(s).',
    'sumupTerminal.keyOkNone': 'Clave OK — cuenta {{mc}} · ningún terminal vinculado en SumUp Cloud.',
    'sumupTerminal.errKeyRejected': 'Clave API rechazada por SumUp',
    'sumupTerminal.msgNoReaders': 'No se encontró ningún terminal — comprueba que el terminal esté vinculado en SumUp Cloud.',
    'sumupTerminal.errDiscover': 'Error al buscar el terminal',
    'sumupTerminal.readerSelected': 'Terminal seleccionado: {{name}}',
    'sumupTerminal.errMerchantChangeKey': 'Cambio de cuenta SumUp: introduce la nueva clave API (sup_sk_…) antes de guardar.',
    'sumupTerminal.errVerifyFirst': 'Primero haz clic en «Verificar la clave API» — SumUp debe confirmar la clave antes de guardar.',
    'sumupTerminal.errReaderRequired': 'Se requiere el ID de lector — haz clic en «Buscar mis terminales» y selecciona el terminal.',
    'sumupTerminal.savedWithNotice': 'Configuración {{mag}} guardada. {{notice}}',
    'sumupTerminal.saved': 'Configuración {{mag}} guardada.',
    'sumupTerminal.errSave': 'Error al guardar',
    'sumupTerminal.testOk': 'Prueba OK — mira el terminal',
    'sumupTerminal.errTest': 'Prueba fallida',
    'adminB2B.accessDenied': 'Acceso denegado',
    'adminB2B.reservedAdmins': 'Reservado para administradores.',
    'adminB2B.backToDashboard': 'Volver al panel',
    'adminB2B.back': 'Volver',
    'adminB2B.title': 'Clientes B2B',
    'adminB2B.accountsSingular': 'Empresas registradas en el portal B2B — {{count}} cuenta',
    'adminB2B.accountsPlural': 'Empresas registradas en el portal B2B — {{count}} cuentas',
    'adminB2B.colCompany': 'Empresa',
    'adminB2B.colManager': 'Gerente',
    'adminB2B.colEmail': 'Correo',
    'adminB2B.colPhone': 'Teléfono',
    'adminB2B.colStatus': 'Estado',
    'adminB2B.colRegistered': 'Registro',
    'adminB2B.empty': 'Ningún cliente B2B',
    'adminB2B.statusValide': 'Validado',
    'adminB2B.statusEnAttente': 'Pendiente',
    'adminB2B.statusRefuse': 'Rechazado',
    'adminCache.statusCompleted': 'Completado',
    'adminCache.statusRunning': 'En curso...',
    'adminCache.statusUpdating': 'Actualizando',
    'adminCache.statusError': 'Error',
    'adminCache.never': 'Nunca',
    'adminCache.title': 'Datos de proveedores',
    'adminCache.refreshing': 'Actualizando...',
    'adminCache.refreshData': 'Actualizar los datos',
    'adminCache.step1Title': 'Paso 1 — Credenciales de proveedores.',
    'adminCache.step1Intro': 'Introduzca el correo y la contraseña de Mobilax, JensMobiles y LCD-Phone en la página',
    'adminCache.step1LinkText': 'Credenciales de proveedores',
    'adminCache.step1Outro': 'Luego vuelva aquí y haga clic en « {{action}} » para alimentar el Auto-Presupuesto IA.',
    'adminCache.configurePasswords': 'Configurar contraseñas',
    'adminCache.totalCached': 'Total de productos en caché',
    'adminCache.spareParts': 'Repuestos',
    'adminCache.accessories': 'Accesorios',
    'adminCache.phones': 'Teléfonos',
    'adminCache.syncState': 'Estado de la sincronización',
    'adminCache.noSync': 'Ninguna sincronización realizada',
    'adminCache.exploreCache': 'Explorar la caché',
    'adminCache.searchPlaceholder': 'Buscar (p. ej.: funda iPhone 14, Galaxy A06 nuevo)...',
    'adminCache.allTypes': 'Todos los tipos',
    'adminCache.filterParts': 'Piezas',
    'adminCache.filterAccessories': 'Accesorios',
    'adminCache.filterPhones': 'Teléfonos',
    'adminCache.colType': 'Tipo',
    'adminCache.colSupplier': 'Proveedor',
    'adminCache.colPart': 'Pieza',
    'adminCache.colBrand': 'Marca',
    'adminCache.colPrice': 'Precio',
    'adminCache.colStock': 'Stock',
    'adminCache.colRef': 'Ref.',
    'adminCache.catPart': 'Pieza',
    'adminCache.catAccessory': 'Accesorio',
    'adminCache.catPhone': 'Teléfono',
    'adminCache.inStock': 'En stock',
    'adminCache.outOfStock': 'Agotado',
    'adminCache.noResults': 'Sin resultados para "{{query}}"',
    'adminDownloads.artifactDesktopLabel': 'Aplicación Windows para el personal',
    'adminDownloads.artifactDesktopDesc': 'Archivo ZIP distribuido a los usuarios de Windows.',
    'adminDownloads.artifactPackLabel': 'Paquete del agente de impresora',
    'adminDownloads.artifactPackDesc': 'Archivo ZIP fuente para reconstruir el agente de impresión.',
    'adminDownloads.artifactExeLabel': 'Agente de Windows',
    'adminDownloads.artifactExeDesc': 'Ejecutable listo para usar en el puesto del técnico.',
    'adminDownloads.available': 'Disponible',
    'adminDownloads.missing': 'Ausente',
    'adminDownloads.download': 'Descargar',
    'adminDownloads.activeFile': 'Archivo activo',
    'adminDownloads.size': 'Tamaño',
    'adminDownloads.lastUpdate': 'Última actualización',
    'adminDownloads.uploadedBy': 'Subido por',
    'adminDownloads.replaceLiveFile': 'Reemplazar el archivo en vivo',
    'adminDownloads.uploading': 'Subiendo...',
    'adminDownloads.replace': 'Reemplazar',
    'adminDownloads.replaceHint': 'El archivo elegido reemplaza directamente el que se entrega a los usuarios en remobiles.com.',
    'adminDownloads.selectedFile': 'Archivo seleccionado: {{name}}',
    'adminDownloads.loadError': 'Error al cargar los archivos',
    'adminDownloads.downloadLinkUnavailable': 'Enlace de descarga no disponible',
    'adminDownloads.downloadFailed': 'No se pudo descargar',
    'adminDownloads.selectFilePrompt': 'Selecciona un archivo para {{label}}.',
    'adminDownloads.confirmReplace': '¿Reemplazar ahora {{label}} por {{name}}?',
    'adminDownloads.replaceSuccess': '{{label}} reemplazado con éxito.',
    'adminDownloads.uploadError': 'Error durante la subida',
    'adminDownloads.title': 'Instaladores y descargas',
    'adminDownloads.subtitle': 'Descargas directas de los paquetes de Windows y reemplazo en vivo para el superadministrador.',
    'adminDownloads.printerConfig': 'Configuración de impresora',
    'adminDownloads.refresh': 'Actualizar',
    'adminDownloads.availableArtifacts': 'Artefactos disponibles',
    'adminDownloads.totalSize': 'Tamaño total',
    'adminDownloads.alert': 'Alerta',
    'adminDownloads.alertText': 'Los reemplazos sobrescriben el archivo en vivo. No hay eliminación aparte.',
    'adminDownloads.accessTitle': 'Acceso de admin y superadmin',
    'adminDownloads.accessText': 'Esta página centraliza las descargas visibles desde remobiles.com. El reemplazo en vivo de los archivos solo aparece para el superadministrador.',
    'adminDownloads.signedLinksNote': 'Los enlaces de descarga permanecen firmados por el backend para evitar los blobs en el navegador.',
    'adminCachePurge.accessDenied': 'Acceso reservado a Carlos.',
    'adminCachePurge.title': 'Purga de documentos comerciales',
    'adminCachePurge.descIntro': 'Página oculta — solo Carlos. Elimina ventas, registros, pedidos, anticipos y presupuestos/facturas',
    'adminCachePurge.descBefore': 'antes de',
    'adminCachePurge.descOutro': 'la fecha elegida. Las reparaciones no se ven afectadas.',
    'adminCachePurge.warnBackupBefore': 'Acción destructiva e irreversible. Haz una exportación de respaldo desde',
    'adminCachePurge.warnBackupLink': 'Base de datos',
    'adminCachePurge.warnBackupAfter': 'antes de cualquier purga real.',
    'adminCachePurge.resultDryRunLine': 'Simulación completada — se eliminarían {{count}} documento(s) antes del {{before}}.',
    'adminCachePurge.resultPurgeLine': 'Purga ejecutada — {{count}} documento(s) eliminados antes del {{before}}.',
    'adminCachePurge.sectionParams': 'Parámetros',
    'adminCachePurge.labelBeforeDate': 'Eliminar todo antes del',
    'adminCachePurge.hintStrictlyBefore': 'Estrictamente antes de las 00:00 de ese día.',
    'adminCachePurge.labelConfirm': 'Confirmación (obligatoria)',
    'adminCachePurge.hintTypeToken': 'Escribe: {{token}}',
    'adminCachePurge.dryRunLabel': 'Modo simulación (dry-run) — no elimina nada',
    'adminCachePurge.previewBtn': 'Vista previa',
    'adminCachePurge.simulateBtn': 'Simular la purga',
    'adminCachePurge.executeBtn': 'Ejecutar la purga',
    'adminCachePurge.previewHeading': 'Vista previa — {{count}} documento(s)',
    'adminCachePurge.beforeLabel': 'antes del {{before}}',
    'adminCachePurge.previewEmpty': 'No hay datos para mostrar.',
    'adminCachePurge.colCollection': 'Colección',
    'adminCachePurge.colCount': 'Cantidad',
    'adminCachePurge.colExamples': 'Ejemplos',
    'adminCachePurge.sectionExcluded': 'No eliminado',
    'adminCachePurge.excludedReparations': 'Reparaciones (dispositivos)',
    'adminCachePurge.excludedStock': 'Stock',
    'adminCachePurge.excludedClients': 'Clientes',
    'adminCachePurge.excludedUtilisateurs': 'Usuarios',
    'adminCachePurge.confirmDryRun': '¿Simular purga antes del {{before}} ({{count}} documentos)?',
    'adminCachePurge.confirmDelete': '⚠️ IRREVERSIBLE — ¿Eliminar {{count}} documentos comerciales antes del {{before}}?',
    'adminCachePurge.errorPreview': 'Error en la vista previa',
    'adminCachePurge.errorLoad': 'Error de carga',
    'adminCachePurge.errorPurge': 'Error en la purga',
    'adminSupplierCreds.title': 'Credenciales de proveedores',
    'adminSupplierCreds.subtitle': '{{providers}} — para Auto-Devis y la caché del catálogo',
    'adminSupplierCreds.supplierData': 'Datos de proveedores',
    'adminMagasins.statusActive': 'Activo',
    'adminMagasins.statusArchived': 'Archivado',
    'adminMagasins.newStore': 'Nueva tienda',
    'adminMagasins.fieldCode': 'Código (autogenerado, editable)',
    'adminMagasins.fieldName': 'Nombre *',
    'adminMagasins.namePlaceholder': 'ej.: Tienda Cayenne Centro',
    'adminMagasins.fieldAddress': 'Dirección',
    'adminMagasins.fieldPhone': 'Teléfono',
    'adminMagasins.fieldPrinterIp': 'Impresora (IP)',
    'adminMagasins.printerIpPlaceholder': 'ej.: 192.168.1.50  — dejar vacío si no hay impresora dedicada',
    'adminMagasins.printerIpHint': 'Si está vacío → se usa la impresora de la sesión POS.',
    'adminMagasins.fieldBadgeColor': 'Color de la etiqueta',
    'adminMagasins.setAsDefault': 'Definir como tienda predeterminada',
    'adminMagasins.defaultWillBeDemoted': 'La tienda {{code}} ({{name}}) es actualmente la predeterminada. Se degradará automáticamente.',
    'adminMagasins.cancel': 'Cancelar',
    'adminMagasins.createStore': 'Crear tienda',
    'adminMagasins.nameRequired': 'Nombre obligatorio',
    'adminMagasins.createError': 'Error al crear',
    'adminMagasins.confirmOverrideDefault': 'La tienda «{{code}} — {{name}}» es actualmente la tienda predeterminada.\n\nAl marcar «Definir como predeterminada», se degradará automáticamente.\n\n¿Confirmar?',
    'adminMagasins.loadError': 'Error al cargar',
    'adminMagasins.confirmArchive': '¿Archivar la tienda {{code}}? Los artículos y las ventas NO se eliminarán.',
    'adminMagasins.genericError': 'Error',
    'adminMagasins.back': 'Volver',
    'adminMagasins.title': 'Tiendas',
    'adminMagasins.subtitle': 'Gestionar las tiendas (locales físicos)',
    'adminMagasins.filterActive': 'Activas',
    'adminMagasins.filterArchived': 'Archivadas',
    'adminMagasins.filterAll': 'Todas',
    'adminMagasins.colCode': 'Código',
    'adminMagasins.colName': 'Nombre',
    'adminMagasins.colAddress': 'Dirección',
    'adminMagasins.colPhone': 'Teléfono',
    'adminMagasins.colPrinterIp': 'IP de impresora',
    'adminMagasins.colColor': 'Color',
    'adminMagasins.colStatus': 'Estado',
    'adminMagasins.colActions': 'Acciones',
    'adminMagasins.loading': 'Cargando…',
    'adminMagasins.emptyArchived': 'Ninguna tienda archivada.',
    'adminMagasins.emptyActive': 'Ninguna tienda activa.',
    'adminMagasins.defaultBadge': 'PREDET.',
    'adminMagasins.edit': 'Editar',
    'adminMagasins.cannotArchiveDefault': 'Imposible — tienda predeterminada',
    'adminMagasins.archive': 'Archivar',
    'adminMagasins.restore': 'Restaurar',
    'adminMagasins.footerNote': 'Las tiendas archivadas conservan sus artículos y ventas (R1 — solo soft delete). La tienda marcada «{{badge}}» no se puede archivar.',
    'adminPromos.title': 'Promociones automatizadas',
    'adminPromos.subtitle': 'Promociones activas, calendario y ajustes',
    'adminPromos.tabCurrent': 'Promociones activas',
    'adminPromos.tabCalendar': 'Calendario mensual',
    'adminPromos.tabSettings': 'Ajustes',
    'adminPromos.forceDailyDraw': 'Forzar un nuevo sorteo diario',
    'adminPromos.ref': 'Ref.: {{ref}}',
    'adminPromos.statusActive': '🟢 Activa',
    'adminPromos.statusInactive': '⚫ Inactiva',
    'adminPromos.endLabel': 'fin: {{date}}',
    'adminPromos.emptyPromos': 'Ninguna promoción',
    'adminPromos.regenThisMonth': 'Regenerar este mes',
    'adminPromos.productsCount': '{{count}} productos',
    'adminPromos.emptyCalendar': 'Sin calendario — ¿Regenerar?',
    'adminPromos.configDaily': 'Auto-bot diario',
    'adminPromos.excludedCategories': 'Categorías excluidas (separadas por comas)',
    'adminPromos.excludedKeywords': 'Palabras clave excluidas (regex OR, opcional — vacío = usa los valores predeterminados)',
    'adminPromos.save': 'Guardar',
    'adminPromos.minPct': 'Mín %',
    'adminPromos.maxPct': 'Máx %',
    'adminPromos.confirmRegenDaily': '¿Generar una nueva promo diaria ahora?',
    'adminPromos.drawResult': 'Nuevo sorteo: {{name}}',
    'adminPromos.statusResult': 'Estado: {{status}}',
    'adminPromos.confirmRegenCalendar': '¿Regenerar el calendario de {{month}}? Esto sobrescribe el existente.',
    'adminPromos.calendarRegenResult': '{{status}} — {{count}} productos utilizados',
    'adminPromos.settingsSaved': 'Ajustes guardados',
    'adminCadbotPrix.source.ventePos': 'Venta TPV',
    'adminCadbotPrix.source.reparation': 'Reparación',
    'adminCadbotPrix.source.devisValide': 'Presupuesto validado',
    'adminCadbotPrix.refSource.prixValide': 'precio validado',
    'adminCadbotPrix.refSource.tarifPublic': 'tarifa pública',
    'adminCadbotPrix.refSource.calculFournisseur': 'cálculo del proveedor',
    'adminCadbotPrix.refSource.aucune': 'sin referencia',
    'adminCadbotPrix.loadError': 'Error de carga',
    'adminCadbotPrix.genericError': 'Error',
    'adminCadbotPrix.toastCollected': '{{ventes}} ventas + {{reparations}} reparaciones registradas',
    'adminCadbotPrix.toastAnalyzed': '{{creees}} nueva(s) propuesta(s), {{maj}} actualización(es)',
    'adminCadbotPrix.priceInvalid': 'Precio no válido',
    'adminCadbotPrix.toastApproved': 'Precio validado: {{price}} — {{detail}}',
    'adminCadbotPrix.toastApprovedLocked': 'tarifa manual bloqueada, propuesta pendiente',
    'adminCadbotPrix.toastApprovedPublished': 'página de Tarifas actualizada',
    'adminCadbotPrix.rejectReasonPrompt': 'Motivo del rechazo (opcional):',
    'adminCadbotPrix.proposalRejected': 'Propuesta rechazada',
    'adminCadbotPrix.settingsSaved': 'Ajustes guardados',
    'adminCadbotPrix.confirmRemoveValidated': '¿Quitar el precio validado {{model}} · {{part}} · {{quality}}?',
    'adminCadbotPrix.validatedRemoved': 'Precio validado eliminado',
    'adminCadbotPrix.pageTitle': 'Validación de precios CADBOT',
    'adminCadbotPrix.pageSubtitle': 'CADBOT registra los precios realmente facturados y propone ajustes. Cada precio validado alimenta la página de Tarifas y tiene prioridad para los presupuestos.',
    'adminCadbotPrix.rules': 'Reglas',
    'adminCadbotPrix.collecting': 'Recopilando…',
    'adminCadbotPrix.memorizeSales': 'Registrar ventas',
    'adminCadbotPrix.analyzing': 'Analizando…',
    'adminCadbotPrix.analyze': 'Analizar',
    'adminCadbotPrix.minSales': 'Ventas mínimas',
    'adminCadbotPrix.tolerancePct': 'Diferencia mínima (%)',
    'adminCadbotPrix.toleranceEur': 'Diferencia mínima (€)',
    'adminCadbotPrix.windowDays': 'Ventana (días)',
    'adminCadbotPrix.publishOnApprove': 'Publicar en la página de Tarifas al validar',
    'adminCadbotPrix.countDevisValides': 'Contar también los presupuestos de IA aprobados (además de las ventas facturadas)',
    'adminCadbotPrix.filterPending': 'Por validar',
    'adminCadbotPrix.filterApproved': 'Validadas',
    'adminCadbotPrix.filterRejected': 'Rechazadas',
    'adminCadbotPrix.filterAll': 'Todas',
    'adminCadbotPrix.refresh': 'Actualizar',
    'adminCadbotPrix.loading': 'Cargando…',
    'adminCadbotPrix.emptyProposals': 'Ninguna propuesta {{scope}}. Haga clic en «{{collect}}» y luego en «{{analyze}}».',
    'adminCadbotPrix.emptyScopePending': 'por validar',
    'adminCadbotPrix.tier': 'Gama',
    'adminCadbotPrix.realSales': '{{count}} venta(s) real(es) (de {{min}} a {{max}})',
    'adminCadbotPrix.lastSaleOn': 'última el {{date}}',
    'adminCadbotPrix.statusBadgePending': 'POR VALIDAR',
    'adminCadbotPrix.statusBadgeApproved': 'VALIDADA',
    'adminCadbotPrix.statusBadgeRejected': 'RECHAZADA',
    'adminCadbotPrix.referencePrice': 'Precio de referencia',
    'adminCadbotPrix.medianRealSales': 'Mediana de las ventas reales',
    'adminCadbotPrix.priceToValidate': 'Precio a validar (editable)',
    'adminCadbotPrix.priceRetained': 'Precio adoptado',
    'adminCadbotPrix.evidenceSales': 'Ventas justificativas ({{count}})',
    'adminCadbotPrix.thDate': 'Fecha',
    'adminCadbotPrix.thSource': 'Origen',
    'adminCadbotPrix.thRef': 'Ref.',
    'adminCadbotPrix.thDesignation': 'Descripción',
    'adminCadbotPrix.thPriceTtc': 'Precio con IVA',
    'adminCadbotPrix.validate': 'Validar',
    'adminCadbotPrix.validateAt': 'a {{price}} €',
    'adminCadbotPrix.reject': 'Rechazar',
    'adminCadbotPrix.reviewApproved': 'Validada por {{by}} el {{date}}',
    'adminCadbotPrix.reviewRejected': 'Rechazada por {{by}} el {{date}}',
    'adminCadbotPrix.lockedPendingNote': '(tarifa editada manualmente: bloqueada, precio pendiente)',
    'adminCadbotPrix.validatedPrices': 'Precios validados ({{count}})',
    'adminCadbotPrix.noValidatedPrices': 'Todavía no hay ningún precio validado.',
    'adminCadbotPrix.thDevice': 'Dispositivo',
    'adminCadbotPrix.thPart': 'Pieza',
    'adminCadbotPrix.thTier': 'Gama',
    'adminCadbotPrix.thPrice': 'Precio',
    'adminCadbotPrix.thValidated': 'Validado',
    'adminCadbotPrix.salesCountShort': '{{count}} venta(s)',
    'adminCadbotPrix.remove': 'Quitar',
    'adminCommissions.typeVentes': 'Ventas',
    'adminCommissions.typeCommandes': 'Pedidos',
    'adminCommissions.typeAcomptes': 'Anticipos',
    'adminCommissions.typeReparations': 'Reparaciones',
    'adminCommissions.typeFactures': 'Facturas',
    'adminCommissions.typeDevis': 'Presupuestos',
    'adminCommissions.typeB2b': 'B2B',
    'adminCommissions.typeDeplacement': 'Desplazamiento',
    'adminCommissions.tagBackfill': 'Backfill',
    'adminCommissions.tagDoublonPotentiel': 'Duplicado potencial',
    'adminCommissions.tagSuspectReparation': 'Reparación sospechosa',
    'adminCommissions.tagSuspectCommande': 'Pedido sospechoso',
    'adminCommissions.confirmCancel': '¿Anular esta comisión?',
    'adminCommissions.noSelection': 'Ninguna línea seleccionada',
    'adminCommissions.confirmBulkMarkPaid': '¿Marcar {{count}} comisión(es) como pagada(s)?',
    'adminCommissions.confirmRecompute30d': '¿Recalcular las comisiones de los últimos 30 días para las ventas existentes?\nIdempotente: no crea duplicados.',
    'adminCommissions.recomputeResult': 'Escaneo: {{scanned}} ventas — {{created}} comisiones creadas',
    'adminCommissions.error': 'Error: {{detail}}',
    'adminCommissions.title': 'Comisiones',
    'adminCommissions.totalToPay': 'Total a pagar',
    'adminCommissions.alreadyPaid': 'Ya pagado',
    'adminCommissions.recompute30d': 'Recalcular últimos 30 días',
    'adminCommissions.recompute30dHint': 'Backfill retroactivo de las ventas existentes',
    'adminCommissions.configPerStaff': 'Configuración por empleado',
    'adminCommissions.configure': 'Configurar',
    'adminCommissions.noStaffFound': 'No se encontró personal',
    'adminCommissions.filters': 'Filtros',
    'adminCommissions.allStatuses': 'Todos los estados',
    'adminCommissions.statusToPay': 'Por pagar',
    'adminCommissions.statusPaid': 'Pagadas',
    'adminCommissions.statusCancelled': 'Anuladas',
    'adminCommissions.allStaff': 'Todo el personal',
    'adminCommissions.allTypes': 'Todos los tipos',
    'adminCommissions.auditHeuristic': 'Auditoría heurística',
    'adminCommissions.auditAdvanced': 'Auditoría avanzada multiseñal',
    'adminCommissions.metierAuditReadOnly': 'Auditoría avanzada — solo lectura · ledger Mongo intacto · solo analizador multiseñal',
    'adminCommissions.metierAuditLoading': 'Análisis de negocio en curso…',
    'adminCommissions.ledgerCommissionStored': 'Comisión ledger (almacenada)',
    'adminCommissions.metierCommissionTheoretical': 'Comisión de negocio teórica',
    'adminCommissions.totalGapPeriod': 'Diferencia total del período',
    'adminCommissions.rowsAnalyzed': 'Líneas analizadas',
    'adminCommissions.typeMismatchDetected': 'Discrepancias de tipo detectadas',
    'adminCommissions.auditHeuristicLegend': 'Auditoría heurística: clasificación por referencia de transacción. Sin escrituras en la base de datos.',
    'adminCommissions.legendRecompute30d': 'recálculo 30d',
    'adminCommissions.combinedAuditNote': 'Columnas Ledger = valores almacenados en Mongo (tipo, tasa snapshot, commission_amount). Columnas Métier = análisis multiseñal + configuración actual del empleado para el tipo detectado.',
    'adminCommissions.bulkMarkPaid': 'Marcar como pagadas ({{count}})',
    'adminCommissions.clearSelection': 'Cancelar la selección',
    'adminCommissions.colDate': 'Fecha',
    'adminCommissions.colStaff': 'Empleado',
    'adminCommissions.colType': 'Tipo',
    'adminCommissions.colTransaction': 'Transacción',
    'adminCommissions.colAmount': 'Importe',
    'adminCommissions.colRateApplied': 'Tasa aplicada',
    'adminCommissions.colCommission': 'Comisión',
    'adminCommissions.colStatus': 'Estado',
    'adminCommissions.colLedgerType': 'L. tipo',
    'adminCommissions.colLedgerRate': 'L. tasa',
    'adminCommissions.colLedgerCommission': 'L. comisión',
    'adminCommissions.colMetierType': 'M. tipo',
    'adminCommissions.colMetierRate': 'M. tasa',
    'adminCommissions.colMetierCommission': 'M. comisión',
    'adminCommissions.colGap': 'Diferencia',
    'adminCommissions.colAuditSignals': 'Señales de auditoría',
    'adminCommissions.colRealType': 'Tipo real (auditoría)',
    'adminCommissions.colAppliedType': 'Tipo aplicado',
    'adminCommissions.colSource': 'Origen',
    'adminCommissions.loading': 'Cargando…',
    'adminCommissions.mixed': 'mixto',
    'adminCommissions.pairLabel': 'Par: {{id}}',
    'adminCommissions.expectedLabel': 'Esperado: {{type}}',
    'adminCommissions.markPaidShort': 'Pagado',
    'adminCommissions.noCommissionInFilter': 'Ninguna comisión en este filtro',
    'adminCommissions.noCommissionHint': 'Si acaba de activarse una comisión, use el botón «Recalcular últimos 30 días» de arriba.',
    'adminCommissions.modalTitle': 'Comisiones de {{name}}',
    'adminCommissions.cancel': 'Cancelar',
    'adminCommissions.save': 'Guardar',
    'adminCloud.status.ok': 'OK',
    'adminCloud.status.ko': 'Error',
    'adminCloud.status.skipped': 'Omitido',
    'adminCloud.docType.ticket': 'Ticket de reparación',
    'adminCloud.docType.facture': 'Factura',
    'adminCloud.docType.acompte': 'Anticipo',
    'adminCloud.docType.devis': 'Presupuesto',
    'adminCloud.docType.bonCommande': 'Orden de compra',
    'adminCloud.errors.load': 'Error de carga',
    'adminCloud.errors.save': 'Error al guardar',
    'adminCloud.errors.test': 'Error de prueba',
    'adminCloud.errors.rebuild': 'Error de reconstrucción',
    'adminCloud.errors.syncToggle': 'Error al cambiar la sincronización.',
    'adminCloud.save.success': 'Parámetros guardados (la clave en texto plano nunca se devuelve).',
    'adminCloud.test.ok': '✓ Conexión OK — {{name}} (propietario: {{owner}}, expira: {{expires}})',
    'adminCloud.test.ko': 'Conexión fallida: {{error}}',
    'adminCloud.test.unknownError': 'desconocido',
    'adminCloud.hierarchy.ok': '✓ Jerarquía OK — {{path}} (folder_id: {{folderId}}...)',
    'adminCloud.hierarchy.ko': 'Jerarquía fallida — {{message}}',
    'adminCloud.access.adminRequired': 'Se requiere acceso de administrador.',
    'adminCloud.sync.resumed': 'Sincronización en la nube REANUDADA.',
    'adminCloud.sync.paused': 'Sincronización en la nube EN PAUSA.',
    'adminCloud.title': 'Sincronización en la nube — remobiles.fr',
    'adminCloud.subtitlePre': 'Sus PDF (tickets, facturas, presupuestos, anticipos) se archivan automáticamente en su espacio privado',
    'adminCloud.refresh': 'Actualizar',
    'adminCloud.sync.active': 'Sincronización en la nube ACTIVA',
    'adminCloud.sync.pausedLabel': 'Sincronización en la nube EN PAUSA',
    'adminCloud.sync.pausedAt': 'En pausa desde el {{date}}',
    'adminCloud.sync.pausedBy': ' por {{by}}',
    'adminCloud.sync.activeHint': 'Todos los nuevos documentos PDF se suben automáticamente a remobiles.fr.',
    'adminCloud.sync.pauseBtn': 'Pausar',
    'adminCloud.sync.resumeBtn': 'Reanudar',
    'adminCloud.confirm.resumeTitle': '¿Reanudar la sincronización?',
    'adminCloud.confirm.pauseTitle': '¿Pausar la sincronización?',
    'adminCloud.confirm.resumeBody': 'Los nuevos documentos se volverán a subir automáticamente a remobiles.fr.',
    'adminCloud.confirm.pauseBody': 'No se subirá ningún documento nuevo hasta que reanude la sincronización. Los documentos existentes no se ven afectados.',
    'adminCloud.cancel': 'Cancelar',
    'adminCloud.stats.globalStatus': 'Estado global',
    'adminCloud.stats.enabled': 'Activado',
    'adminCloud.stats.disabled': 'Desactivado',
    'adminCloud.stats.uploadsOk': 'Subidas OK',
    'adminCloud.stats.uploadsKo': 'Subidas fallidas',
    'adminCloud.stats.total': 'Total',
    'adminCloud.structure.title': 'Estructura objetivo en la nube (jerarquía real)',
    'adminCloud.structure.cachedTotal': '{{count}} carpetas en caché',
    'adminCloud.structure.createdThisMonth': '{{count}} creadas este mes',
    'adminCloud.structure.retryHierarchy': 'Reintentar la creación de la jerarquía',
    'adminCloud.structure.noUploadToday': '(ninguna subida hoy)',
    'adminCloud.structure.flat': '(plano)',
    'adminCloud.structure.recentFolders': 'Carpetas creadas recientemente',
    'adminCloud.structure.noFolderCache': '(ninguna carpeta en caché)',
    'adminCloud.structure.policyLabel': 'Política',
    'adminCloud.structure.policyBody': ': nunca se envía ninguna eliminación de carpeta o archivo a remobiles.fr. Los archivos de prueba permanecen visibles en la nube.',
    'adminCloud.loading': 'Cargando...',
    'adminCloud.connection.title': 'Parámetros de conexión',
    'adminCloud.connection.uploadUrl': 'URL de subida',
    'adminCloud.connection.status': 'Estado',
    'adminCloud.connection.enableAuto': 'Activar la sincronización automática',
    'adminCloud.connection.currentKey': 'Clave API actual: {{masked}}',
    'adminCloud.connection.noKey': '<ninguna>',
    'adminCloud.connection.keyPlaceholder': 'Pegue aquí una nueva clave para reemplazar (rcsk_...)',
    'adminCloud.connection.keyHint': 'La clave se cifra (Fernet) en la base de datos. Déjela vacía para no modificarla.',
    'adminCloud.save.btn': 'Guardar',
    'adminCloud.test.btn': 'Probar la conexión (whoami)',
    'adminCloud.test.lastTest': 'Última prueba: {{mark}} {{date}}',
    'adminCloud.logs.title': 'Registro de subidas',
    'adminCloud.logs.allStatuses': 'Todos los estados',
    'adminCloud.logs.filterOk': 'OK',
    'adminCloud.logs.filterKo': 'Fallida',
    'adminCloud.logs.filterSkipped': 'Omitida',
    'adminCloud.logs.allTypes': 'Todos los tipos',
    'adminCloud.logs.typeTickets': 'Tickets',
    'adminCloud.logs.typeFactures': 'Facturas',
    'adminCloud.logs.typeAcomptes': 'Anticipos',
    'adminCloud.logs.typeDevis': 'Presupuestos',
    'adminCloud.logs.typeBonsCommande': 'Órdenes de compra',
    'adminCloud.logs.colDate': 'Fecha',
    'adminCloud.logs.colType': 'Tipo',
    'adminCloud.logs.colRef': 'Referencia',
    'adminCloud.logs.colStatus': 'Estado',
    'adminCloud.logs.colFolder': 'Carpeta',
    'adminCloud.logs.colError': 'Error',
    'adminCloud.logs.empty': 'Ninguna subida por ahora.',
    'size50x30': '50 x 30 mm (estándar Bixolon)',
    'protocolZpl': 'ZPL (recomendado para Bixolon reciente)',
    'protocolBpl': 'BPL (antiguo / serie SLP)',
    'fieldClientName': 'Nombre del cliente',
    'fieldClientPhone': 'Teléfono del cliente',
    'fieldDeviceLock': 'Código / bloqueo',
    'fieldModel': 'Modelo',
    'fieldParts': 'Piezas / avería',
    'fieldDate': 'Fecha',
    'fieldPrice': 'Precio',
    'fieldRef': 'Referencia REM-XXX',
    'errLoad': 'Error al cargar la configuración',
    'saved': 'Configuración guardada.',
    'errSave': 'Error al guardar',
    'previewNeedRef': 'Introduzca una referencia REM-XXX para la vista previa.',
    'errPreview': 'Error al generar la vista previa',
    'testQueued': 'Prueba enviada a la cola. El agente local la procesará en cuanto esté conectado.',
    'errTest': 'Error en la prueba de impresora',
    'confirmRotate': 'Regenerar el token invalidará el anterior. ¿Continuar?',
    'tokenGenerated': 'Nuevo token generado. Cópielo y péguelo en la configuración del agente local.',
    'errRotate': 'Error al regenerar el token',
    'tokenCopied': 'Token copiado al portapapeles.',
    'copyFailed': 'No se pudo copiar.',
    'errDownloadPack': 'No se pudo descargar{{http}}: {{detail}}',
    'downloadLinkUnavailable': 'Enlace de descarga no disponible',
    'downloadStartedHint': 'Descarga iniciada. Si no ocurre nada, permita las descargas en el navegador.',
    'errDownloadApp': 'No se pudo descargar la aplicación{{http}}: {{detail}}',
    'agentExeDownloaded': 'Agente de Windows descargado correctamente.',
    'errDownloadAgent': 'No se pudo descargar el agente{{http}}: {{detail}}',
    'packDownloaded': 'Paquete del agente descargado correctamente.',
    'securityTitle': 'Seguridad de la impresora de red',
    'securityBody': 'No olvide cambiar la contraseña de administrador por defecto (admin/admin) y desactivar TELNET y FTP desde la interfaz web de la impresora',
    'securityNoInternet': 'Nunca exponga el puerto 9100 a Internet.',
    'downloadsTitle': 'Descargas e instaladores',
    'downloadsDesc': 'Acceso directo a los ZIP de Windows, al agente de impresión y a la página de reemplazo en vivo.',
    'openInstallers': 'Abrir instaladores',
    'loading': 'Cargando...',
    'bixolonSection': 'Bixolon - etiquetas QR',
    'fieldPrinterName': 'Nombre de la impresora',
    'fieldIp': 'Dirección IP',
    'fieldPortRaw': 'Puerto (socket RAW)',
    'fieldIpMethod': 'Método IP',
    'ipMethodManual': 'Manual (IP fija)',
    'ipMethodDhcp': 'DHCP',
    'fieldSubnet': 'Subred',
    'fieldGateway': 'Puerta de enlace',
    'fieldDns': 'DNS',
    'fieldProtocol': 'Protocolo de impresión',
    'fieldDefaultLabelFormat': 'Formato de etiqueta predeterminado',
    'printerActive': 'Impresora activa',
    'testConnection': 'Probar conexión',
    'lastTest': 'Última prueba: {{date}}',
    'epsonSection': 'Epson - tickets de caja',
    'epsonDesc': 'Estos valores se usan para los tickets de 80 mm. El agente de Windows lee esta configuración y luego envía el ticket a la impresora Epson de la tienda.',
    'fieldTicketIp': 'Dirección IP de Epson',
    'fieldTicketPort': 'Puerto de Epson',
    'fieldTicketProtocol': 'Protocolo de ticket',
    'ticketProtoEscpos': 'ESC/POS (Epson)',
    'ticketProtoZplFallback': 'ZPL (alternativa)',
    'agentSection': 'Agente local',
    'agentDesc': 'El agente local se ejecuta en un equipo de la LAN, recibe los trabajos mediante sondeo (polling) y envía las etiquetas Bixolon o los tickets Epson a las impresoras configuradas. El token de API se usa para autenticarse como agente.',
    'tokenCopyNow': 'Token (cópielo ahora; no se volverá a mostrar):',
    'agentTokenLabel': 'Token del agente',
    'tokenCreated': '(creado)',
    'tokenNotGenerated': '(no generado)',
    'noToken': '— sin token —',
    'hide': 'Ocultar',
    'show': 'Mostrar',
    'copy': 'Copiar',
    'regenerateToken': 'Regenerar token',
    'generateToken': 'Generar token',
    'agentWinTitle': 'Agente local de Windows',
    'agentWinDesc': 'Descargue el agente listo para ejecutar, o el paquete zip si necesita reconstruir el agente en un equipo Windows.',
    'directLinks': 'Enlaces directos',
    'dlDesktopApp': 'Aplicación Windows para el personal',
    'dlAgentExe': 'Agente de Windows (.exe)',
    'dlAgentPack': 'Paquete del agente (.zip)',
    'tempLinksNote': 'Enlaces temporales firmados automáticamente. Caducan al cabo de unos minutos.',
    'downloading': 'Descargando...',
    'dlAgentExeBtn': 'Descargar el agente de Windows (.exe)',
    'dlAgentPackBtn': 'Descargar el paquete del agente (.zip)',
    'desktopAppDesc': 'Descargue la aplicación de escritorio R.E.Mobiles ya compilada. Inicia el frontend local, el backend local y el agente de impresión incluido.',
    'dlDesktopAppBtn': 'Descargar la aplicación de Windows (.zip)',
    'printedFields': 'Campos impresos',
    'fieldFontSize': 'Tamaño de fuente (6-16)',
    'fieldMargin': 'Margen (0-24 pt)',
    'previewPdf': 'Vista previa PDF',
    'previewDesc': 'Generar una etiqueta PDF de prueba para una reparación existente.',
    'previewRefPlaceholder': 'Ref REM-XXX',
    'previewBtn': 'Vista previa',
    'save': 'Guardar',
    'reload': 'Recargar',
    'errUnknown': 'Error desconocido',
    'adminPertes.title': 'Pérdidas',
    'adminPertes.subtitle': 'Ventas fuera de stock cobradas por debajo del precio de catálogo y descuentos por encima del umbral autorizado, por vendedor.',
    'adminPertes.exportCsv': 'Exportar CSV',
    'adminPertes.recalcul': 'Recalcular sobre el historial',
    'adminPertes.typeHorsStock': 'Fuera de stock bajo precio',
    'adminPertes.typeRemise': 'Descuento excesivo',
    'adminPertes.typeSousCatalogue': 'Precio bajo catálogo',
    'adminPertes.preset30j': '30 d',
    'adminPertes.preset3m': '3 meses',
    'adminPertes.preset12m': '12 meses',
    'adminPertes.presetCustom': 'Personalizado',
    'adminPertes.payCb': 'Tarjeta bancaria',
    'adminPertes.payCash': 'Efectivo',
    'adminPertes.payCheque': 'Cheque',
    'adminPertes.payVirement': 'Transferencia',
    'adminPertes.payMixte': 'Mixto',
    'adminPertes.payAvoir': 'Vale',
    'adminPertes.payAcompte': 'Anticipo',
    'adminPertes.periode': 'Período: {{debut}} → {{fin}}',
    'adminPertes.du': 'Desde',
    'adminPertes.au': 'Hasta',
    'adminPertes.vendeur': 'Vendedor',
    'adminPertes.type': 'Tipo',
    'adminPertes.magasin': 'Tienda',
    'adminPertes.tous': 'Todos',
    'adminPertes.tileTotal': 'Pérdida total',
    'adminPertes.calculeLe': 'Calculado el {{date}}',
    'adminPertes.remisesExcessives': 'Descuentos excesivos',
    'adminPertes.auDelaDe': 'Más allá del {{pct}}',
    'adminPertes.tileNb': 'Ventas afectadas',
    'adminPertes.parVendeur': 'Por vendedor',
    'adminPertes.loading': 'Cargando…',
    'adminPertes.aucunePerte': 'Sin pérdidas en el período.',
    'adminPertes.colTotal': 'Total',
    'adminPertes.colNbVentes': 'N.º ventas',
    'adminPertes.filtrerVendeur': 'Filtrar el detalle por este vendedor',
    'adminPertes.detailTitle': 'Detalle de ventas',
    'adminPertes.pageRange': '{{from}}–{{to}} de {{total}}',
    'adminPertes.pageN': 'Página {{page}}',
    'adminPertes.aucuneLigne': 'No hay filas para estos filtros.',
    'adminPertes.colDate': 'Fecha',
    'adminPertes.colTicket': 'Ticket',
    'adminPertes.colArticle': 'Artículo',
    'adminPertes.colQte': 'Cant.',
    'adminPertes.colPrixVendu': 'Precio vendido',
    'adminPertes.colPrixRef': 'Precio ref.',
    'adminPertes.colRemise': 'Descuento',
    'adminPertes.colPerte': 'Pérdida',
    'adminPertes.trierPerte': 'Ordenar por pérdida',
    'adminPertes.colStatut': 'Estado',
    'adminPertes.colActions': 'Acciones',
    'adminPertes.ticket': 'Ticket',
    'adminPertes.ouvrirTicket': 'Abrir el ticket de caja (PDF) en una nueva pestaña',
    'adminPertes.voirVente': 'Ver la venta',
    'adminPertes.masquerVente': 'Ocultar el contenido de la venta',
    'adminPertes.voirVenteTitle': 'Ver qué se vendió en este ticket',
    'adminPertes.venteLabel': 'Venta',
    'adminPertes.paiement': 'Pago:',
    'adminPertes.contenuIndispo': 'Contenido de la venta no disponible para este ticket (abra el ticket PDF).',
    'adminPertes.ligneEnPerte': '(línea con pérdida)',
    'adminPertes.totalVente': 'Total venta:',
    'adminPertes.precedent': 'Anterior',
    'adminPertes.suivant': 'Siguiente',
    'adminPertes.lignesParPage': '{{count}} filas por página',
    'adminPertes.legendeTitle': 'Cómo se calculan las pérdidas',
    'adminPertes.legendeHorsStockText': 'Venta «fuera de stock» cobrada por debajo del precio de catálogo aunque el artículo existía en la base en el momento de la venta. Pérdida =',
    'adminPertes.legendeHorsStockFormula': '(precio de referencia − precio vendido) × cantidad',
    'adminPertes.legendeRemiseText': 'Descuento superior al {{seuil}} en una línea de venta. Solo se cuenta la parte por encima del {{seuil}}:',
    'adminPertes.legendeRemiseFormula': '(descuento − {{seuil}}) × precio de referencia × cantidad',
    'adminPertes.legendeSousCatalogue': 'Artículo en stock vendido por debajo del precio de catálogo sin descuento declarado: misma fórmula que «fuera de stock bajo precio».',
    'adminPertes.legendeFooter': 'El precio de referencia es el precio de catálogo del artículo en la fecha de la venta. «Recalcular sobre el historial» vuelve a leer todas las ventas pasadas; la vista actual se almacena en caché y se actualiza automáticamente.',
    'adminPertes.confirmRecalcul': '¿Recalcular las pérdidas sobre todo el historial de ventas? Esta operación vuelve a leer todas las ventas pasadas y puede tardar unos instantes.',
    'adminPertes.recalculDone': 'Recálculo completado — {{count}} venta(s) analizada(s)',
    'adminPertes.recalculDoneGeneric': 'Recálculo completado sobre todo el historial',
    'adminPertes.recalculFail': 'Error al recalcular',
    'adminPertes.exportDone': 'Exportación CSV descargada',
    'adminPertes.exportUnavailable': 'Exportación no disponible (backend por actualizar)',
    'adminPertes.exportFail': 'Error en la exportación',
    'adminPertes.refManquante': 'Falta la referencia de venta: ticket no encontrado',
    'adminPertes.ticketFail': 'No se pudo abrir el ticket',
    'adminPertes.endpointIndispo': 'Endpoint «Pérdidas» no disponible (backend por actualizar).',
    'adminPertes.errLoad': 'Error de carga',
    'adminPertes.ticketTooltipRef': 'Ticket {{ref}}',
    'adminPertes.lignes_one': '{{count}} fila',
    'adminPertes.lignes_other': '{{count}} filas',
    'adminPertes.articles_one': '{{count}} artículo',
    'adminPertes.articles_other': '{{count}} artículos',
    'adminPertes.autres_one': '(+{{count}} más)',
    'adminPertes.autres_other': '(+{{count}} más)',
    'adminTodo.cat.ventesHorsStock': 'Ventas sin stock por confirmar',
    'adminTodo.cat.cadbotPrix': 'Precios CADBOT por validar',
    'adminTodo.cat.devisChat': 'Presupuestos del chat por procesar',
    'adminTodo.cat.acomptesACommander': 'Anticipos → piezas por pedir',
    'adminTodo.cat.commandesSansSuivi': 'Pedidos sin número de seguimiento',
    'adminTodo.cat.sumupAConfirmer': 'Pagos SumUp por confirmar',
    'adminTodo.cat.factureRequests': 'Solicitudes de factura',
    'adminTodo.groupFallback': 'Grupo',
    'adminTodo.time.now': 'ahora mismo',
    'adminTodo.time.minutesAgo': 'hace {{n}} min',
    'adminTodo.time.hoursAgo': 'hace {{n}} h',
    'adminTodo.error.endpointUnavailable': 'Endpoint «Tareas» no disponible (hay que actualizar el backend).',
    'adminTodo.error.load': 'Error de carga',
    'adminTodo.settings.unavailable': 'Ajustes no disponibles (hay que actualizar el backend).',
    'adminTodo.settings.notLoaded': 'Ajustes no cargados',
    'adminTodo.settings.saved': 'Ajustes guardados',
    'adminTodo.settings.saveError': 'No se pudieron guardar los ajustes',
    'adminTodo.title': 'Tareas',
    'adminTodo.subtitleUpdated': 'Actualizado a las {{time}} · actualización automática cada 60 s',
    'adminTodo.subtitleDefault': 'Todo lo que requiere acción, en un solo lugar.',
    'adminTodo.notifications': 'Notificaciones',
    'adminTodo.refresh': 'Actualizar',
    'adminTodo.settings.saving': 'Guardando…',
    'adminTodo.settings.loading': 'Cargando ajustes…',
    'adminTodo.settings.pushLabel': 'Notificación push en el teléfono',
    'adminTodo.settings.pushHint': 'Una alerta en cuanto aparece una nueva acción.',
    'adminTodo.settings.digestLabel': 'Resumen diario a las 9 h',
    'adminTodo.settings.digestHint': 'Un único mensaje cada mañana con todo lo que queda por hacer.',
    'adminTodo.settings.categoriesTracked': 'Categorías seguidas',
    'adminTodo.allClear': 'Nada pendiente. Todo está al día.',
    'adminTodo.groupNothingPending': 'Nada pendiente',
    'adminTodo.open': 'Abrir',
    'adminTodo.seeAll': 'Ver los {{count}} elementos',
    'adminTodo.openPage': 'Abrir la página',
    'adminTodo.pushOn': 'Push activado',
    'adminTodo.pushOff': 'Push desactivado',
    'adminTodo.digestOn': 'Resumen 9 h activado',
    'adminTodo.digestOff': 'Resumen 9 h desactivado',
    'adminUsers.role.super_admin.label': 'Superadministrador',
    'adminUsers.role.super_admin.desc': 'Acceso completo a todo el sistema (solo carlos)',
    'adminUsers.role.admin_magasin.label': 'Administrador de tienda',
    'adminUsers.role.admin_magasin.desc': 'Gestiona una o varias tiendas asignadas',
    'adminUsers.role.technicien.label': 'Técnico de posventa',
    'adminUsers.role.technicien.desc': 'Tickets de posventa de las 2 tiendas. Sin POS, sin contabilidad.',
    'adminUsers.role.vendeur.label': 'Vendedor',
    'adminUsers.role.vendeur.desc': 'POS en todas las tiendas. Sin contabilidad, sin administración.',
    'adminUsers.roleUnknown': 'desconocido',
    'adminUsers.modal.editTitle': 'Editar {{username}}',
    'adminUsers.createUser': 'Crear un usuario',
    'adminUsers.field.username': 'Nombre de usuario',
    'adminUsers.field.passwordEdit': 'Nueva contraseña (dejar vacío para conservar)',
    'adminUsers.field.passwordCreate': 'Contraseña * (mín. {{min}} car.)',
    'adminUsers.field.email': 'Correo electrónico',
    'adminUsers.field.telephone': 'Teléfono',
    'adminUsers.field.role': 'Rol en tienda',
    'adminUsers.field.assignedMagasins': 'Tiendas asignadas',
    'adminUsers.modal.minOneRequired': '(mín. 1 requerida)',
    'adminUsers.modal.ignoredForRole': '— Se guarda pero se ignora para este rol (alcance = todas las tiendas)',
    'adminUsers.modal.loadingMagasins': 'Cargando tiendas…',
    'adminUsers.modal.posOnlyTitle': 'Ausente / suspensión — solo POS',
    'adminUsers.modal.posOnlyDesc': 'Puede iniciar sesión y cobrar en el POS, sin acceso a las demás páginas (reparaciones, inventario, clientes, administración…).',
    'adminUsers.action.cancel': 'Cancelar',
    'adminUsers.action.save': 'Guardar',
    'adminUsers.action.create': 'Crear',
    'adminUsers.denied.title': 'Acceso denegado',
    'adminUsers.denied.desc': 'Esta página está reservada para el superadministrador.',
    'adminUsers.denied.back': 'Volver al panel',
    'adminUsers.error.load': 'Error de carga',
    'adminUsers.error.passwordMin': 'La contraseña debe contener al menos {{min}} caracteres.',
    'adminUsers.feedback.updated': 'Usuario {{username}} actualizado.',
    'adminUsers.feedback.created': 'Usuario {{username}} creado.',
    'adminUsers.error.operation': 'Error durante la operación',
    'adminUsers.error.needsMagasinPick': 'Elija primero una tienda de sesión (ventana en el centro de la pantalla) y luego cree el usuario.',
    'adminUsers.feedback.disabled': '{{username}} desactivado.',
    'adminUsers.feedback.enabled': '{{username}} reactivado.',
    'adminUsers.error.generic': 'Error',
    'adminUsers.action.back': 'Volver',
    'adminUsers.title': 'Usuarios internos',
    'adminUsers.subtitle': 'Creación / modificación / desactivación (solo superadministrador)',
    'adminUsers.limitInfo': '{{current}}/{{max}} usuarios · Plan {{plan}}',
    'adminUsers.limitReachedTitle': 'Límite alcanzado (máx. {{max}} usuarios)',
    'adminUsers.limitReached': 'Límite alcanzado ({{max}})',
    'adminUsers.includeDisabled': 'Incluir usuarios desactivados',
    'adminUsers.col.role': 'Rol',
    'adminUsers.col.emailTel': 'Correo / Tel.',
    'adminUsers.col.status': 'Estado',
    'adminUsers.col.actions': 'Acciones',
    'adminUsers.empty': 'Ningún usuario.',
    'adminUsers.allMagasins': 'todas',
    'adminUsers.status.active': 'Activo',
    'adminUsers.status.disabled': 'Desactivado',
    'adminUsers.status.posOnly': 'Ausente · solo POS',
    'adminUsers.action.edit': 'Editar',
    'adminUsers.commissions': 'Comisiones',
    'adminUsers.action.disable': 'Desactivar',
    'adminUsers.action.enable': 'Reactivar',
    'adminHorsStock.stockUnknown': 'stock desconocido',
    'adminHorsStock.stockCount': 'stock {{count}}',
    'adminHorsStock.selected': 'Seleccionado',
    'adminHorsStock.lineDefaultDesignation': 'Artículo',
    'adminHorsStock.loadError': 'Error de carga',
    'adminHorsStock.lineStillUnresolved': 'Una línea sigue en «Por verificar» o sin referencia vinculada.',
    'adminHorsStock.saleValidatedWithLoss': 'Venta {{ref}} validada — {{total}} en el historial. Pérdida registrada: {{loss}}.',
    'adminHorsStock.saleValidatedNoLoss': 'Venta {{ref}} validada — {{total}} en el historial, sin pérdida.',
    'adminHorsStock.validationFailed': 'Validación imposible',
    'adminHorsStock.catalogBadge': 'Catálogo',
    'adminHorsStock.cashedLineInfo': 'cobrado {{qty}} × {{price}}',
    'adminHorsStock.horsStockBadge': 'Sin stock',
    'adminHorsStock.articleExistedQuestion': '¿El artículo existía?',
    'adminHorsStock.optionLoss': 'Pérdida — el artículo existía, vincular la referencia',
    'adminHorsStock.optionNonExistent': 'Artículo inexistente — aceptar tal cual',
    'adminHorsStock.optionToVerify': 'Por verificar',
    'adminHorsStock.attachedArticle': 'Artículo vinculado',
    'adminHorsStock.refLabel': 'Ref. {{ref}}',
    'adminHorsStock.catalogPriceLabel': 'Precio de catálogo',
    'adminHorsStock.unknown': 'desconocido',
    'adminHorsStock.soldLabel': 'vendido',
    'adminHorsStock.estimatedLoss': 'Pérdida estimada',
    'adminHorsStock.selectCatalogRef': 'Seleccione la referencia del catálogo correspondiente a este artículo.',
    'adminHorsStock.catalogSuggestions': 'Sugerencias del catálogo',
    'adminHorsStock.noSuggestion': 'Sin sugerencias para esta línea — use la búsqueda de abajo.',
    'adminHorsStock.otherCatalogArticle': 'Otro artículo del catálogo',
    'adminHorsStock.searchPlaceholder': 'Buscar referencia / descripción / EAN…',
    'adminHorsStock.noArticleFound': 'No se encontró ningún artículo.',
    'adminHorsStock.freeArticleInfo': 'Artículo libre: la línea se conserva tal cual, sin vinculación ni movimiento de stock.',
    'adminHorsStock.toVerifyInfo': 'Bloquea la validación mientras la línea no se decida (Sí / No).',
    'adminHorsStock.toValidateBadge': 'Por validar',
    'adminHorsStock.cashedBadge': 'Cobrada',
    'adminHorsStock.cashedAmountLabel': 'Cobrado',
    'adminHorsStock.subtotal': 'Subtotal',
    'adminHorsStock.discountLabel': 'Descuento',
    'adminHorsStock.historyTotal': 'Total del historial',
    'adminHorsStock.amountLockedInfo': 'Importe realmente cobrado: precio, cantidades y descuento no se pueden modificar aquí.',
    'adminHorsStock.lossesPreview': 'Vista previa de pérdidas (visible solo para la dirección)',
    'adminHorsStock.remiseExcessiveLabel': 'Descuento por encima del {{seuil}} % ({{pct}} concedidos)',
    'adminHorsStock.lossRecorded': 'Pérdida registrada',
    'adminHorsStock.lossSavedInfo': 'Se registra en la página Pérdidas al validar.',
    'adminHorsStock.noLossYet': 'Ninguna pérdida registrada en esta etapa',
    'adminHorsStock.noLossYetSuffix': ' — el cálculo se completa una vez vinculadas las referencias.',
    'adminHorsStock.noteLabel': 'Nota (opcional)',
    'adminHorsStock.notePlaceholder': 'Ej. precio negociado, artículo recibido el…',
    'adminHorsStock.validateButton': 'Validar y escribir en el historial',
    'adminHorsStock.blockedTitle': 'Una o más líneas sin stock aún deben decidirse',
    'adminHorsStock.validationBlocked': 'Validación bloqueada:',
    'adminHorsStock.blockedVerifierCount': '{{n}} línea(s) «Por verificar»',
    'adminHorsStock.blockedNoRefCount': '{{n}} línea(s) «Sí» sin referencia vinculada',
    'adminHorsStock.legendTitle': 'Qué ocurre',
    'adminHorsStock.legendIntro': 'La venta ya está cobrada: no se puede anular y el stock no se modifica. La validación vincula el artículo correcto, registra la diferencia de precio o el descuento excesivo en las pérdidas y luego escribe la venta en el historial.',
    'adminHorsStock.legendYesWord': 'Sí',
    'adminHorsStock.legendYesDesc': '— el artículo existía: seleccione la referencia del catálogo (sugerencias o búsqueda).',
    'adminHorsStock.legendNonWord': 'No',
    'adminHorsStock.legendNonDesc': '— artículo libre, conservado tal cual.',
    'adminHorsStock.legendVerifierDesc': '— bloquea la validación mientras la línea no se decida.',
    'adminHorsStock.legendPertesWord': 'Pérdidas',
    'adminHorsStock.legendPertesDesc': '— diferencia entre el precio de catálogo y el precio vendido, más la parte del descuento por encima del {{seuil}} % del subtotal; visible solo aquí y registrada en la página Pérdidas.',
    'adminHorsStock.pageTitle': 'Ventas sin stock por validar',
    'adminHorsStock.pageSubtitle': 'Ya cobradas; ausentes del historial hasta su validación por la dirección.',
    'adminHorsStock.refresh': 'Actualizar',
    'adminHorsStock.emptyState': 'No hay ventas sin stock pendientes de validación.',
    'adminHorsStock.processedThisSession': 'Procesadas en esta sesión',
    'adminHorsStock.lossShortLabel': 'pérdida',
    'adminHorsStock.validatedBadge': 'Validada',
    'stockPhotoAi.title': 'Fotos de stock · IA',
    'stockPhotoAi.subtitle': 'Superadministrador Carlos · generación OpenAI · tienda aislada M1/M2',
    'stockPhotoAi.apiKeysLink': 'Claves API de OpenAI',
    'stockPhotoAi.statsTotal': 'Artículos {{mag}}',
    'stockPhotoAi.statsWithPhoto': 'Con foto',
    'stockPhotoAi.statsMissing': 'Sin foto',
    'stockPhotoAi.searchPlaceholder': 'Buscar ref o designación…',
    'stockPhotoAi.filter': 'Filtrar',
    'stockPhotoAi.generateBatch': 'Generar lote (máx. 10)',
    'stockPhotoAi.batchResult': 'Lote {{mag}}: {{ok}} OK · {{skipped}} omitidos · {{errors}} errores',
    'stockPhotoAi.loading': 'Cargando…',
    'stockPhotoAi.stockLabel': 'Stock {{qty}}',
    'stockPhotoAi.generateOne': 'Generar IA',
    'stockPhotoAi.empty': 'Ningún artículo sin foto para {{mag}}',
    'stockPhotoAi.errorLoad': 'No se pudo cargar',
    'stockPhotoAi.errorGenerate': 'Falló la generación',
    'stockPhotoAi.errorBatch': 'Falló el lote',
    'stockPhotoAi.confirmBatch': '¿Generar hasta {{max}} imágenes IA para {{mag}}? (OpenAI · coste de API)',
    'stockCatAudit.title': 'Auditoría de categorías de stock',
    'stockCatAudit.subtitle': 'Análisis completo teléfono vs pieza/accesorio · reservado a Carlos',
    'stockCatAudit.backToIntegrations': 'Integraciones admin',
    'stockCatAudit.magasin': 'Tienda',
    'stockCatAudit.allStores': 'Todas',
    'stockCatAudit.issuesOnly': 'Solo filas con problemas',
    'stockCatAudit.runAnalysis': 'Ejecutar análisis',
    'stockCatAudit.statTotal': 'Total',
    'stockCatAudit.statWithIssues': 'Con problemas',
    'stockCatAudit.statFalseImei': 'IMEI falso',
    'stockCatAudit.statNeedsImei': 'IMEI requerido',
    'stockCatAudit.statCategorieMismatch': 'Cat. diferente',
    'stockCatAudit.statCategorieMissing': 'Cat. vacía',
    'stockCatAudit.statAmbiguous': 'Ambiguo',
    'stockCatAudit.currentCategories': 'Categorías actuales',
    'stockCatAudit.suggestedCategories': 'Categorías sugeridas',
    'stockCatAudit.searchPlaceholder': 'Ref, designación, categoría…',
    'stockCatAudit.allFilters': 'Todos los filtros',
    'stockCatAudit.applySuggested': 'Aplicar cat. sugerida ({{count}})',
    'stockCatAudit.colRef': 'Ref',
    'stockCatAudit.colDesignation': 'Designación',
    'stockCatAudit.colMag': 'Tienda',
    'stockCatAudit.colCurrentCat': 'Cat. actual',
    'stockCatAudit.colSuggestedCat': 'Cat. sugerida',
    'stockCatAudit.colType': 'Tipo',
    'stockCatAudit.colIssues': 'Problemas',
    'stockCatAudit.typePhone': 'Tel.',
    'stockCatAudit.typePiece': 'Pieza',
    'stockCatAudit.analyzing': 'Analizando…',
    'stockCatAudit.emptyRows': 'Ninguna fila — ejecuta el análisis o amplía los filtros.',
    'stockCatAudit.hint': 'Ej. «Soporte de teléfono» ahora se clasifica como Accesorio (sin IMEI). Los teléfonos completos reales siguen sujetos al IMEI en el inventario.',
    'stockCatAudit.errorAnalyze': 'Análisis imposible',
    'stockCatAudit.errorApply': 'Aplicación fallida',
    'stockCatAudit.confirmApply': '¿Aplicar la categoría sugerida a {{count}} artículo(s)?',
    'stockCatAudit.issueFalsePhoneImei': 'Falso teléfono (IMEI por error)',
    'stockCatAudit.issueNeedsImei': 'Teléfono — IMEI requerido',
    'stockCatAudit.issueCategorieMismatch': 'Categoría diferente',
    'stockCatAudit.issueCategorieMissing': 'Categoría faltante',
    'stockCatAudit.issueAmbiguous': 'Ambiguo',
    'stockHist.periodToday': 'Hoy',
    'stockHist.periodYesterday': 'Ayer',
    'stockHist.periodWeek': 'Esta semana',
    'stockHist.periodMonth': 'Este mes',
    'stockHist.title': 'Historial de stock',
    'stockHist.subtitle': 'Movimientos de tienda y almacén',
    'stockHist.statMovements': 'Movimientos',
    'stockHist.statPieces': 'Piezas',
    'stockHist.locationShop': 'Tienda',
    'stockHist.locationWarehouse': 'Almacén',
    'stockHist.empty': 'No hay adiciones para este período',
    'stockHist.colDateTime': 'Fecha / Hora',
    'stockHist.colDesignation': 'Artículo',
    'stockHist.colStore': 'Sucursal',
    'stockHist.colLocation': 'Ubicación',
    'stockHist.colQty': 'Cant.',
    'stockHist.colSalePrice': 'P. venta',
    'stockHist.colBy': 'Por',
    'stockHist.statusNew': 'Nuevo',
    'stockHist.statusRestock': 'Reposición',
    'stockHist.selectedOne': 'seleccionado',
    'stockHist.selectedMany': 'seleccionados',
    'stockHist.labelOne': 'etiqueta',
    'stockHist.labelMany': 'etiquetas',
    'stockHist.printCount': 'Imprimir ({{count}})',
    'partsOrders.statusPending': 'Pendiente',
    'partsOrders.statusPartial': 'Parcial',
    'partsOrders.statusReceived': 'Recibida',
    'partsOrders.statusCancelled': 'Anulada',
    'partsOrders.filterAll': 'Todas',
    'partsOrders.filterReceived': 'Recibidas',
    'partsOrders.filterCancelled': 'Anuladas',
    'partsOrders.partTypeStandard': 'Estándar',
    'partsOrders.partTypeSpare': 'Pieza de repuesto',
    'partsOrders.partTypeSerialized': 'Serializado (n.º de serie/IMEI)',
    'partsOrders.createTitle': 'Nuevo pedido a proveedor',
    'partsOrders.supplier': 'Proveedor',
    'partsOrders.supplierPlaceholder': 'Nombre del proveedor',
    'partsOrders.line': 'Línea {{num}}',
    'partsOrders.designationPlaceholder': 'Descripción *',
    'partsOrders.referencePlaceholder': 'Referencia (opcional)',
    'partsOrders.type': 'Tipo',
    'partsOrders.qty': 'Cant.',
    'partsOrders.purchasePriceUnit': 'Precio compra U.',
    'partsOrders.expectedSalePrice': 'Precio venta previsto',
    'partsOrders.category': 'Categoría',
    'partsOrders.categoryPlaceholder': 'Ej.: Pantalla, Batería',
    'partsOrders.location': 'Ubicación',
    'partsOrders.locationShop': 'Tienda',
    'partsOrders.locationWarehouse': 'Almacén',
    'partsOrders.addLine': 'Añadir una línea',
    'partsOrders.notes': 'Notas',
    'partsOrders.errorNeedLine': 'Añada al menos una línea con una descripción.',
    'partsOrders.errorCreate': 'Error al crear.',
    'partsOrders.cancel': 'Cancelar',
    'partsOrders.creating': 'Creando…',
    'partsOrders.create': 'Crear pedido',
    'partsOrders.receiveTitle': 'Recepción — {{ref}}',
    'partsOrders.allReceived': 'Todas las líneas ya se han recibido.',
    'partsOrders.remaining': 'Quedan {{count}}',
    'partsOrders.receivedQty': 'Cant. recibida',
    'partsOrders.serialsLabel': 'N.º de serie / IMEI (uno por línea o separados por comas)',
    'partsOrders.errorNeedQty': 'Indique al menos una cantidad recibida.',
    'partsOrders.errorReceive': 'Error al recibir.',
    'partsOrders.close': 'Cerrar',
    'partsOrders.validating': 'Validando…',
    'partsOrders.validateReceive': 'Validar la recepción',
    'partsOrders.linkTitle': 'Asignar a una reparación',
    'partsOrders.linkDescription': 'La pieza «{{designation}}» se integrará en el precio de la reparación sin descontarse del stock (aún no recibida).',
    'partsOrders.linkRefPlaceholder': 'Ref. reparación (ej.: REP-000123)',
    'partsOrders.errorNeedRef': 'Introduzca la referencia de la reparación.',
    'partsOrders.errorRepairNotFound': 'Error: ¿reparación no encontrada?',
    'partsOrders.assign': 'Asignar',
    'partsOrders.confirmCancel': '¿Anular este pedido? Las piezas vinculadas a reparaciones se desvincularán.',
    'partsOrders.errorCancel': 'Error de anulación.',
    'partsOrders.errorGeneric': 'Error.',
    'partsOrders.supplierUnknown': '¿Proveedor?',
    'partsOrders.linesCount': '{{count}} línea(s)',
    'partsOrders.receivedCount': '{{received}}/{{total}} recibido',
    'partsOrders.purchaseCost': 'coste compra',
    'partsOrders.colDesignation': 'Descripción',
    'partsOrders.colReceivedQty': 'Recibido/Cant.',
    'partsOrders.colPurchaseUnit': 'Compra U.',
    'partsOrders.colSalePlanned': 'Venta prevista',
    'partsOrders.colRepair': 'Reparación',
    'partsOrders.colAction': 'Acción',
    'partsOrders.typeSerialized': 'Serializado',
    'partsOrders.typeSpareShort': 'Pieza',
    'partsOrders.typeStandardShort': 'Est.',
    'partsOrders.detach': 'Desvincular',
    'partsOrders.receive': 'Recibir',
    'partsOrders.pageTitle': 'Pedidos de piezas',
    'partsOrders.pageSubtitle': 'Aprovisionamiento de proveedores — preasignación a reparación y recepción',
    'partsOrders.filterAllStores': 'Todos',
    'partsOrders.refresh': 'Actualizar',
    'partsOrders.newOrder': 'Nuevo pedido',
    'partsOrders.kpiOpenOrders': 'Pedidos abiertos',
    'partsOrders.kpiAssignedParts': 'Piezas asignadas a repar.',
    'partsOrders.kpiCostToReceive': 'Coste por recibir',
    'partsOrders.loading': 'Cargando…',
    'partsOrders.empty': 'No hay pedidos de piezas.',
    'stockForm.editTitle': 'Editar artículo',
    'stockForm.addTitle': 'Agregar artículo',
    'stockForm.productSheet': 'Ficha de producto',
    'stockForm.newStockProduct': 'Nuevo producto de stock',
    'stockForm.analyzePhoto': 'Analizar foto',
    'stockForm.scan': 'Escanear',
    'stockForm.supplierSearch': 'Búsqueda de proveedor',
    'stockForm.supplierSearchPlaceholder': 'Referencia, EAN o nombre de pieza…',
    'stockForm.refShort': 'Ref.:',
    'stockForm.priceLabel': 'Precio:',
    'stockForm.sectionArticle': 'Sección artículo',
    'stockForm.reference': 'Referencia',
    'stockForm.ean': 'EAN',
    'stockForm.eanPlaceholder': 'Código de barras',
    'stockForm.category': 'Categoría',
    'stockForm.categoryPlaceholder': 'Pantallas, baterías…',
    'stockForm.designation': 'Descripción',
    'stockForm.supplier': 'Proveedor',
    'stockForm.sectionStock': 'Sección stock',
    'stockForm.location': 'Ubicación',
    'stockForm.shop': 'Tienda',
    'stockForm.depot': 'Almacén',
    'stockForm.both': 'Ambos',
    'stockForm.qtyShop': 'Cant. tienda',
    'stockForm.qtyDepot': 'Cant. almacén',
    'stockForm.alertThreshold': 'Umbral de alerta',
    'stockForm.sectionPricing': 'Sección tarifas',
    'stockForm.purchasePrice': 'Precio de compra (sin IVA)',
    'stockForm.salePrice': 'Precio de venta (€)',
    'stockForm.margin': 'Margen',
    'stockForm.sectionShop': 'Sección tienda',
    'stockForm.visibleOnline': 'Visible en la tienda en línea',
    'stockForm.visibleOnlineHint': 'Los clientes podrán comprar este artículo',
    'stockForm.cancel': 'Cancelar',
    'stockForm.saving': 'Guardando…',
    'stockForm.edit': 'Modificar',
    'stockForm.addToStock': 'Agregar al stock',
    'stockForm.save': 'Guardar',
    'stockForm.reviewTitle': 'Verificación del artículo',
    'stockForm.newArticle': 'Nuevo artículo',
    'stockForm.existingBanner': 'Existente — {{designation}} (T:{{qb}} A:{{qd}}). Cantidad agregada al stock.',
    'stockForm.imeiRequired': 'IMEI obligatorio para registrar un teléfono en stock.',
    'stockForm.imeiInvalid': 'IMEI inválido (14 a 20 dígitos).',
    'stockForm.articleNotFound': 'Artículo no encontrado',
    'stockForm.imeiNotRegistered': 'IMEI no registrado — verifique el número o Stock avanzado > IMEI.',
    'stockForm.imeiFirstRegistered': 'Primer IMEI registrado. {{count}} dispositivo(s) restante(s) — complete los IMEI en Stock avanzado > pestaña IMEI (ref. {{ref}}).',
    'stockForm.saveError': 'Error al guardar',
    'clientChat.typeBoutiqueOrder': 'Pedido de tienda',
    'clientChat.typeRepair': 'Reparación',
    'clientChat.typeClient': 'Conversación con el cliente',
    'clientChat.title': 'Chat de clientes',
    'clientChat.convCount': '{{count}} conversación',
    'clientChat.convCountPlural': '{{count}} conversaciones',
    'clientChat.searchPlaceholder': 'Buscar un cliente...',
    'clientChat.noConversations': 'Sin conversaciones de clientes',
    'clientChat.clientFallback': 'Cliente',
    'clientChat.startConversation': 'Inicia la conversación',
    'clientChat.writePlaceholder': 'Escribir al cliente...',
    'clientChat.selectConversation': 'Selecciona una conversación',
    'stockInvImport.errorAiAnalysis': 'Error de análisis IA — verifique Admin > Integraciones API (OpenAI)',
    'stockInvImport.confirmMissingImei': '{{count}} línea(s) de teléfono sin IMEI completo.\n\n¿Continuar la importación? Podrá completarlo en Stock avanzado > IMEI.',
    'stockInvImport.errorImport': 'Error de importación',
    'stockInvImport.locationDepot': 'Almacén',
    'stockInvImport.locationBoutique': 'Tienda',
    'stockInvImport.pageTitle': 'Importación de factura con IA',
    'stockInvImport.pageSubtitle': 'Análisis PDF · cálculos alineados con /calcul',
    'stockInvImport.visionHint': 'OpenAI Vision · redondeo de precios idéntico al módulo Cálculo de margen',
    'stockInvImport.invoiceLabel': 'Factura (PDF o imagen)',
    'stockInvImport.fileSize': '{{size}} KB',
    'stockInvImport.clickToChoose': 'Haga clic para elegir un archivo',
    'stockInvImport.shippingTotalLabel': 'Gastos de envío totales (EUR)',
    'stockInvImport.autoIfEmpty': '— automático si está vacío',
    'stockInvImport.shippingPlaceholder': 'Ej: 29.90',
    'stockInvImport.customsPct': 'Aduana %',
    'stockInvImport.marginPct': 'Margen %',
    'stockInvImport.analyzing': 'Analizando… (15–30 s)',
    'stockInvImport.analyzeInvoice': 'Analizar la factura',
    'stockInvImport.kpiProducts': 'Productos',
    'stockInvImport.kpiSupplier': 'Proveedor',
    'stockInvImport.kpiShippingTotal': 'Envío total',
    'stockInvImport.kpiShippingPerUnit': 'Envío / unidad',
    'stockInvImport.recalc': 'Recalculando…',
    'stockInvImport.phonesCompleteImei': '{{count}} teléfono(s) — complete el IMEI abajo (extraído automáticamente de la factura si está presente).',
    'stockInvImport.colRef': 'Ref.',
    'stockInvImport.colDesignation': 'Descripción',
    'stockInvImport.colQty': 'Cant.',
    'stockInvImport.colPurchase': 'Compra',
    'stockInvImport.colPlusShipping': '+Envío',
    'stockInvImport.colPlusCustoms': '+{{pct}}% Aduana',
    'stockInvImport.colPlusMargin': '+{{pct}}% Margen',
    'stockInvImport.colLabor': 'M.O.',
    'stockInvImport.colFinalPrice': 'Precio final',
    'stockInvImport.remove': 'Quitar',
    'stockInvImport.generateEan': 'Generar EAN',
    'stockInvImport.imeiDevicePlaceholder': 'IMEI del dispositivo {{n}}',
    'stockInvImport.back': 'Volver',
    'stockInvImport.importing': 'Importando…',
    'stockInvImport.confirm': 'Confirmar',
    'stockInvImport.importDone': 'Importación completada',
    'stockInvImport.created': 'Creados',
    'stockInvImport.updated': 'Actualizados',
    'stockInvImport.imeiRegistered': 'IMEI registrados',
    'stockInvImport.errors': 'Errores',
    'stockInvImport.imeiMissingTitle': 'IMEI faltantes — completar en Stock avanzado',
    'stockInvImport.missingOfTotal': '{{missing}} faltante(s) / {{total}}',
    'stockInvImport.newImport': 'Nueva importación',
    'stockInvImport.backToStock': 'Volver al stock',
    'clientPwd.pinGenerated': 'PIN generado para {{nom}}: {{pin}}',
    'clientPwd.error': 'Error',
    'clientPwd.errorSendEmail': 'Error al enviar el correo',
    'clientPwd.errorSendBulk': 'Error al enviar en masa',
    'clientPwd.bulkResult': '{{sent}} correos enviados, {{errors}} errores',
    'clientPwd.totalClients': '{{total}} clientes en total',
    'clientPwd.sending': 'Enviando...',
    'clientPwd.sendToClients': 'Enviar a {{count}} clientes',
    'clientPwd.searchPlaceholder': 'Buscar por nombre, teléfono, correo...',
    'clientPwd.filterAll': 'Todos',
    'clientPwd.filterSent': 'Contraseña enviada',
    'clientPwd.filterNotSent': 'Contraseña no enviada',
    'clientPwd.colName': 'Nombre',
    'clientPwd.colPhone': 'Teléfono',
    'clientPwd.colEmail': 'Correo',
    'clientPwd.colPin': 'PIN',
    'clientPwd.colStatus': 'Estado',
    'clientPwd.colActions': 'Acciones',
    'clientPwd.loading': 'Cargando...',
    'clientPwd.noEmail': 'Sin correo',
    'clientPwd.statusSent': 'Enviado',
    'clientPwd.statusPending': 'Pendiente',
    'clientPwd.statusNotGenerated': 'No generado',
    'clientPwd.genPinTitle': 'Generar PIN',
    'clientPwd.resend': 'Reenviar',
    'clientPwd.pageOf': 'Página {{page}} / {{total}}',
    'stockInv.error.pickMagasin': 'Primero elige una tienda para este inventario.',
    'stockInv.error.analyzeFailed': 'Análisis imposible — verifica la clave de OpenAI o inténtalo de nuevo.',
    'stockInv.error.server': 'Error del servidor',
    'stockInv.dropdown.refLabel': 'Ref.:',
    'stockInv.short.boutique': 'T',
    'stockInv.short.depot': 'A',
    'stockInv.summary.title': 'Resumen del inventario',
    'stockInv.summary.subtitle': '{{count}} artículo(s) guardado(s)',
    'stockInv.summary.statusNew': 'Nuevo',
    'stockInv.summary.statusUpdated': 'Actualizado',
    'stockInv.summary.errorsTitle': 'Errores',
    'stockInv.summary.created': '{{count}} creado(s)',
    'stockInv.summary.updated': '{{count}} actualizado(s)',
    'stockInv.summary.pieces': '{{count}} piezas',
    'stockInv.btn.printLabels': 'Imprimir etiquetas',
    'stockInv.btn.newInventory': 'Nuevo inventario',
    'stockInv.btn.printCount': 'Imprimir ({{count}})',
    'stockInv.btn.addRow': 'Fila',
    'stockInv.btn.scan': 'Escanear',
    'stockInv.btn.csvImport': 'Importar CSV',
    'stockInv.btn.csvExport': 'Exportar',
    'stockInv.btn.saving': 'Guardando…',
    'stockInv.btn.saveAll': 'Guardar todo ({{count}})',
    'stockInv.col.status': 'Estado',
    'stockInv.col.reference': 'Referencia',
    'stockInv.col.designation': 'Descripción',
    'stockInv.col.pAchat': 'P. compra',
    'stockInv.col.pVente': 'P. venta',
    'stockInv.col.lieu': 'Lugar',
    'stockInv.col.qteAjoutee': 'Cant. añadida',
    'stockInv.col.stockTotal': 'Stock total',
    'stockInv.col.magasin': 'Tienda',
    'stockInv.col.prixAchat': 'Precio compra (€)',
    'stockInv.col.prixVente': 'Precio venta (€)',
    'stockInv.col.emplacement': 'Ubicación',
    'stockInv.col.qte': 'Cant.',
    'stockInv.col.fournisseur': 'Proveedor',
    'stockInv.location.boutique': 'Tienda',
    'stockInv.location.depot': 'Almacén',
    'stockInv.header.title': 'Inventario de stock',
    'stockInv.header.subtitleMagasin': 'Entrada rápida · {{magasin}}',
    'stockInv.header.subtitleNoMagasin': 'Entrada rápida · elige una tienda',
    'stockInv.warn.pickMagasin': 'Elige una tienda antes de guardar el inventario.',
    'stockInv.cross.title': '{{count}} referencia(s) ya existe(n) en otra tienda',
    'stockInv.cross.explain': 'Has creado una nueva línea en tu tienda de destino. Si es intencional (stock dedicado por tienda), ignora este mensaje. Si querías transferir, ve a',
    'stockInv.cross.explainTransfer': '→ Transferir.',
    'stockInv.cross.createdIn': 'creado en {{magasin}}',
    'stockInv.cross.existedIn': 'existía en',
    'stockInv.cross.noMagasin': '— sin tienda —',
    'stockInv.cross.qty': 'cant.',
    'stockInv.badge.existing': 'existente',
    'stockInv.badge.new': 'nuevo',
    'stockInv.placeholder.refEan': 'Ref. / EAN',
    'stockInv.placeholder.ean13': 'Código EAN13',
    'stockInv.placeholder.productName': 'Nombre del producto',
    'stockInv.placeholder.fournisseur': 'Proveedor',
    'stockInv.footer.rows': 'filas',
    'stockInv.footer.toSave': 'por guardar',
    'stockInv.footer.existingCount': '({{count}} existente(s))',
    'stockInv.footer.newCount': '({{count}} nuevo(s))',
    'stockInv.footer.piecesAndValue': '{{count}} piezas · {{value}} compra',
    'stockInv.hint.enterBefore': 'Pulsa',
    'stockInv.hint.enterKey': 'Intro',
    'stockInv.hint.enterAfter': 'para pasar a la siguiente fila',
    'stockInv.review.title': 'Preanálisis del inventario',
    'stockInv.review.subtitle': '{{count}} línea(s) · tienda {{magasin}}',
    'staffChat.statusOnline': 'En línea',
    'staffChat.statusBusy': 'Ocupado',
    'staffChat.statusAway': 'Ausente',
    'staffChat.statusOffline': 'Desconectado',
    'staffChat.colorYellow': 'Amarillo',
    'staffChat.colorBlue': 'Azul',
    'staffChat.colorGreen': 'Verde',
    'staffChat.colorOrange': 'Naranja',
    'staffChat.colorPurple': 'Morado',
    'staffChat.colorCyan': 'Cian',
    'staffChat.colorRed': 'Rojo',
    'staffChat.quickRepliesTitle': 'Respuestas rápidas',
    'staffChat.quickRepliesSubtitle': 'Personaliza las respuestas del chat',
    'staffChat.qrLabelPlaceholder': 'Etiqueta (ej.: ¡Listo!)',
    'staffChat.qrTextPlaceholder': 'Texto del mensaje...',
    'staffChat.qrSaveEdit': 'Guardar',
    'staffChat.cancel': 'Cancelar',
    'staffChat.add': 'Añadir',
    'staffChat.filterAll': 'Todos',
    'staffChat.filterTeam': 'Equipo',
    'staffChat.filterClients': 'Clientes',
    'staffChat.filterTickets': 'Tickets',
    'staffChat.filterQuick': 'Rápidas',
    'staffChat.messaging': 'Mensajería',
    'staffChat.newConversation': 'Nueva conversación',
    'staffChat.searchPlaceholder': 'Buscar una conversación...',
    'staffChat.noStaffAvailable': 'Ningún miembro disponible',
    'staffChat.labelTeam': 'Equipo',
    'staffChat.labelOrder': 'Pedido',
    'staffChat.labelRepair': 'Reparación',
    'staffChat.labelClient': 'Cliente',
    'staffChat.priorityUrgent': 'Urgente',
    'staffChat.priorityMedium': 'Medio',
    'staffChat.priorityNormal': 'Normal',
    'staffChat.ticketsNone': 'Ningún ticket pendiente',
    'staffChat.ticketsAllHandled': 'Todos los mensajes han sido atendidos',
    'staffChat.timeAgoLessThanHour': 'hace menos de 1 h',
    'staffChat.timeAgoHours': 'hace {{h}} h',
    'staffChat.viewConversation': 'Ver conversación',
    'staffChat.close': 'Cerrar',
    'staffChat.recentlyClosed': 'Cerrados recientemente',
    'staffChat.closedBy': 'por {{name}}',
    'staffChat.noConversations': 'Ninguna conversación',
    'staffChat.conversation': 'Conversación',
    'staffChat.startConversation': 'Inicia la conversación',
    'staffChat.endToEndEncrypted': 'Los mensajes están cifrados de extremo a extremo',
    'staffChat.aiAssistant': 'Asistente IA',
    'staffChat.autoBadge': 'auto',
    'staffChat.nudgeTitle': '¡Enviar un zumbido!',
    'staffChat.sending': 'Enviando...',
    'staffChat.messagePlaceholder': 'Escribe un mensaje...',
    'staffChat.selectConversation': 'Selecciona una conversación',
    'staffChat.chooseFromList': 'Elige en la lista de la izquierda',
    'warnDuplicateReference': 'Ya en stock — +1 al registrar',
    'warnDuplicateEan': 'EAN ya en stock — +1 al registrar',
    'warnCrossMagasin': 'Referencia en otra tienda',
    'warnLowVision': 'Lectura de foto incierta',
    'warnPrixAchatManual': 'Precio de compra a introducir manualmente',
    'warnLlmUnavailable': 'Visión IA no disponible (claves API)',
    'alertAddPhotoOrText': 'Añada una foto o pegue el texto de la etiqueta.',
    'errAnalyzePhoto': 'Error de análisis de foto',
    'alertEnterPrixAchat': 'Introduzca un precio de compra para recalcular el precio de venta.',
    'errCalcPrice': 'Error de cálculo de precio',
    'alertRefDesignationRequired': 'Referencia y designación obligatorias.',
    'alertPrixVenteRequired': 'Precio de venta obligatorio.',
    'noticeAddedToList': '+{{qty}} a la lista: {{designation}} (total +{{total}})',
    'noticeStockUpdate': 'Actualización de stock: {{designation}} (+{{qty}})',
    'noticeAdded': 'Añadido: {{designation}} (×{{qty}})',
    'errServer': 'Error del servidor',
    'alertChooseMagasin': 'Elija una tienda.',
    'errAnalyzeImpossible': 'Análisis imposible',
    'summaryTitle': 'Artículos registrados',
    'summarySubtitle': '{{created}} creado(s) · {{updated}} actualizado(s) · {{labels}} etiqueta(s) a imprimir',
    'printLabels': 'Imprimir etiquetas ({{count}})',
    'newSession': 'Nueva sesión',
    'colStatut': 'Estado',
    'colReference': 'Referencia',
    'colDesignation': 'Designación',
    'colPrixAchat': 'P. compra',
    'colPrixVente': 'P. venta',
    'colQtyAdded': 'Cant. añadida',
    'badgeNew': 'Nuevo',
    'badgeAddStock': '+stock',
    'pageTitle': 'Analizar un producto',
    'pageSubtitle': 'Escanee varios artículos · valide cada línea · guarde todo de una vez',
    'pendingList': 'Lista pendiente — {{count}} artículo(s) · {{pieces}} pieza(s)',
    'saveAll': 'Guardar todo ({{count}})',
    'badgeUpdate': 'Actualización',
    'depot': 'Depósito',
    'boutique': 'Tienda',
    'stockAbbrev': 'stock T:{{boutique}} D:{{depot}}',
    'remove': 'Quitar',
    'photoSectionTitle': 'Foto del producto',
    'productAlt': 'Producto',
    'photoHint': 'Galería o cámara — embalaje o etiqueta (EAN visible)',
    'gallery': 'Galería',
    'camera': 'Cámara',
    'analyzing': 'Analizando…',
    'analyze': 'Analizar',
    'aiVisionOption': 'Visión IA si la etiqueta es ilegible (OpenAI / Gemini)',
    'labelTextLabel': 'Texto de etiqueta (opcional — si el código de barras es ilegible)',
    'labelTextPlaceholder': 'Pantalla iPhone 8 OLED\nEAN 3701234567890\nRef IP8-LCD-001',
    'emptyHint': 'Inicie el análisis para rellenar la ficha de stock.',
    'analyzingHint': 'Leyendo etiqueta y buscando proveedor…',
    'alreadyInStockPrefix': 'Ya en stock ({{magasin}}) — registro =',
    'alreadyInStockSuffix': '(tienda {{boutique}} · depósito {{depot}})',
    'alreadyInListPrefix': 'Ya en la lista (×{{qty}}) — aceptar =',
    'alreadyInListSuffix': 'a la lista',
    'currentStockBoutique': '(stock actual tienda: {{qty}})',
    'resultTitle': 'Resultado del análisis',
    'readConfidence': 'Confianza de lectura: {{pct}}%',
    'aiVision': 'Visión IA',
    'matchLabel': 'coincidencia',
    'fieldDesignation': 'Designación *',
    'fieldReference': 'Referencia *',
    'fieldCategorie': 'Categoría',
    'fieldFournisseur': 'Proveedor',
    'otherSupplierParts': 'Otras piezas del proveedor',
    'tarifsTitle': 'Tarifas',
    'fieldPrixAchat': 'Precio de compra (€)',
    'autoSupplierCache': 'Caché automático de proveedor',
    'fieldPrixVente': 'Precio de venta (€)',
    'recalcVente': 'Recalcular venta',
    'laborLabel': 'MO: {{amount}}',
    'detailTitle': 'Detalle del cálculo Auto-Presupuesto',
    'detailAchat': 'Compra:',
    'detailPort': 'Envío:',
    'detailDouane': 'Aduana:',
    'detailCoutPiece': 'Costo por pieza:',
    'detailFinal': 'Final:',
    'qtyLocationTitle': 'Cantidad y ubicación',
    'quantite': 'Cantidad',
    'quit': 'Salir',
    'acceptPlusOne': 'Aceptar (+1)',
    'acceptLine': 'Aceptar la línea',
    'acceptHelp': 'Duplicado en lista o stock = +1 automático · luego «Guardar todo» · etiquetas al final.',
    'reviewTitleAccept': '¿Es correcta esta línea?',
    'reviewTitleBulk': 'Verificación antes de guardar',
    'reviewSubtitleAccept': 'Confirme para añadir a la lista, luego escanee el siguiente artículo',
    'reviewBulkSubtitle': '{{count}} artículo(s) para guardar en stock',
    'avoirs.title': 'Vales de crédito',
    'avoirs.subtitle': 'Crédito del cliente generado por un tique o una factura — utilizable en el TPV',
    'avoirs.refresh': 'Actualizar',
    'avoirs.errorLoad': 'Error al cargar los vales de crédito',
    'avoirs.searchPlaceholder': 'Ref. de vale, cliente, tique de origen…',
    'avoirs.allStatuses': 'Todos los estados',
    'avoirs.empty': 'Ningún vale de crédito',
    'avoirs.colRef': 'Referencia',
    'avoirs.colClient': 'Cliente',
    'avoirs.colOrigin': 'Origen',
    'avoirs.colInitial': 'Inicial',
    'avoirs.colSolde': 'Saldo',
    'avoirs.colStatut': 'Estado',
    'avoirs.colDate': 'Fecha',
    'avoirs.createdBy': 'Creado por',
    'avoirs.originLabel': 'Origen:',
    'avoirs.motifLabel': 'Motivo:',
    'avoirs.clientLabel': 'Cliente:',
    'avoirs.printTicket': 'Imprimir tique de vale',
    'avoirs.downloadPdf': 'Descargar PDF',
    'avoirs.historyTitle': 'Historial de movimientos',
    'avoirs.cancelRemaining': 'Anular el saldo restante',
    'avoirs.confirmCancel': '¿Anular el saldo restante de {{ref}}?',
    'avoirs.close': 'Cerrar',
    'avoirs.statutDisponible': 'Disponible',
    'avoirs.statutPartiel': 'Utilizado parcialmente',
    'avoirs.statutUtilise': 'Utilizado',
    'avoirs.statutAnnule': 'Anulado',
    'stockMov.tab.dashboard': 'Panel',
    'stockMov.tab.movements': 'Movimientos',
    'stockMov.tab.imei': 'IMEI / Series',
    'stockMov.tab.inventory': 'Inventario',
    'stockMov.header.title': 'Stock avanzado',
    'stockMov.header.subtitle': 'Movimientos · IMEI · sesiones de inventario · panel',
    'stockMov.cancel': 'Cancelar',
    'stockMov.save': 'Guardar',
    'stockMov.saving': 'Guardando...',
    'stockMov.loadError': 'Error de carga',
    'stockMov.error': 'Error: {{detail}}',
    'stockMov.loading': 'Cargando…',
    'stockMov.pageOf': 'Página {{page}} / {{total}}',
    'stockMov.kpi.totalArticles': 'Total de artículos',
    'stockMov.kpi.qteBoutique': 'Cant. tienda',
    'stockMov.kpi.qteDepot': 'Cant. almacén',
    'stockMov.kpi.ruptures': 'Roturas',
    'stockMov.kpi.imeiEnStock': 'IMEI en stock',
    'stockMov.boutique': 'Tienda',
    'stockMov.depot': 'Almacén',
    'stockMov.total': 'Total',
    'stockMov.valeurAchat': 'Valor de compra',
    'stockMov.valeurVente': 'Valor de venta',
    'stockMov.marge': 'Margen',
    'stockMov.margeTotale': 'Margen total',
    'stockMov.stocksNegatifs': 'Stock negativo ({{count}})',
    'stockMov.aucunStockNegatif': 'Sin stock negativo',
    'stockMov.articlesSousSeuil': 'Artículos bajo el umbral ({{count}})',
    'stockMov.tousAuDessusSeuil': 'Todos los artículos están por encima de su umbral de alerta',
    'stockMov.filter.all': 'Todos',
    'stockMov.filter.entrees': 'Entradas',
    'stockMov.filter.sorties': 'Salidas',
    'stockMov.magasinLabel': 'Tienda:',
    'stockMov.nouveauMouvement': 'Nuevo movimiento',
    'stockMov.col.date': 'Fecha',
    'stockMov.col.type': 'Tipo',
    'stockMov.col.motif': 'Motivo',
    'stockMov.col.article': 'Artículo',
    'stockMov.col.magasin': 'Tienda',
    'stockMov.col.qte': 'Cant.',
    'stockMov.col.stockAvant': 'Stock antes',
    'stockMov.col.stockApres': 'Stock después',
    'stockMov.col.imei': 'IMEI',
    'stockMov.col.par': 'Por',
    'stockMov.aucunMouvement': 'Ningún movimiento registrado',
    'stockMov.type.transfert': 'Transferencia',
    'stockMov.type.entree': 'Entrada',
    'stockMov.type.sortie': 'Salida',
    'stockMov.modalNewMovement': 'Nuevo movimiento de stock',
    'stockMov.field.motif': 'Motivo',
    'stockMov.field.article': 'Artículo',
    'stockMov.searchArticlePlaceholder': 'Buscar un artículo...',
    'stockMov.refStock': '({{ref}}) Stock: {{qty}}',
    'stockMov.refShort': 'Ref.: {{ref}}',
    'stockMov.field.quantite': 'Cantidad',
    'stockMov.field.prixUnitaire': 'Precio unitario',
    'stockMov.field.imeiOptional': 'IMEI / N.º de serie (opcional)',
    'stockMov.imeiPlaceholder': 'Ej.: 353012345678901',
    'stockMov.field.noteOptional': 'Nota (opcional)',
    'stockMov.commentPlaceholder': 'Comentario...',
    'stockMov.imeiRefRequired': 'IMEI y referencia obligatorios',
    'stockMov.refQtyRequired': 'Referencia y cantidad obligatorias',
    'stockMov.registreTitle': 'Registro IMEI — trazabilidad de teléfonos',
    'stockMov.registreDesc': 'Cada dispositivo en stock debe tener un IMEI único. Permite consultar el historial (compra, venta TPV, reparación).',
    'stockMov.nouveauTelephone': 'Nuevo teléfono',
    'stockMov.searchImeiPlaceholder': 'Buscar IMEI, artículo...',
    'stockMov.tousLesStatuts': 'Todos los estados',
    'stockMov.enregistrerImei': 'Registrar IMEI',
    'stockMov.col.imeiSerie': 'IMEI / N.º de serie',
    'stockMov.col.refDot': 'Ref.',
    'stockMov.col.magShort': 'Tienda',
    'stockMov.col.etat': 'Condición',
    'stockMov.col.statut': 'Estado',
    'stockMov.col.origine': 'Origen',
    'stockMov.aucunImei': 'Ningún IMEI — añada un teléfono al stock y luego registre su número aquí.',
    'stockMov.historique': 'Historial',
    'stockMov.historiqueImei': 'Historial · {{imei}}',
    'stockMov.byUser': 'por {{user}}',
    'stockMov.aucunMouvementImei': 'Ningún movimiento vinculado a este IMEI.',
    'stockMov.modalRegisterImei': 'Registrar un IMEI / N.º de serie',
    'stockMov.field.articleStockRef': 'Artículo de stock (referencia)',
    'stockMov.searchPlaceholder': 'Buscar...',
    'stockMov.field.etat': 'Condición',
    'stockMov.field.origine': 'Origen',
    'stockMov.origine.achat': 'Compra',
    'stockMov.origine.reprise_client': 'Entrega de cliente',
    'stockMov.origine.transfert': 'Transferencia',
    'stockMov.etat.neuf': 'Nuevo',
    'stockMov.etat.occasion': 'Usado',
    'stockMov.etat.reconditionne': 'Reacondicionado',
    'stockMov.etat.hs': 'Averiado',
    'stockMov.statut.en_stock': 'En stock',
    'stockMov.statut.vendu': 'Vendido',
    'stockMov.statut.reserve': 'Reservado',
    'stockMov.statut.en_reparation': 'En reparación',
    'stockMov.motif.achat_fournisseur': 'Compra a proveedor',
    'stockMov.motif.retour_client': 'Devolución de cliente',
    'stockMov.motif.correction_inventaire': 'Corrección de inventario',
    'stockMov.motif.transfert_entrant': 'Transferencia entrante',
    'stockMov.motif.reception_commande': 'Recepción de pedido',
    'stockMov.motif.reintegration_reparation': 'Reintegración por reparación',
    'stockMov.motif.vente_pos': 'Venta TPV',
    'stockMov.motif.consommation_reparation': 'Consumo por reparación',
    'stockMov.motif.perte_casse': 'Pérdida / rotura',
    'stockMov.motif.retour_fournisseur': 'Devolución a proveedor',
    'stockMov.motif.transfert_sortant': 'Transferencia saliente',
    'stockMov.motif.ajustement_inventaire': 'Ajuste de inventario',
    'stockMov.sessionsInventaire': 'Sesiones de inventario',
    'stockMov.nouvelInventaire': 'Nuevo inventario',
    'stockMov.aucuneSession': 'Ninguna sesión de inventario',
    'stockMov.parUser': 'Por {{user}}',
    'stockMov.articlesEcarts': '{{articles}} artículos, {{ecarts}} diferencias',
    'stockMov.status.enCours': 'En curso',
    'stockMov.status.valide': 'Validado',
    'stockMov.retourSessions': 'Volver a las sesiones',
    'stockMov.statutColon': 'Estado:',
    'stockMov.validePar': 'Validado por {{user}}',
    'stockMov.validerSansCorrection': 'Validar sin corrección',
    'stockMov.validerCorriger': 'Validar + corregir stock',
    'stockMov.comptagePhysique': 'Recuento físico',
    'stockMov.searchArticleShort': 'Buscar artículo...',
    'stockMov.inv.bdShort': 'T:{{b}} A:{{d}}',
    'stockMov.stockSelectionne': 'Stock seleccionado:',
    'stockMov.dotBoutique': '· tienda {{q}}',
    'stockMov.dotDepot': '· almacén {{q}}',
    'stockMov.qteComptee': 'Cant. contada',
    'stockMov.col.stockTheorique': 'Stock teórico',
    'stockMov.col.comptagePhysique': 'Recuento físico',
    'stockMov.col.ecart': 'Diferencia',
    'stockMov.col.comptePar': 'Contado por',
    'stockMov.aucunArticleCompte': 'Ningún artículo contado. Empiece el recuento arriba.',
    'stockMov.modalNewSession': 'Nueva sesión de inventario',
    'stockMov.field.titreOptional': 'Título (opcional)',
    'stockMov.titrePlaceholder': 'Ej.: Inventario mensual marzo 2026',
    'stockMov.creating': 'Creando...',
    'stockMov.creer': 'Crear',
    'stockMov.confirmValidateApply': '¿Validar Y aplicar las correcciones de stock?',
    'stockMov.confirmValidateNoApply': '¿Validar SIN aplicar las correcciones?',
    'stockMov.sessionValidee': '¡Sesión validada!',
    'stockMov.countSaved': 'Recuento guardado: Stock teórico {{theorique}}, Físico {{physique}}, Diferencia {{ecart}}',
    'stock.err.templateDownload': 'Error al descargar la plantilla',
    'stock.err.missingId': 'Error: falta el ID del artículo',
    'stock.deleteSuccess': 'Artículo eliminado correctamente',
    'stock.err.delete': 'Error al eliminar',
    'stock.confirmDeleteMany': '¿Eliminar {{count}} artículo(s)?',
    'stock.err.update': 'Error al actualizar',
    'stock.err.transfer': 'Error de transferencia',
    'stock.err.bulkTransfer': 'Error en la transferencia masiva',
    'stock.depotOnlyM1': 'El almacén solo está disponible en M1 por ahora.',
    'stock.sameSourceDest': 'El origen y el destino son idénticos.',
    'stock.noLineToTransfer': 'No hay ninguna línea para transferir (cantidades nulas o tienda de origen = destino).',
    'stock.confirmBulkPublish': '¿Poner a la venta en línea {{count}} artículo(s)?',
    'stock.confirmBulkUnpublish': '¿Retirar de la venta en línea {{count}} artículo(s)?',
    'stock.confirmPublishOne': '¿Poner a la venta en línea «{{name}}»?',
    'stock.confirmUnpublishOne': '¿Retirar de la venta en línea «{{name}}»?',
    'stock.importDone': 'Importación completada',
    'stock.importCreated': 'creado(s)',
    'stock.importUpdated': 'actualizado(s)',
    'stock.importSkipped': 'omitido(s)',
    'stock.importErrors': 'error(es)',
    'stock.importRetryHint': '{{count}} artículo(s) ya existía(n); vuelve a ejecutar en modo «Actualizar».',
    'stock.importRetryBtn': 'Reejecutar (actualizar)',
    'stock.importViewErrors': 'Ver los {{count}} error(es)',
    'stock.transferTitle': 'Transferencia de stock',
    'stock.boutique': 'Tienda',
    'stock.depot': 'Almacén',
    'stock.sourceStore': 'Tienda de origen',
    'stock.sourceLocation': 'Ubicación de origen',
    'stock.destStore': 'Tienda de destino',
    'stock.destLocation': 'Ubicación de destino',
    'stock.quantity': 'Cantidad',
    'stock.availableAtSource': 'Disponible en origen: {{count}}',
    'stock.cancel': 'Cancelar',
    'stock.transferring': 'Transfiriendo…',
    'stock.transfer': 'Transferir',
    'stock.bulkTransferTitle': 'Cambiar la tienda de {{count}} artículo(s)',
    'stock.location': 'Ubicación',
    'stock.bulkTransferR1Note': 'La transferencia respeta la regla R1: el documento de origen conserva una cantidad de 0 si queda vacío y se crea un nuevo documento en la tienda de destino.',
    'stock.colArticle': 'Artículo',
    'stock.colCurrentStore': 'Tienda actual',
    'stock.colStock': 'Stock',
    'stock.colQtyToTransfer': 'Cantidad a transferir',
    'stock.runTransfer': 'Iniciar transferencia',
    'stock.resultSucceeded': 'con éxito',
    'stock.resultFailed': 'fallidos',
    'stock.resultUnitsTransferred': 'unidades transferidas',
    'stock.failuresLabel': 'Fallos:',
    'stock.done': 'Finalizar',
    'stock.storeN': 'Tienda {{n}}',
    'stock.tab.view': 'Vista',
    'stock.tab.inventory': 'Inventario',
    'stock.tab.analyze': 'Analizar producto',
    'stock.tab.history': 'Historial',
    'stock.tab.supplierOrders': 'Aprovisionamiento proveedor',
    'stock.tab.invoiceImport': 'Importar factura IA',
    'stock.tab.labels': 'Etiquetas',
    'stock.tab.advanced': 'Stock avanzado',
    'stock.tab.reconciliation': 'Conciliación',
    'stock.tab.config': 'Configuración',
    'posV2.remisePlafonneeMsg': 'Descuento limitado al {{pct}} %. Por encima, se requiere la aprobación de la dirección.',
    'posV2.venteNonEnregRemiseRamenee': 'La venta NO se registró — el descuento se redujo al límite; verifica el total y cobra de nuevo.',
    'posV2.remiseRameneeVerif': 'El descuento se redujo al límite — verifica el total y cobra.',
    'posV2.catalogUnavailable': 'Catálogo no disponible',
    'posV2.paymentRefusedTpe': 'Pago rechazado o cancelado en el datáfono — inténtalo de nuevo.',
    'posV2.caisseClosedOpenFirst': 'Caja {{mag}} cerrada — ábrela antes de cobrar',
    'posV2.sumupCheckoutDesc': 'POS V2 · {{count}} línea(s)',
    'posV2.sumupTerminalNotConnected': 'Terminal SumUp no conectado',
    'posV2.sumupSaleNotSaved': '{{msg}}. La venta NO se registró (stock sin cambios). Verifica que el datáfono esté encendido y conectado.',
    'posV2.cartEmpty': 'Carrito vacío',
    'posV2.lookupValidAvoir': 'Busca un vale válido antes de cobrar',
    'posV2.printError': 'Error de impresión',
    'posV2.caisseClosedBanner': 'Caja {{mag}} cerrada.',
    'posV2.open': 'Abrir',
    'posV2.oneEncaissementMultiStock': '1 cobro {{mag}} · stock multitienda',
    'posV2.catalog': 'Catálogo',
    'posV2.ficheButtonHint': 'Botón Ficha → galería de fotos',
    'posV2.all': 'Todos',
    'posV2.stockMag': 'Stock {{mag}}',
    'posV2.catalogPlaceholder': 'Catálogo…',
    'posV2.go': 'Ir',
    'posV2.catalogMeta': '{{total}} refs · {{scope}} · pág.{{page}}/{{pages}}',
    'posV2.enterAvoirRefOrClient': 'Introduce una referencia de vale o un nombre de cliente',
    'posV2.avoirNotFound': 'Vale no encontrado',
    'posV2.productSheet': 'Ficha de producto',
    'posV2.productSheetSub': 'Galería · stock · añadir al carrito',
    'posV2.ticketCenter': 'Centro de tickets',
    'posV2.ticketCenterSub': 'Tickets recientes · reimpresión',
    'posV2.savStation': 'Puesto de posventa / reparación',
    'posV2.savStationSub': 'Buscar expediente · cobrar saldo · anticipo · carrito',
    'posV2.horsStock': 'Fuera de stock',
    'posV2.horsStockSub': 'Venta de artículo ad hoc · etiqueta FUERA DE STOCK · cobro directo',
    'posV2.clientCenter': 'Centro de clientes',
    'posV2.clientCenterSub': 'Historial · fidelidad · vincular al cobro',
    'posV2.orders': 'Pedidos',
    'posV2.ordersSub': 'Solicitud del cliente · pedido · anticipo · carrito',
    'openCaisse.denomBill': 'Billete',
    'openCaisse.denomCoin': 'Moneda',
    'openCaisse.cardTotal': 'Total',
    'openCaisse.successOpen': 'Caja {{magasin}} abierta con éxito.',
    'openCaisse.errorOpen': 'Error al abrir la caja',
    'openCaisse.backToDashboard': 'Volver al panel',
    'openCaisse.title': 'Apertura de caja {{magasin}}',
    'openCaisse.titleForce': 'Apertura forzada de caja {{magasin}}',
    'openCaisse.openingFund': 'Fondo de apertura',
    'openCaisse.openingFundHint': 'Introduce los billetes y las monedas para la caja {{magasin}}.',
    'openCaisse.totalOpening': 'Total apertura',
    'openCaisse.forceWarning': 'Esta acción cerrará la caja abierta de la tienda de destino y luego creará una nueva caja con este importe.',
    'openCaisse.cancel': 'Cancelar',
    'openCaisse.opening': 'Abriendo...',
    'openCaisse.validateOpening': 'Confirmar apertura',
    'calcul.title': 'Herramienta de cálculo de precio / presupuesto',
    'calcul.subtitle': 'Interfaz idéntica al cálculo PHP + generación de PDF 80mm y A4.',
    'calcul.clientSection': 'Información del cliente',
    'calcul.clientName': 'Nombre del cliente',
    'calcul.phone': 'Teléfono',
    'calcul.email': 'Correo electrónico',
    'calcul.saveClient': 'Guardar cliente',
    'calcul.deviceSection': 'Selección del dispositivo',
    'calcul.brand': 'Marca',
    'calcul.model': 'Modelo',
    'calcul.itemsSection': 'Artículos',
    'calcul.itemDescription': 'Pieza / Descripción',
    'calcul.itemReference': 'Ref. pieza',
    'calcul.itemPurchasePrice': 'Precio de compra',
    'calcul.addLine': 'Agregar una línea',
    'calcul.paramsSection': 'Parámetros',
    'calcul.quantity': 'Cantidad',
    'calcul.labor': 'Mano de obra (€)',
    'calcul.partReference': 'Referencia de la pieza',
    'calcul.supplier': 'Proveedor',
    'calcul.docType': 'Tipo de documento',
    'calcul.docTypeDevis': 'PRESUPUESTO',
    'calcul.docTypeFacture': 'FACTURA',
    'calcul.docTypeProforma': 'PROFORMA',
    'calcul.acceptOnlinePayment': 'Aceptar pago en línea (SumUp)',
    'calcul.acceptOnlinePaymentHint': 'El cliente podrá solicitar un enlace de pago SumUp',
    'calcul.saveTicket': '✅ Guardar el ticket',
    'calcul.saving': 'Guardando...',
    'calcul.preview': '👁️ Previsualizar',
    'calcul.previewSection': 'Previsualización',
    'calcul.previewIframeTitle': 'Vista previa del ticket',
    'calcul.previewEmpty': 'Ejecute un cálculo para mostrar el ticket.',
    'calcul.printTicket': 'Imprimir ticket',
    'calcul.transformA4': 'Convertir en presupuesto A4',
    'calcul.totalArticles': 'Total de artículos',
    'calcul.totalPurchase': 'Total de compra',
    'calcul.shippingFees': 'Gastos de envío',
    'calcul.customsFees': 'Gastos de aduana',
    'calcul.costPerPiece': 'Costo por pieza',
    'calcul.finalPrice': 'Precio final',
    'calcul.alertAllowPopups': 'Permita las ventanas emergentes para imprimir.',
    'calcul.alertAddItem': 'Agregue al menos un artículo con un precio de compra.',
    'calcul.ticketSaved': '✅ Ticket guardado.',
    'calcul.errorGenerateTicket': 'Error al generar el ticket',
    'calcul.errorPrintTicket': 'Error al imprimir el ticket',
    'calcul.errorGenerateA4': 'Error al generar el presupuesto A4',
    'caisseHist.errPrint': 'Error al imprimir la caja',
    'caisseHist.errPrintGeneric': 'Error de impresión',
    'caisseHist.errLoadMonthly': 'Error al cargar el historial mensual',
    'caisseHist.errExport': 'Error al exportar la contabilidad',
    'caisseHist.confirmForceClose': '¿Cerrar forzosamente la caja del {{date}}? Esta acción es irreversible.',
    'caisseHist.errForceClose': 'Error durante el cierre forzado',
    'caisseHist.title': 'Historial de aperturas / cierres de caja',
    'caisseHist.month': 'Mes',
    'caisseHist.store': 'Tienda',
    'caisseHist.allStores': 'Todas las tiendas',
    'caisseHist.exportAccounting': 'Exportar contabilidad',
    'caisseHist.totalSales': 'Total ventas',
    'caisseHist.totalCash': 'Total efectivo',
    'caisseHist.totalCard': 'Total tarjeta',
    'caisseHist.withdrawals': 'Retiros',
    'caisseHist.totalTheoretical': 'Total teórico',
    'caisseHist.totalAccounting': 'Total contable',
    'caisseHist.discrepancy': 'Diferencia',
    'caisseHist.validatedBy': 'Validado por',
    'caisseHist.validationDate': 'Fecha de validación',
    'caisseHist.noValidatedCaisse': 'Ninguna caja validada.',
    'caisseHist.opening': 'Apertura',
    'caisseHist.closing': 'Cierre',
    'caisseHist.caisse': 'Caja',
    'caisseHist.daySales': 'Ventas del día',
    'caisseHist.dateStart': 'Fecha inicio',
    'caisseHist.dateEnd': 'Fecha fin',
    'caisseHist.reset': 'Restablecer',
    'caisseHist.cashFloat': 'Fondo de caja',
    'caisseHist.openedBy': 'Abierto por',
    'caisseHist.closedBy': 'Cerrado por',
    'caisseHist.noHistory': 'No hay historial disponible',
    'caisseHist.closingProgress': 'Cerrando...',
    'caisseHist.forceClose': 'Cerrar (forzado)',
    'caisseHist.forced': 'Forzado',
    'caisseHist.showMore': 'Ver más ({{count}} aperturas anteriores)',
    'caisseHist.showLess': 'Ver menos',
    'repairDetail.popupBlocked': 'Por favor, permita las ventanas emergentes para imprimir.',
    'repairDetail.downloadError': 'Error al descargar',
    'repairDetail.statusUpdateError': 'Error al actualizar',
    'repairDetail.invalidAmount': 'Importe no válido',
    'repairDetail.genericError': 'Error',
    'repairDetail.filesAttached': '{{count}} archivo(s) adjunto(s)',
    'repairDetail.uploadProgress': 'Subiendo {{current}}/{{total}}…',
    'repairDetail.addNoteError': 'Error al añadir la nota',
    'repairDetail.confirmDeleteNote': '¿Eliminar esta nota?',
    'repairDetail.notFound': 'Reparación no encontrada',
    'repairDetail.backToRepairs': 'Volver a las reparaciones',
    'repairDetail.photosTitle': 'Fotos ({{count}})',
    'repairDetail.photoAlt': 'Foto {{index}}',
    'repairDetail.notesTitle': 'Notas ({{count}})',
    'repairDetail.notePlaceholder': 'Añadir una nota...',
    'repairDetail.visibilityPublic': 'Público',
    'repairDetail.visibilityInternal': 'Interno',
    'repairDetail.filesBtn': 'Archivos',
    'repairDetail.sending': 'Enviando...',
    'repairDetail.add': 'Añadir',
    'repairDetail.noNotes': 'Sin notas',
    'repairDetail.staffDefault': 'Personal',
    'repairDetail.printAcompteError': 'Error al imprimir el ticket de anticipo',
    'repairDetail.printAvoirError': 'Error al imprimir el ticket de abono',
    'repairDetail.downloadPdfError': 'Error al descargar el PDF',
    'repairDetail.changeStatus': 'Cambiar el estado',
    'repairDetail.noStatusChange': 'Ningún cambio permitido',
    'repairDetail.addDeposit': 'Añadir un anticipo',
    'repairDetail.amountLabel': 'Importe (€)',
    'repairDetail.paymentMode': 'Método de pago',
    'repairDetail.paymentCash': 'Efectivo',
    'repairDetail.paymentCard': 'Tarjeta',
    'repairDetail.paymentTransfer': 'Transferencia',
    'repairDetail.paymentCheck': 'Cheque',
    'repairDetail.cancel': 'Cancelar',
    'repairDetail.statusRecu': 'Recibido',
    'repairDetail.statusEnCours': 'En curso',
    'repairDetail.statusAttentePieces': 'Esperando piezas',
    'repairDetail.statusPieceArrivee': 'Pieza recibida',
    'repairDetail.statusNonReparable': 'No reparable',
    'repairDetail.statusTermine': 'Terminado',
    'repairDetail.statusLivre': 'Entregado',
    'repairDetail.statusAttenteDepot': 'Pendiente de entrega del equipo',
    'closeCaisse.denomBillet': 'Billete',
    'closeCaisse.denomPiece': 'Moneda',
    'closeCaisse.countBadge': '× {{count}}',
    'closeCaisse.total': 'Total',
    'closeCaisse.errLoad': 'Error al cargar la caja',
    'closeCaisse.errPdf': 'Error al generar el PDF',
    'closeCaisse.errConfirmCb': 'Confirme los pagos con tarjeta antes de cerrar la caja',
    'closeCaisse.confirmEcart': 'Atención: se detectó una diferencia de {{ecart}}.\n\nTotal teórico: {{theorique}}\nTotal contado: {{compte}}\n\n¿Desea continuar?',
    'closeCaisse.closeSuccess': 'Caja {{magasin}} cerrada correctamente.',
    'closeCaisse.errClose': 'Error al cerrar la caja',
    'closeCaisse.backToDashboard': 'Volver al panel',
    'closeCaisse.journee': 'Jornada {{date}}',
    'closeCaisse.openedBy': 'abierta por {{name}}',
    'closeCaisse.refresh': 'Actualizar',
    'closeCaisse.summaryTitle': 'Resumen de la caja',
    'closeCaisse.activitySummary': 'Actividad de la tienda {{magasin}} — {{ops}} operación(es) ({{pos}} ventas POS, {{acomptes}} anticipos).',
    'closeCaisse.fondOuverture': 'Fondo de apertura',
    'closeCaisse.ventesEspeces': 'Ventas en efectivo',
    'closeCaisse.ventesCb': 'Ventas con tarjeta',
    'closeCaisse.paiementsStripe': 'Pagos Stripe',
    'closeCaisse.acomptes': 'Anticipos',
    'closeCaisse.retraits': 'Retiros',
    'closeCaisse.totalTheorique': 'Total teórico',
    'closeCaisse.totalVentes': 'Total ventas: {{montant}}',
    'closeCaisse.activiteVendeur': 'Actividad por vendedor',
    'closeCaisse.colVendeur': 'Vendedor',
    'closeCaisse.colOps': 'Ops',
    'closeCaisse.colEspeces': 'Efectivo',
    'closeCaisse.colCb': 'Tarjeta',
    'closeCaisse.comptageEspeces': 'Conteo de efectivo',
    'closeCaisse.comptageSubtitle': 'Billetes y monedas con detalle visual para el cierre.',
    'closeCaisse.totalCompte': 'Total contado',
    'closeCaisse.ecart': 'Diferencia',
    'closeCaisse.ecartImportant': 'Diferencia importante detectada',
    'closeCaisse.infosComplementaires': 'Información complementaria',
    'closeCaisse.montantCoffreLabel': 'Importe depositado en la caja fuerte (EUR)',
    'closeCaisse.montantCoffreHint': 'Importe en efectivo depositado en la caja fuerte.',
    'closeCaisse.cbConfirmLabel': 'He confirmado los pagos con tarjeta',
    'closeCaisse.cbConfirmHint': 'Verifique que todos los pagos con tarjeta se hayan cobrado en el terminal.',
    'closeCaisse.imprimerRapport': 'Imprimir el informe',
    'closeCaisse.validerCaisse': 'Validar la caja',
    'closeCaisse.onlyAdmin': 'Solo un administrador puede validar el cierre de caja',
    'paiements.title': 'Pagos en línea',
    'paiements.proofsToValidate': '{{count}} comprobante(s) por validar',
    'paiements.pendingCount': '{{count}} pendiente(s)',
    'paiements.tabSumup': 'Pagos SumUp ({{count}})',
    'paiements.tabProofs': 'Comprobantes de pago ({{count}})',
    'paiements.noProof': 'Ningún comprobante de pago',
    'paiements.orderDefault': 'Pedido',
    'paiements.proofValidated': 'Validado',
    'paiements.proofPendingValidation': 'Pendiente de validación',
    'paiements.totalLabel': 'Total: ',
    'paiements.sentLabel': 'Enviado: ',
    'paiements.byLabel': 'Por: ',
    'paiements.validatedByLabel': 'Validado por: ',
    'paiements.viewCapture': 'Ver captura',
    'paiements.validatePayment': 'Validar pago',
    'paiements.reject': 'Rechazar',
    'paiements.confirmOrder': 'Confirmar pedido',
    'paiements.filterAll': 'Todos',
    'paiements.filterPending': 'Pendientes',
    'paiements.filterConfirmed': 'Confirmados',
    'paiements.filterCancelled': 'Cancelados',
    'paiements.noPayment': 'Ningún pago',
    'paiements.amountLabel': 'Importe: ',
    'paiements.refLabel': 'Ref.: ',
    'paiements.dateLabel': 'Fecha: ',
    'paiements.ticketPdf': 'Recibo PDF',
    'paiements.validate': 'Validar',
    'paiements.cancel': 'Cancelar',
    'paiements.statusPaidApplied': 'Confirmado',
    'paiements.statusPaidPending': 'Pendiente',
    'paiements.statusPending': 'En curso',
    'paiements.statusCancelled': 'Cancelado',
    'paiements.orderRepair': 'Reparación {{ref}}',
    'paiements.orderBoutique': 'Pedido de tienda',
    'paiements.alertConfirmed': '¡Pago confirmado y aplicado!',
    'paiements.errorConfirm': 'Error al confirmar',
    'paiements.confirmCancel': '¿Cancelar este pago?',
    'paiements.error': 'Error',
    'paiements.errorTicket': 'Error al descargar el recibo',
    'paiements.confirmValidateProof': '¿Validar este comprobante de pago?',
    'paiements.alertProofValidated': '¡Pago validado!',
    'paiements.confirmRejectProof': '¿Rechazar este comprobante de pago?',
    'paiements.confirmConfirmOrder': '¿Confirmar este pedido?',
    'paiements.alertOrderConfirmed': '¡Pedido confirmado!',
    'repairForm.deviceNotFound': 'Dispositivo no encontrado',
    'repairForm.selectMagasinFirst': 'Elige primero la tienda que se encarga de esta reparación.',
    'repairForm.saveError': 'Error al guardar',
    'repairForm.conversionFromCommande': 'Conversión desde pedido',
    'repairForm.prefillNotice': 'Información precargada · anticipos ({{amount}}) transferidos al finalizar.',
    'repairForm.sectionMagasin': 'Tienda',
    'repairForm.magasinLabel': 'Tienda responsable *',
    'repairForm.selectMagasinOption': '— Selecciona una tienda —',
    'repairForm.sectionForcedEntry': 'Registro forzado',
    'repairForm.forcedEntryHint': 'Para una entrega olvidada: registra la reparación con la fecha real de entrega (no la de hoy).',
    'repairForm.useBackdateLabel': 'Usar una fecha de entrega anterior',
    'repairForm.realDepotDateTime': 'Fecha y hora reales de entrega',
    'repairForm.sectionClient': 'Cliente',
    'repairForm.clientName': 'Nombre del cliente *',
    'repairForm.phone': 'Teléfono *',
    'repairForm.email': 'Correo electrónico',
    'repairForm.address': 'Dirección',
    'repairForm.sectionDevice': 'Dispositivo',
    'repairForm.brand': 'Marca *',
    'repairForm.model': 'Modelo *',
    'repairForm.problem': 'Problema',
    'repairForm.technician': 'Técnico',
    'repairForm.selectOption': '— Seleccionar —',
    'repairForm.imeiSerial': 'IMEI / N.º de serie',
    'repairForm.deviceLock': 'Código de bloqueo',
    'repairForm.sectionParts': 'Piezas',
    'repairForm.defectivePartsHint': 'Piezas que no funcionan al recibir',
    'repairForm.phoneDoesntTurnOn': 'El tel. no enciende',
    'repairForm.sectionStockParts': 'Piezas en stock (opcional)',
    'repairForm.stockPartsHint': 'Si la pieza está en el stock de la tienda, se descontará al crear y el precio de reparación se recalculará según los precios de catálogo. Si no, indica un precio manual abajo (presupuesto teórico).',
    'repairForm.stockPartsTotal': 'Total piezas en stock: {{amount}} — aplicado al crear si está disponible.',
    'repairForm.sectionPricing': 'Tarifas',
    'repairForm.priceRepair': 'Precio de reparación (€)',
    'repairForm.theoreticalQuote': '— presupuesto teórico',
    'repairForm.priceDiagnostic': 'Precio de diagnóstico (€)',
    'repairForm.receptionNotes': 'Notas de recepción',
    'repairForm.sectionPhotos': 'Fotos',
    'repairForm.addPhoto': 'Añadir',
    'repairForm.cancel': 'Cancelar',
    'repairForm.save': 'Guardar',
    'repairForm.createRepair': 'Crear reparación',
    'repairForm.parts.speaker': 'Altavoz',
    'repairForm.parts.lcd': 'Pantalla',
    'repairForm.parts.front_cam': 'Cámara frontal',
    'repairForm.parts.back_cam': 'Cámara trasera',
    'repairForm.parts.microphone': 'Micrófono',
    'repairForm.parts.fingerprint': 'Huella',
    'repairForm.parts.home_button': 'Botón de inicio',
    'repairForm.parts.volume_button': 'Volumen',
    'repairForm.parts.power_button': 'Encendido',
    'repairForm.parts.signal_carrier': 'Señal',
    'repairForm.parts.battery': 'Batería',
    'repairForm.parts.wifi_bt': 'Wi-Fi/Bluetooth',
    'repairForm.parts.ear_speaker': 'Auricular',
    'repairForm.parts.charging_port': 'Puerto de carga',
    'labels.barcodeAuto': 'EAN13 se generará automáticamente',
    'labels.allowPopups': 'Por favor, permita las ventanas emergentes para imprimir.',
    'labels.selectAtLeastOne': 'Seleccione al menos un producto',
    'labels.errorGenerate': 'Error al generar etiquetas',
    'labels.infoNoEan': 'Info: {{count}} artículo(s) sin EAN — EAN13 interno generado automáticamente. Total: {{total}} etiqueta(s).',
    'labels.jobCreated': 'Trabajo de impresión creado ({{count}} etiquetas).\nID: {{id}}...\nEl agente Bixolon recogerá este lote.',
    'labels.jobNoEan': '\nNota: {{count}} sin EAN (generado automáticamente).',
    'labels.errorBatch': 'Error de impresión por lotes',
    'labels.generating': 'Generando...',
    'labels.generatePdf': 'Generar PDF ({{count}})',
    'labels.previewPdf': 'Vista previa PDF ({{count}})',
    'labels.printBixolon': 'Imprimir Bixolon ({{count}})',
    'labels.clear': 'Vaciar',
    'labels.format': 'Formato',
    'labels.formatBixolon': 'Bixolon 50 × 30 mm (térmica)',
    'labels.formatA4': 'Hoja A4 (antigua)',
    'labels.pageTitle': 'Etiquetas de productos',
    'labels.pageSubtitle': 'Etiquetas de productos configurables',
    'labels.config': 'Config',
    'labels.searchPlaceholder': 'Buscar un producto...',
    'labels.boutique': 'Tienda',
    'labels.depot': 'Almacén',
    'labels.deselectAll': 'Deseleccionar todo',
    'labels.colProduct': 'Producto',
    'labels.colPrice': 'Precio',
    'labels.colBoutiqueShort': 'Tienda',
    'labels.colQtyToPrint': 'Cant. a imprimir',
    'labels.noProduct': 'Ningún producto',
    'labels.autoShort': 'auto',
    'labels.previewTitle': 'Vista previa de la etiqueta',
    'labels.refLabel': 'Ref.:',
    'labels.selectedProducts': 'Productos seleccionados',
    'labels.totalLabels': 'Total de etiquetas',
    'labels.autoGenAtPdf': 'Generado automáticamente en el PDF',
    'labels.selectToPreview': 'Seleccione un producto para previsualizar',
    'labels.batchVeryLarge': 'Lote muy grande',
    'labels.batchConfirmTitle': 'Confirmar el lote grande',
    'labels.confirmBodyPrefix': 'Va a generar',
    'labels.confirmBodySuffix': 'etiquetas.',
    'labels.estRoll': '≈ {{meters}} m de rollo (50×30mm)',
    'labels.estTime': '≈ {{minutes}} min de impresión (~1,5 s/etiqueta)',
    'labels.cancel': 'Cancelar',
    'labels.confirmAnyway': 'Confirmar de todos modos',
    'labels.continue': 'Continuar',
    'rep.status.awaitingDeposit': 'En espera de entrega',
    'rep.status.received': 'Recibido',
    'rep.status.inProgress': 'En curso',
    'rep.status.awaitingParts': 'Esperando piezas',
    'rep.status.completed': 'Terminado',
    'rep.status.notRepairable': 'No reparable',
    'rep.status.delivered': 'Entregado',
    'rep.status.refused': 'Rechazado',
    'rep.payCash': 'Efectivo',
    'rep.payCard': 'Tarjeta',
    'rep.payTransfer': 'Transferencia',
    'rep.payCheck': 'Cheque',
    'rep.accept': 'Aceptar',
    'rep.addError': 'Error al agregar',
    'rep.adminOnlyStatus': 'Solo un administrador puede modificar este estado.',
    'rep.allowPopups': 'Permita las ventanas emergentes para imprimir.',
    'rep.chatTitle': 'Chat de reparación {{ref}}',
    'rep.confirmArrivalAsk': '¿Confirmar la recepción del aparato {{ref}} en la tienda?',
    'rep.confirmArrivalDone': '¡Aparato confirmado! La reparación ya está activa.',
    'rep.confirmArrivalError': 'Error al confirmar',
    'rep.created': 'Creado',
    'rep.currentStatus': 'Estado actual:',
    'rep.deleteError': 'Error al eliminar',
    'rep.deleteRecordAsk': '¿Eliminar este registro?',
    'rep.deleteStatusAsk': '¿Eliminar el estado "{{name}}"?',
    'rep.depositAmountEuro': 'Importe del anticipo (€)',
    'rep.diagnosticPaid': 'Diagnóstico pagado',
    'rep.diagnosticRemaining': 'Diagnóstico: {{amount}} restante',
    'rep.downloadError': 'Error al descargar',
    'rep.error': 'Error',
    'rep.invalidAmount': 'Importe no válido',
    'rep.newStatus': 'Nuevo estado',
    'rep.noDeposits': 'Ningún anticipo pagado',
    'rep.noOnlineRequests': 'No hay solicitudes en línea pendientes',
    'rep.onlineRequests': 'Solicitudes en línea ({{count}})',
    'rep.or': 'o',
    'rep.pointAtTicketQr': 'Apunte al código QR del ticket',
    'rep.printAcompteError': 'Error al imprimir el ticket de anticipo',
    'rep.qrPrintHint': 'Escanee para seguir su reparación',
    'rep.qrSearchPlaceholder': 'Ej.: REM0094',
    'rep.qrTrackingHint': 'El cliente escanea este código QR para seguir su reparación en tiempo real',
    'rep.qrTrackingTitle': 'Código QR de seguimiento',
    'rep.reference': 'Referencia:',
    'rep.repair': 'Reparación',
    'rep.scanOrEnterRef': 'Escanee un código QR o introduzca la referencia',
    'rep.scanWithCamera': 'Escanear con la cámara',
    'rep.searchRepair': 'Buscar una reparación',
    'rep.statusManagement': 'Gestión de estados',
    'rep.ticket': 'Ticket',
    'rep.updateError': 'Error al actualizar',
    'rep.bulkNoteSentSingular': 'Nota enviada a {{count}} expediente{{skip}}.',
    'rep.bulkNoteSentPlural': 'Nota enviada a {{count}} expedientes{{skip}}.',
    'rep.bulkNoteSkippedSingular': '({{count}} omitido)',
    'rep.bulkNoteSkippedPlural': '({{count}} omitidos)',
    'devisDepl.title': 'Presupuestos a domicilio',
    'devisDepl.subtitle': 'Gestión de presupuestos para reparaciones a domicilio',
    'devisDepl.newDevis': 'Nuevo presupuesto',
    'devisDepl.exportCsv': 'Exportar CSV',
    'devisDepl.remindBtn': 'Recordar ({{count}})',
    'devisDepl.sending': 'Enviando...',
    'devisDepl.send': 'Enviar',
    'devisDepl.cancel': 'Cancelar',
    'devisDepl.errGeneric': 'Error',
    'devisDepl.confirmSendReminders': '¿Enviar un recordatorio a {{count}} cliente(s) con presupuestos pendientes desde hace más de 3 días?',
    'devisDepl.remindersSent': '¡{{count}} recordatorio(s) enviado(s)!',
    'devisDepl.sentByEmail': '¡Presupuesto enviado por correo!',
    'devisDepl.errSend': 'Error de envío',
    'devisDepl.confirmDelete': '¿Eliminar este presupuesto?',
    'devisDepl.searchPlaceholder': 'Buscar por ref, nombre, correo...',
    'devisDepl.noResults': 'Sin resultados',
    'devisDepl.empty': 'No se ha creado ningún presupuesto',
    'devisDepl.travelFeeLabel': 'Tarifa de desplazamiento',
    'devisDepl.invalidAmount': 'Importe no válido',
    'devisDepl.errPayment': 'Error de pago',
    'devisDepl.confirmStaffAccept': '¿Validar este presupuesto? Se crearán una orden de compra y una factura.',
    'devisDepl.errValidation': 'Error de validación',
    'devisDepl.reminderSent': 'Recordatorio enviado',
    'devisDepl.errSendReminder': 'Error al enviar el recordatorio',
    'devisDepl.confirmValidateBon': '¿Validar la orden de compra?',
    'devisDepl.errSendFacture': 'Error al enviar la factura',
    'devisDepl.confirmDetach': '¿Desvincular este presupuesto de la reparación {{ref}}?',
    'devisDepl.status.pending': 'Pendiente',
    'devisDepl.status.accepted': 'Aceptado',
    'devisDepl.status.refused': 'Rechazado',
    'devisDepl.status.depositPaid': 'Anticipo pagado',
    'devisDepl.status.paid': 'Pagado',
    'devisDepl.stats.total': 'Total',
    'devisDepl.stats.pending': 'Pendiente',
    'devisDepl.stats.accepted': 'Aceptados',
    'devisDepl.stats.refused': 'Rechazados',
    'devisDepl.stats.revenue': 'Ingresos',
    'devisDepl.filter.all': 'Todos los estados',
    'devisDepl.requests.title': 'Solicitudes de presupuesto entrantes',
    'devisDepl.requests.newCountSingular': '{{count}} nueva',
    'devisDepl.requests.newCountPlural': '{{count}} nuevas',
    'devisDepl.requests.defaultTitle': 'Solicitud de presupuesto',
    'devisDepl.requests.statusNew': 'Nuevo',
    'devisDepl.requests.statusInProgress': 'En curso',
    'devisDepl.requests.statusRefused': 'Rechazado',
    'devisDepl.requests.statusTreated': 'Procesado',
    'devisDepl.requests.client': 'Cliente',
    'devisDepl.requests.addressLabel': 'Dirección',
    'devisDepl.requests.createDevis': 'Crear presupuesto',
    'devisDepl.requests.markTreated': 'Procesado',
    'devisDepl.requests.refuse': 'Rechazar',
    'devisDepl.requests.refuseMotifLabel': 'Motivo del rechazo',
    'devisDepl.requests.refuseMotifPlaceholder': 'Motivo del rechazo (opcional)...',
    'devisDepl.requests.confirmRefuse': 'Confirmar el rechazo',
    'devisDepl.requests.refuseMotifShownLabel': 'Motivo del rechazo:',
    'devisDepl.sumup.title': 'Solicitudes de enlace SumUp',
    'devisDepl.sumup.pendingCount': '{{count}} pendiente(s)',
    'devisDepl.sumup.enterLinkAlert': 'Introduzca el enlace de SumUp',
    'devisDepl.sumup.linkSentAlert': '¡Enlace de SumUp enviado al cliente por correo!',
    'devisDepl.sumup.linkPlaceholder': 'Pega el enlace de SumUp aquí...',
    'devisDepl.chart.title': 'Actividad de los últimos 30 días',
    'devisDepl.chart.accepted': 'Aceptados',
    'devisDepl.chart.pending': 'Pendiente',
    'devisDepl.chart.refused': 'Rechazados',
    'devisDepl.chart.noData': 'No hay datos para este período',
    'devisDepl.form.editTitle': 'Editar presupuesto',
    'devisDepl.form.newTitle': 'Nuevo presupuesto',
    'devisDepl.form.clientName': 'Nombre del cliente *',
    'devisDepl.form.searchPlaceholder': 'Escribe para buscar...',
    'devisDepl.form.phone': 'Teléfono',
    'devisDepl.form.email': 'Correo *',
    'devisDepl.form.emailPlaceholder': 'correo@ejemplo.com',
    'devisDepl.form.address': 'Dirección',
    'devisDepl.form.addressPlaceholder': 'Dirección del cliente',
    'devisDepl.form.descriptionLabel': 'Descripción de la reparación',
    'devisDepl.form.descriptionPlaceholder': 'Descripción del trabajo a realizar...',
    'devisDepl.form.lines': 'Líneas del presupuesto',
    'devisDepl.form.addLine': 'Añadir',
    'devisDepl.form.designation': 'Descripción',
    'devisDepl.form.price': 'Precio',
    'devisDepl.form.travelFee': 'Tarifa de desplazamiento ({{amount}})',
    'devisDepl.form.acceptOnline': 'Aceptar pago en línea (SumUp)',
    'devisDepl.form.acceptOnlineHint': 'El cliente podrá solicitar un enlace de pago SumUp',
    'devisDepl.form.total': 'TOTAL',
    'devisDepl.form.submitEdit': 'Actualizar',
    'devisDepl.form.submitCreate': 'Crear presupuesto',
    'devisDepl.form.nameEmailRequired': 'El nombre y el correo del cliente son obligatorios',
    'devisDepl.form.atLeastOneLine': 'Añade al menos una línea con descripción y precio',
    'devisDepl.detail.phone': 'Tel.:',
    'devisDepl.detail.address': 'Dirección:',
    'devisDepl.detail.purchaseOrder': 'Orden de compra:',
    'devisDepl.detail.invoice': 'Factura:',
    'devisDepl.detail.emailSentOn': 'Correo enviado el {{date}}',
    'devisDepl.detail.reminderSentOn': 'Recordatorio enviado el {{date}}',
    'devisDepl.table.designation': 'Descripción',
    'devisDepl.table.qty': 'Cant.',
    'devisDepl.table.price': 'Precio',
    'devisDepl.table.total': 'Total',
    'devisDepl.actions.validateDevis': 'Validar presupuesto',
    'devisDepl.actions.sendByEmail': 'Enviar presupuesto por correo',
    'devisDepl.actions.remindAcceptance': 'Recordar aceptación',
    'devisDepl.actions.edit': 'Editar',
    'devisDepl.actions.validateBon': 'Validar orden de compra',
    'devisDepl.actions.bonValidated': 'Orden validada',
    'devisDepl.actions.remindPayment': 'Recordar pago',
    'devisDepl.actions.pdfDevis': 'PDF Presupuesto',
    'devisDepl.actions.pdfBon': 'PDF Orden de compra',
    'devisDepl.actions.pdfFacture': 'PDF Factura',
    'devisDepl.actions.sendFactureEmail': 'Enviar factura por correo',
    'devisDepl.actions.registerPayment': 'Registrar pago',
    'devisDepl.actions.delete': 'Eliminar',
    'devisDepl.actions.linkedTo': 'Vinculado a {{ref}}',
    'devisDepl.actions.attachToRepair': 'Vincular a reparación',
    'devisDepl.payment.title': 'Registrar un pago',
    'devisDepl.payment.devisLabel': 'Presupuesto:',
    'devisDepl.payment.totalLabel': 'Total:',
    'devisDepl.payment.methodLabel': 'Método de pago',
    'devisDepl.payment.cash': 'Efectivo',
    'devisDepl.payment.card': 'Tarjeta',
    'devisDepl.payment.transfer': 'Transferencia',
    'devisDepl.payment.mixed': 'Mixto',
    'devisDepl.payment.amount': 'Importe',
    'devisDepl.payment.noteLabel': 'Nota (opcional)',
    'devisDepl.payment.notePlaceholder': 'Ej.: anticipo, saldo...',
    'devisDepl.payment.submit': 'Confirmar el pago',
    'reviews.ratingFallback': 'Nuestros clientes nos valoran en Google',
    'reviews.subtitle': 'Descubre las opiniones de nuestros clientes en Google y comparte tu experiencia.',
    'reviews.readCta': 'Leer nuestras opiniones en Google',
    'reviews.writeCta': 'Dejar una opinión',
    'acompteStart.title': 'Anticipo de tu presupuesto',
    'acompteStart.subtitle': 'Resurrection Mobile · pago seguro con SumUp',
    'acompteStart.loading': 'Preparando el pago…',
    'acompteStart.redirecting': 'Redirigiendo a la página de pago',
    'acompteStart.clickHere': 'Haz clic aquí si no ocurre nada.',
    'acompteStart.paid': 'Este anticipo ya ha sido pagado. ¡Gracias! Tu pedido se está preparando.',
    'acompteStart.orderRef': 'Pedido {{ref}}',
    'acompteStart.errTitle': 'Pago en línea temporalmente no disponible',
    'acompteStart.retry': 'Reintentar',
    'acompteStart.whatsappPay': 'Pagar por WhatsApp / contactarnos',
    'acompteStart.inStore': 'El anticipo también puede pagarse directamente en la tienda.',
    'acompteStart.footer': 'Tras el pago, tu pedido de la pieza se registra automáticamente y te enviamos un recibo por correo electrónico.',
    'acompteStart.backToSite': 'Volver al sitio',
    'acompteStart.errLinkUnavailable': 'Enlace de pago no disponible.',
    'acompteStart.errOnlineUnavailable': 'El pago en línea no está disponible temporalmente.',
    'acompteStart.waMessage': 'Hola, quiero pagar el anticipo de mi presupuesto ({{id}}).',
    'emailVerif.loadingTitle': 'Verificando...',
    'emailVerif.loadingSub': 'Por favor, espera',
    'emailVerif.successTitle': '¡Cuenta activada!',
    'emailVerif.successDefault': '¡Correo electrónico verificado con éxito!',
    'emailVerif.login': 'Iniciar sesión',
    'emailVerif.errorTitle': 'Error de verificación',
    'emailVerif.errorDefault': 'Error de verificación',
    'emailVerif.invalidLink': 'Enlace de verificación no válido.',
    'emailVerif.backLogin': 'Volver al inicio de sesión',
    'emailVerif.expiredTitle': 'Enlace caducado',
    'emailVerif.expiredDefault': 'Este enlace ha caducado.',
    'emailVerif.backLoginResend': 'Volver al inicio de sesión (reenviar correo)',
    'paySuccess.noPaymentToVerify': 'Ningún pago que verificar',
    'paySuccess.statusCheckFailed': 'No se pudo verificar el estado. El pago se procesará automáticamente.',
    'paySuccess.verificationError': 'Error al verificar el pago',
    'paySuccess.completedTitle': '¡Pago exitoso!',
    'paySuccess.completedDesc': 'Su pago ha sido confirmado y aplicado a su expediente.',
    'paySuccess.failedTitle': 'Pago fallido',
    'paySuccess.failedDesc': 'No se pudo procesar el pago. Inténtelo de nuevo.',
    'paySuccess.pendingTitle': 'Pago en proceso',
    'paySuccess.pendingDesc': 'Su pago se está verificando. Se aplicará automáticamente.',
    'paySuccess.verifying': 'Verificando el pago...',
    'paySuccess.errorTitle': 'Error',
    'paySuccess.amountLabel': 'Importe:',
    'paySuccess.repairLabel': 'Reparación:',
    'paySuccess.orderLabel': 'Pedido:',
    'paySuccess.referenceLabel': 'Referencia:',
    'paySuccess.noInfo': 'No hay información de pago disponible.',
    'paySuccess.backToSpace': 'Volver a mi espacio',
    'devisChat.errStart': 'No se pudo iniciar el chat. Inténtalo de nuevo.',
    'devisChat.errSend': 'Error al enviar',
    'devisChat.errNetwork': 'Error de red',
    'devisChat.hint': 'Pide tu presupuesto por correo',
    'devisChat.fabAria': 'Pedir un presupuesto',
    'devisChat.fabLabel': 'Presupuesto gratis',
    'devisChat.panelTitle': 'Presupuesto R.E.Mobiles',
    'devisChat.panelSubtitle': 'Envío por correo tras la validación',
    'devisChat.close': 'Cerrar',
    'devisChat.connecting': 'Conectando…',
    'devisChat.inputPlaceholder': 'Ej. pantalla iPhone 13…',
    'register.emailRequired': 'El correo electrónico es obligatorio para crear una cuenta.',
    'register.passwordMinLength': 'La contraseña debe contener al menos 4 caracteres.',
    'register.passwordMismatch': 'Las contraseñas no coinciden.',
    'register.registerError': 'Error durante el registro',
    'register.verifyEmailTitle': '¡Revisa tu correo electrónico!',
    'register.confirmationSentTo': 'Se ha enviado un correo de confirmación a:',
    'register.activateHint': 'Haz clic en el enlace del correo para activar tu cuenta. Revisa también tu carpeta de spam si no lo ves.',
    'register.goToLogin': 'Ir a iniciar sesión',
    'register.clientSubtitle': 'Accede al seguimiento de tus reparaciones',
    'register.namePlaceholder': 'Juan Pérez',
    'register.emailPlaceholder': 'correo@ejemplo.com',
    'register.emailHint': 'Se enviará un correo de confirmación para activar tu cuenta',
    'register.addressPlaceholder': 'Calle Ejemplo 123',
    'register.password': 'Contraseña',
    'register.confirmPassword': 'Confirmar contraseña',
    'register.referralCode': 'Código de referido (opcional)',
    'register.referredBy': 'Recomendado por {{nom}}',
    'register.invalidReferral': 'Código de referido no válido',
    'register.termsNotice': 'Al crear una cuenta, aceptas nuestros términos de uso',
    'login.googleDisabled': 'El inicio de sesión con Google se ha desactivado. Usa tu usuario y contraseña.',
    'login.invalid2FA': 'Código 2FA no válido',
    'login.tabStaff': 'Personal',
    'login.tabClient': 'Cliente',
    'login.tabBusiness': 'Empresa',
    'login.frenchGuiana': 'Guayana Francesa',
    'login.emailNotVerifiedTitle': 'Correo no verificado',
    'login.emailNotVerifiedDesc': 'Debes confirmar tu correo antes de iniciar sesión.',
    'login.emailResent': '¡Correo reenviado! Revisa tu bandeja de entrada.',
    'login.sending': 'Enviando...',
    'login.resendVerification': 'Reenviar correo de confirmación',
    'login.back': 'Volver',
    'login.twoFATitle': 'Verificación 2FA',
    'login.twoFASubtitle': 'Introduce el código de tu aplicación',
    'login.verifying': 'Verificando...',
    'login.verify': 'Verificar',
    'login.passwordPlaceholder': 'Tu contraseña',
    'login.allRightsReserved': 'Todos los derechos reservados.',
    'acompteSuccess.errorIncompleteLink': 'Enlace de pago incompleto.',
    'acompteSuccess.errorCannotConfirm': 'No se puede confirmar el pago por el momento.',
    'acompteSuccess.whatsappMessage': 'Hola, he pagado el anticipo de mi presupuesto (ref. {{ref}}). ¿Pueden confirmar mi pedido?',
    'acompteSuccess.whatsappDefault': 'Escríbenos por WhatsApp',
    'acompteSuccess.errorHint': 'Si su pago se ha cargado correctamente, su pedido se registrará automáticamente en los próximos minutos y recibirá un correo de confirmación.',
    'acompteSuccess.appliedTitle': 'Anticipo recibido',
    'acompteSuccess.orderRegisteredLead': 'Gracias. Su pedido de pieza',
    'acompteSuccess.orderRegisteredTail': 'está registrado. Se le ha enviado un recibo por correo electrónico; recibirá el número de seguimiento en cuanto se envíe.',
    'acompteSuccess.staffPendingTitle': 'Pago recibido',
    'acompteSuccess.staffPendingBody': 'Su anticipo se ha registrado correctamente en SumUp. Nuestro equipo está finalizando su pedido manualmente y se lo confirmará por correo electrónico muy pronto.',
    'acompteSuccess.whatsappQuestion': '¿Una pregunta? WhatsApp',
    'acompteSuccess.sumupFailedTitle': 'Pago no completado',
    'acompteSuccess.sumupFailedBody': 'SumUp no confirmó el pago ({{status}}). Puede volver a intentarlo desde el enlace de su correo de presupuesto, o contactarnos.',
    'acompteSuccess.timedOutTitle': 'Confirmación en curso',
    'acompteSuccess.timedOutBody': 'SumUp aún no ha confirmado su pago. No se preocupe: si se realizó el cargo, su pedido se creará automáticamente en los próximos minutos y recibirá un correo de confirmación. Puede cerrar esta página.',
    'acompteSuccess.recheckNow': 'Volver a verificar ahora',
    'acompteSuccess.whatsappProof': 'Enviar el comprobante de pago por WhatsApp',
    'acompteSuccess.verifyingTitle': 'Verificando el pago…',
    'acompteSuccess.verifyingBody': 'Espere unos segundos, por favor.',
    'acompteSuccess.backHome': 'Volver al inicio',
    'b2bDashboard.acceptRefuse': 'Aceptar / Rechazar',
    'b2bDashboard.actions': 'Acciones',
    'b2bDashboard.addNotePlaceholder': 'Añadir una nota sobre esta reparación...',
    'b2bDashboard.addPhoto': '+ Añadir',
    'b2bDashboard.additionalInfoPlaceholder': 'Información adicional...',
    'b2bDashboard.additionalNotes': 'Notas adicionales',
    'b2bDashboard.addressOptional': 'Dirección (opcional)',
    'b2bDashboard.addressPlaceholder': 'Dirección para desplazamiento si es necesario',
    'b2bDashboard.alertDescribeRequest': 'Por favor, describa su solicitud',
    'b2bDashboard.amount': 'Importe',
    'b2bDashboard.awaitingReceptionStore': 'En espera de recepción en tienda',
    'b2bDashboard.back': 'Volver',
    'b2bDashboard.backGlass': 'Cristal trasero',
    'b2bDashboard.backGlassBroken': 'Cristal trasero roto',
    'b2bDashboard.backGlassIntact': 'Cristal trasero intacto',
    'b2bDashboard.brandModelRequired': 'La marca y el modelo son obligatorios',
    'b2bDashboard.broken': 'Roto',
    'b2bDashboard.changePassword': 'Cambiar contraseña',
    'b2bDashboard.chat': 'Chatear',
    'b2bDashboard.clear': 'Borrar',
    'b2bDashboard.clickNewRequestHint': 'Haga clic en «Nueva solicitud» para crear una',
    'b2bDashboard.clickToAddPhotos': 'Haga clic para añadir fotos',
    'b2bDashboard.code': 'Código',
    'b2bDashboard.code6Digits': 'Código de 6 dígitos',
    'b2bDashboard.codeDigitsLetters': 'Código (números/letras)',
    'b2bDashboard.codeValidatedSuccess': '¡Código validado con éxito!',
    'b2bDashboard.confirmOrderEmailPre': 'Se ha enviado a su correo un pedido con un código de confirmación. Introduzca este código en la sección ',
    'b2bDashboard.confirmOrderEmailPost': ' para validar su pedido.',
    'b2bDashboard.createdOn': 'Creada el',
    'b2bDashboard.customerProvidesPart': 'Yo aporto la pieza',
    'b2bDashboard.date': 'Fecha',
    'b2bDashboard.delivery': 'Entrega',
    'b2bDashboard.delivery.pickup': 'Recogida',
    'b2bDashboard.delivery.postal': 'Envío postal',
    'b2bDashboard.delivery.store': 'En tienda',
    'b2bDashboard.describeProblemPlaceholder': 'Describa el problema...',
    'b2bDashboard.designation': 'Concepto',
    'b2bDashboard.device': 'Dispositivo',
    'b2bDashboard.devisStatus.accepted': 'Aceptado',
    'b2bDashboard.devisStatus.depositPaid': 'Anticipo pagado',
    'b2bDashboard.devisStatus.paid': 'Pagado',
    'b2bDashboard.devisStatus.pending': 'Pendiente',
    'b2bDashboard.devisStatus.refused': 'Rechazado',
    'b2bDashboard.diagRef': 'Ref. diag.:',
    'b2bDashboard.documentsWord': 'Documentos',
    'b2bDashboard.downloadError': 'Error al descargar',
    'b2bDashboard.downloadPdf': 'Descargar PDF',
    'b2bDashboard.enter6DigitCode': 'Introduzca el código de 6 dígitos',
    'b2bDashboard.enterCodePerOrder': 'Introduzca el código recibido por correo para validar cada pedido.',
    'b2bDashboard.enterCodeToValidate': 'Introduzca el código recibido por correo para validar su pedido.',
    'b2bDashboard.enterPinPlaceholder': 'Introduzca el código PIN, contraseña...',
    'b2bDashboard.enterValidationCode': 'Por favor, introduzca el código de validación',
    'b2bDashboard.error': 'Error',
    'b2bDashboard.filter.all': 'Todas',
    'b2bDashboard.history': 'Historial',
    'b2bDashboard.imeiSerial': 'IMEI / N.º de serie',
    'b2bDashboard.imeiSerialShort': 'IMEI / Serie',
    'b2bDashboard.incorrectCode': 'Código incorrecto',
    'b2bDashboard.invoiceLabel': 'Factura:',
    'b2bDashboard.invoiceType.combined': 'Comb.',
    'b2bDashboard.invoiceType.diag': 'Diag',
    'b2bDashboard.invoiceType.repair': 'Repar.',
    'b2bDashboard.invoices': 'Facturas',
    'b2bDashboard.invoicesAppearWhenPriced': 'Las facturas aparecen en cuanto R.E.Mobiles fija el precio',
    'b2bDashboard.latePayment': 'RETRASO DE PAGO - {{days}} días',
    'b2bDashboard.lock': 'Bloqueo',
    'b2bDashboard.lockCode': 'Código de bloqueo',
    'b2bDashboard.mostRecent': 'Más recientes',
    'b2bDashboard.nav.documents': 'Presupuestos / Facturas',
    'b2bDashboard.nav.quoteRequest': 'Solicitar un presupuesto',
    'b2bDashboard.newQuoteRequest': 'Nueva solicitud de presupuesto',
    'b2bDashboard.newRequest': 'Nueva solicitud',
    'b2bDashboard.noInvoiceAvailable': 'No hay facturas disponibles',
    'b2bDashboard.noPhoto': 'Sin fotos',
    'b2bDashboard.noPosInvoice': 'Ninguna factura de compra',
    'b2bDashboard.noQuoteRequest': 'Ninguna solicitud de presupuesto',
    'b2bDashboard.noTravelQuote': 'Ningún presupuesto de desplazamiento',
    'b2bDashboard.nonFunctionalParts': 'Piezas no funcionales',
    'b2bDashboard.noteSaveError': 'Error al guardar la nota',
    'b2bDashboard.notes': 'Notas',
    'b2bDashboard.oldest': 'Más antiguas',
    'b2bDashboard.optional': 'Opcional',
    'b2bDashboard.orderValidated': 'Pedido validado',
    'b2bDashboard.orderValidatedSuccess': '¡Pedido validado!',
    'b2bDashboard.orderValidationCode': 'Código de validación del pedido',
    'b2bDashboard.paid': 'Pagada',
    'b2bDashboard.paidLabel': 'Pagado',
    'b2bDashboard.partProvidedByStore': 'R.E.Mobiles aportará la pieza',
    'b2bDashboard.parts.backCam': 'Cámara trasera',
    'b2bDashboard.parts.backGlass': 'Cristal trasero',
    'b2bDashboard.parts.battery': 'Batería',
    'b2bDashboard.parts.chargingPort': 'Puerto de carga',
    'b2bDashboard.parts.earSpeaker': 'Auricular',
    'b2bDashboard.parts.fingerprint': 'Huella',
    'b2bDashboard.parts.frontCam': 'Cámara frontal',
    'b2bDashboard.parts.homeButton': 'Botón de inicio',
    'b2bDashboard.parts.lcd': 'Pantalla',
    'b2bDashboard.parts.microphone': 'Micrófono',
    'b2bDashboard.parts.powerButton': 'Botón de encendido',
    'b2bDashboard.parts.signal': 'Señal',
    'b2bDashboard.parts.speaker': 'Altavoz',
    'b2bDashboard.parts.volumeButton': 'Volumen',
    'b2bDashboard.parts.wifiBt': 'Wi-Fi/BT',
    'b2bDashboard.pattern': 'Patrón',
    'b2bDashboard.pay': 'Pagar',
    'b2bDashboard.payRemaining': 'Pagar el resto ({{amount}})',
    'b2bDashboard.paymentCreateError': 'Error al crear el pago',
    'b2bDashboard.paymentLinkUnavailable': 'Enlace de pago no disponible. Contacte con R.E.Mobiles.',
    'b2bDashboard.pdfDownloadError': 'Error al descargar el PDF',
    'b2bDashboard.pdfInvoice': 'PDF Factura',
    'b2bDashboard.pdfPurchaseOrder': 'PDF Pedido',
    'b2bDashboard.pdfQuote': 'PDF Presupuesto',
    'b2bDashboard.penaltiesLine': 'Penalizaciones: {{penalty}} + Indemnización: {{indemnity}}',
    'b2bDashboard.photos': 'Fotos',
    'b2bDashboard.pickupAddress': 'Dirección de recogida',
    'b2bDashboard.pickupAddressPlaceholder': 'Dirección completa donde recoger el teléfono...',
    'b2bDashboard.pickupAddressRequired': 'Por favor, introduzca la dirección de recogida',
    'b2bDashboard.pickupRequested': 'Recogida solicitada: iremos a buscar el dispositivo',
    'b2bDashboard.posInvoices': 'Facturas de compra (POS)',
    'b2bDashboard.price': 'Precio',
    'b2bDashboard.priceCol': 'Precio',
    'b2bDashboard.priceDiagnostic': 'Precio de diagnóstico',
    'b2bDashboard.pricePending': 'Pendiente: lo fijará R.E.Mobiles',
    'b2bDashboard.priceRepair': 'Precio de reparación',
    'b2bDashboard.problem': 'Problema',
    'b2bDashboard.problemDescription': 'Problema / Descripción',
    'b2bDashboard.purchaseOrderLabel': 'Pedido:',
    'b2bDashboard.quoteRequestTitle': 'Solicitud de presupuesto',
    'b2bDashboard.refusalReason': 'Motivo del rechazo:',
    'b2bDashboard.remaining': 'Resto',
    'b2bDashboard.repairAcceptedByStaff': 'Reparación aceptada por el personal',
    'b2bDashboard.repairRefusedByStaff': 'Reparación rechazada por el personal',
    'b2bDashboard.repairTitle': 'Reparación {{ref}}',
    'b2bDashboard.requestDescription': 'Descripción de su solicitud',
    'b2bDashboard.requestDescriptionPlaceholder': 'Describa lo que desea: tipo de reparación, cantidad, problemas, etc.',
    'b2bDashboard.requestStatus.inProgress': 'En curso',
    'b2bDashboard.requestStatus.new': 'Nuevo',
    'b2bDashboard.requestStatus.processed': 'Procesado',
    'b2bDashboard.requestStatus.refused': 'Rechazado',
    'b2bDashboard.retentionInvoices': 'Las facturas se conservan en nuestros servidores durante 18 meses.',
    'b2bDashboard.retentionQuotes': 'Los presupuestos se conservan en nuestros servidores durante 1 mes.',
    'b2bDashboard.saveNote': 'Guardar nota',
    'b2bDashboard.saving': 'Guardando...',
    'b2bDashboard.searchPlaceholder': 'Buscar...',
    'b2bDashboard.sendRequest': 'Enviar mi solicitud',
    'b2bDashboard.sending': 'Enviando...',
    'b2bDashboard.status.awaitingParts': 'Esp. piezas',
    'b2bDashboard.status.awaitingPickup': 'Esp. recogida',
    'b2bDashboard.status.awaitingReception': 'Esp. recepción',
    'b2bDashboard.status.completed': 'Terminado',
    'b2bDashboard.status.delivered': 'Entregado',
    'b2bDashboard.status.inProgress': 'En curso',
    'b2bDashboard.status.received': 'Recibido',
    'b2bDashboard.status.refused': 'Rechazado',
    'b2bDashboard.statusCol': 'Estado',
    'b2bDashboard.submitError': 'Error al enviar',
    'b2bDashboard.teamResponse': 'Respuesta del equipo:',
    'b2bDashboard.titleOptional': 'Título (opcional)',
    'b2bDashboard.titlePlaceholder': 'Ej.: Reparación lote pantallas Samsung',
    'b2bDashboard.total': 'Total',
    'b2bDashboard.totalDue': 'Total a pagar: {{amount}}',
    'b2bDashboard.trackingBadge': 'Seguimiento:',
    'b2bDashboard.trackingNumber': 'Número de seguimiento',
    'b2bDashboard.trackingPlaceholder': 'Ej.: 1Z999AA10123456784',
    'b2bDashboard.trackingRequired': 'Por favor, introduzca el número de seguimiento para el envío postal',
    'b2bDashboard.trackingShort': 'N.º seguimiento',
    'b2bDashboard.travelFee': 'Gastos de desplazamiento',
    'b2bDashboard.travelQuotes': 'Presupuestos de desplazamiento',
    'b2bDashboard.uploadError': 'Error al subir',
    'b2bDashboard.uploading': 'Subiendo...',
    'b2bDashboard.validate': 'Validar',
    'b2bDashboard.validationCodeConfirmed': 'Código de validación confirmado',
    'client.mySpace': 'Mi Espacio',
    'client.invoiceDownloadError': 'Error al descargar la factura',
    'client.invoiceViewError': 'Error al mostrar la factura',
    'client.invoicePrintError': 'Error al imprimir la factura',
    'client.pinMustBe4': 'El código PIN debe tener 4 dígitos',
    'client.pinMismatch': 'Los códigos PIN no coinciden',
    'client.pinChanged': '¡Código PIN modificado con éxito!',
    'client.pinChangeError': 'Error al cambiar el PIN',
    'client.describeRequest': 'Describa su solicitud',
    'client.error': 'Error',
    'client.enterValidationCode': 'Introduzca el código de validación',
    'client.codeValidated': '¡Código validado con éxito!',
    'client.codeIncorrect': 'Código incorrecto',
    'client.sumupUrlUnavailable': 'Error: URL de pago de SumUp no disponible',
    'client.sumupCreateError': 'Error al crear el pago de SumUp',
    'client.fillRequired': 'Complete todos los campos obligatorios',
    'client.invalidEmail': 'Dirección de correo electrónico no válida',
    'client.requestError': 'Error durante la solicitud',
    'client.trackingSaved': '¡Número de seguimiento guardado!',
    'client.statusText.recu': 'Dispositivo recibido en el taller',
    'client.statusText.enCours': 'Reparación en curso',
    'client.statusText.attentePieces': 'A la espera de piezas',
    'client.statusText.termine': 'Reparación finalizada - Para recoger',
    'client.statusText.livre': 'Dispositivo recogido',
    'client.statusText.demandeEnLigne': 'A la espera de recibir el dispositivo',
    'client.statusText.nonReparable': 'Dispositivo no reparable',
    'client.statusLabel.recu': 'Recibido',
    'client.statusLabel.enCours': 'En curso',
    'client.statusLabel.attentePieces': 'Espera de piezas',
    'client.statusLabel.termine': 'Finalizado',
    'client.statusLabel.livre': 'Entregado',
    'client.statusLabel.recupere': 'Recogido',
    'client.statusLabel.demandeEnLigne': 'Solicitud en línea',
    'client.statusLabel.nonReparable': 'No reparable',
    'client.created': 'Creado',
    'client.technicianNotes': 'Notas del técnico',
    'client.noNotes': 'Aún no hay notas',
    'client.file': 'archivo',
    'client.files': 'archivos',
    'client.navigation': 'Navegación',
    'client.devisFactures': 'Presupuestos / Facturas',
    'client.myAddresses': 'Mis direcciones',
    'client.myAccount': 'Mi cuenta',
    'client.needHelp': '¿Necesita ayuda?',
    'client.helpHours': 'Nuestro equipo le atiende de lunes a sábado de 9 a 19 h.',
    'client.contactUs': 'Contáctenos',
    'client.contactSupport': 'Contactar con soporte',
    'client.guideMe': 'Guíame',
    'client.logout': 'Cerrar sesión',
    'client.changePassword': 'Cambiar contraseña',
    'client.addresses': 'Direcciones',
    'client.requestRepair': 'Solicitar una reparación',
    'client.showDelivered': 'Ver entregados',
    'client.hideDelivered': 'Ocultar entregados',
    'client.noRepairsInProgress': 'Ninguna reparación en curso',
    'client.onlineRepairRequest': 'Solicitud de reparación en línea',
    'client.diagFeeFormPre': 'Complete el formulario a continuación. La tarifa de diagnóstico de',
    'client.diagFeeFormPost': 'debe pagarse en línea.',
    'client.repairReason': 'Motivo de la reparación',
    'client.repairReasonPlaceholder': 'Ej.: Pantalla rota, batería...',
    'client.fullName': 'Nombre y apellidos',
    'client.fullNamePlaceholder': 'Su nombre completo',
    'client.postalAddress': 'Dirección postal',
    'client.addressPlaceholder': 'Su dirección',
    'client.emailAddress': 'Correo electrónico',
    'client.emailPlaceholder': 'correo@ejemplo.com',
    'client.describeIssue': 'Describa la avería en detalle',
    'client.describeIssuePlaceholder': 'Cuéntenos cómo se averió el teléfono/tableta y los síntomas observados...',
    'client.devicePhotos': 'Fotos del dispositivo',
    'client.addPhotos': 'Añadir fotos',
    'client.cancel': 'Cancelar',
    'client.sending': 'Enviando...',
    'client.sendRequest': 'Enviar solicitud',
    'client.requestSaved': 'Solicitud registrada: {{ref}}',
    'client.redirecting': 'Redirigiendo...',
    'client.payDiagnosticSumup': 'Pagar {{amount}} con SumUp (diagnóstico)',
    'client.diagFeePending': 'Su solicitud está pendiente. Para iniciar el diagnóstico, pague la tarifa de',
    'client.depositOrSend': 'Deje su dispositivo en la tienda o envíelo por correo con acuse de recibo:',
    'client.trackingPlaceholder': 'Número de seguimiento postal',
    'client.save': 'Guardar',
    'client.postalDelayNotice': 'Si se envía por correo: el plazo se amplía a 20 días antes de que caduque la solicitud (40 días para su eliminación)',
    'client.close': 'Cerrar',
    'client.progress': 'Progreso',
    'client.deposits': 'Anticipos',
    'client.rest': 'Restante',
    'client.payWithSumup': 'Pagar {{amount}} con SumUp',
    'client.detailedTracking': 'Seguimiento detallado',
    'client.chatRepair': 'Chat de reparación {{ref}}',
    'client.contact': 'Contactar',
    'client.photosCount': 'Fotos ({{count}})',
    'client.level': 'Nivel {{name}}',
    'client.tierOr': 'Oro',
    'client.tierArgent': 'Plata',
    'client.tierBronze': 'Bronce',
    'client.totalPurchases': '{{count}} compra(s) en total',
    'client.nextLevel': 'Siguiente nivel:',
    'client.purchasesToNext': '{{count}} compra(s) restante(s)',
    'client.rewardAvailable': '¡Recompensa disponible!',
    'client.reward10Reached': 'Enhorabuena, ha alcanzado {{count}} compras',
    'client.rewardPosDesc': 'en su próxima compra en tienda',
    'client.rewardRepairDesc': 'en su próxima reparación',
    'client.loyaltyPoints': 'Puntos de fidelidad',
    'client.purchasesUntilReward': 'Solo {{count}} compra(s) para la recompensa',
    'client.rewardReached': '¡Recompensa alcanzada!',
    'client.rewardsHistory': 'Historial de recompensas',
    'client.reward15Pos': '-15% en tienda',
    'client.reward10Repair': '-10% Reparación',
    'client.referralProgram': 'Programa de Referidos',
    'client.referralSubtitle': 'Comparta su código y gane puntos extra',
    'client.yourReferralCode': 'Su código de referido',
    'client.copied': '¡Copiado!',
    'client.copy': 'Copiar',
    'client.referralShare1': 'Comparta este código con sus allegados. Cuando se registren con él, usted gana',
    'client.referralBonusPoints': '+2 puntos',
    'client.referralShare2': 'de fidelidad!',
    'client.copyReferralLink': 'Copiar el enlace de registro',
    'client.referrals': 'Referido(s)',
    'client.bonusPoints': 'Puntos extra',
    'client.yourReferrals': 'Sus referidos',
    'client.referralFallback': 'Referido',
    'client.myDevis': 'Mis Presupuestos',
    'client.newRequest': 'Nueva solicitud',
    'client.newDevisRequest': 'Nueva solicitud de presupuesto',
    'client.titleOptional': 'Título (opcional)',
    'client.devisTitlePlaceholder': 'Ej.: Reparación de pantalla iPhone 15',
    'client.requestDescription': 'Descripción de su solicitud',
    'client.devisDescPlaceholder': 'Describa lo que desea: tipo de reparación, problema, etc.',
    'client.addressOptional': 'Dirección (opcional, para desplazamiento)',
    'client.devisAddressPlaceholder': 'Su dirección si desea un desplazamiento',
    'client.sendMyRequest': 'Enviar mi solicitud',
    'client.myDevisRequests': 'Mis solicitudes de presupuesto',
    'client.devisRequestTitle': 'Solicitud de presupuesto',
    'client.devisReqNouveau': 'Nuevo',
    'client.devisReqEnCours': 'En curso',
    'client.devisReqRefuse': 'Rechazado',
    'client.devisReqTraite': 'Procesado',
    'client.teamResponse': 'Respuesta del equipo:',
    'client.refusalReason': 'Motivo del rechazo:',
    'client.clickNewRequest': 'Haga clic en «Nueva solicitud» para crear una',
    'client.designation': 'Concepto',
    'client.price': 'Precio',
    'client.travelFees': 'Gastos de desplazamiento',
    'client.totalUpper': 'TOTAL',
    'client.paid': 'Pagado',
    'client.purchaseOrder': 'Orden de compra',
    'client.invoice': 'Factura',
    'client.latePayment': 'PAGO ATRASADO - {{days}} días',
    'client.latePenaltyLabel': 'Penalizaciones por demora ({{rate}}% anual)',
    'client.recoveryIndemnity': 'Indemnización fija por cobro',
    'client.totalWithPenalties': 'Total adeudado con penalizaciones',
    'client.validationCodeTitle': 'Código de validación de la orden de compra',
    'client.validationCodeDesc': 'Introduzca el código recibido por correo para validar su pedido.',
    'client.code6digits': 'Código de 6 dígitos',
    'client.validate': 'Validar',
    'client.codeConfirmed': 'Código de validación confirmado',
    'client.pdfDevis': 'PDF Presupuesto',
    'client.pdfPurchaseOrder': 'PDF Orden de compra',
    'client.pdfInvoice': 'PDF Factura',
    'client.payRest': 'Pagar el resto ({{amount}})',
    'client.deposit50': 'Anticipo 50%',
    'client.fullPayment': 'Pago completo',
    'client.myInvoices': 'Mis Facturas',
    'client.mostRecent': 'Más recientes',
    'client.oldest': 'Más antiguas',
    'client.noInvoices': 'No hay facturas disponibles',
    'client.view': 'Ver',
    'client.print': 'Imprimir',
    'client.seeLess': 'Ver menos',
    'client.seeMoreInvoices': 'Ver más ({{count}} facturas)',
    'client.invoiceRetention': 'Las facturas se conservan en nuestros servidores durante 18 meses.',
    'client.devisRetention': 'Los presupuestos se conservan en nuestros servidores durante 1 mes.',
    'client.createCaricature': 'Creo mi caricatura',
    'client.copyrightBy': 'Copyright de',
    'client.notifications': 'Notificaciones',
    'client.markAllRead': 'Marcar todo como leído',
    'client.noNotifications': 'Sin notificaciones',
    'client.pinChangeTitle': 'Cambio de código PIN',
    'client.pinChangeDesc': 'Por su seguridad, elija un nuevo código PIN de 4 dígitos.',
    'client.newPin': 'Nuevo código PIN',
    'client.confirmPin': 'Confirmar PIN',
    'client.modifying': 'Modificando...',
    'client.changePin': 'Cambiar mi código PIN',
    'client.proofSent': '¡Comprobante de pago enviado! El personal lo verificará.',
    'client.sendError': 'Error al enviar',
    'client.orderStatusEnAttente': 'Pendiente',
    'client.orderStatusPayee': 'Pagada',
    'client.orderStatusProofUploaded': 'Comprobante enviado',
    'client.orderStatusConfirmee': 'Confirmada',
    'client.orderStatusPreparee': 'Preparada',
    'client.orderStatusExpediee': 'Enviada',
    'client.orderStatusLivree': 'Entregada',
    'client.orderStatusAnnulee': 'Cancelada',
    'client.trackingNumber': 'Número de seguimiento:',
    'client.trackingHint': 'Use este número para seguir su paquete',
    'client.stepCommande': 'Pedido',
    'client.proofSentLabel': 'Comprobante de pago enviado',
    'client.sentOn': 'Enviado el',
    'client.validatedByStaff': 'Validado por el personal',
    'client.payWithSumupPlain': 'Pagar con SumUp',
    'client.sendProof': 'Enviar comprobante de pago (captura)',
    'client.history': 'Historial',
    'client.chatOrder': 'Chat del pedido {{ref}}',
    'client.homeLabel': 'Domicilio',
    'client.enterFullAddress': 'Introduzca su dirección completa.',
    'client.saveError': 'Error al guardar',
    'client.addressLabelField': 'Etiqueta',
    'client.labelPlaceholder': 'Domicilio, Oficina...',
    'client.phone': 'Teléfono',
    'client.phonePlaceholder': '06 94 ...',
    'client.recipient': 'Destinatario',
    'client.recipientPlaceholder': 'Nombre del destinatario',
    'client.deliveryAddress': 'Dirección de entrega',
    'client.addressInputPlaceholder': 'Introduzca su dirección completa',
    'client.freeAddressHint': 'Entrada libre: seleccione una sugerencia si aparece; de lo contrario, escriba su dirección.',
    'client.searching': 'Buscando...',
    'client.addressValidated': 'Dirección validada',
    'client.saving': 'Guardando...',
    'client.confirmDeleteAddress': '¿Eliminar esta dirección?',
    'client.manageAddressesSubtitle': 'Gestione sus direcciones de entrega',
    'client.addAddress': 'Añadir una dirección',
    'client.newAddress': 'Nueva dirección',
    'client.editAddress': 'Editar la dirección',
    'client.default': 'Predeterminada',
    'client.edit': 'Editar',
    'client.delete': 'Eliminar',
    'client.setDefault': 'Establecer como predeterminada',
    'client.selectAddress': 'Seleccione o añada una dirección de entrega.',
    'client.orderSuccess': '¡Pedido realizado con éxito!',
    'client.orderError': 'Error al realizar el pedido',
    'client.ourAccessories': 'Nuestros accesorios',
    'client.expertSelection': 'Selección probada por nuestros expertos',
    'client.allCategories': 'Todas las categorías',
    'client.cart': 'Carrito',
    'client.noArticles': 'No hay artículos disponibles',
    'client.inStock': 'En stock',
    'client.unavailable': 'No disponible',
    'client.add': 'Añadir',
    'client.myCart': 'Mi carrito',
    'client.articleSingular': 'artículo',
    'client.articlesPlural': 'artículos',
    'client.cartEmpty': 'Su carrito está vacío',
    'client.manage': 'Gestionar',
    'client.processing': 'Procesando...',
    'client.payOnDelivery': 'Pago contra entrega',
    'publicShop.status.en_attente': 'En espera',
    'publicShop.status.en_cours': 'En curso',
    'publicShop.status.termine': 'Terminado',
    'publicShop.status.pret': 'Listo',
    'publicShop.status.livre': 'Entregado',
    'publicShop.status.annule': 'Cancelado',
    'publicShop.repairNotFound': 'Reparación no encontrada',
    'publicShop.shopNotFound': 'Tienda no encontrada',
    'publicShop.trackTitle': 'Seguir mi reparación',
    'publicShop.trackSubtitle': 'Introduzca su número de serie o código de seguimiento',
    'publicShop.trackPlaceholder': 'Número de serie o código de seguimiento...',
    'publicShop.trackButton': 'Seguir',
    'publicShop.labelDateEntree': 'Fecha de entrada:',
    'publicShop.labelSortiePrevue': 'Salida prevista:',
    'publicShop.labelProbleme': 'Problema:',
    'publicShop.labelRemarques': 'Observaciones:',
    'publicShop.poweredBy': 'Desarrollado por {{brand}}',
    'invoiceRequest.subtitle': 'Solicitud de factura',
    'invoiceRequest.search.title': 'Busca tu compra',
    'invoiceRequest.search.hint': 'Introduce el importe exacto y la hora aproximada.',
    'invoiceRequest.search.amountLabel': 'Importe pagado (EUR)',
    'invoiceRequest.search.amountPlaceholder': 'Ej.: 25.00',
    'invoiceRequest.search.timeLabel': 'Hora',
    'invoiceRequest.search.dateLabel': 'Fecha',
    'invoiceRequest.search.loading': 'Buscando…',
    'invoiceRequest.search.submit': 'Buscar',
    'invoiceRequest.results.title': 'Selecciona tu compra',
    'invoiceRequest.results.paidLabel': 'Pagado:',
    'invoiceRequest.itemsCount': '{{count}} artículo(s)',
    'invoiceRequest.back': 'Volver',
    'invoiceRequest.form.title': 'Tus datos',
    'invoiceRequest.form.purchase': 'Compra',
    'invoiceRequest.form.alreadyPaid': 'Ya pagado',
    'invoiceRequest.form.payment': 'Pago',
    'invoiceRequest.form.remaining': 'Restante',
    'invoiceRequest.form.nameLabel': 'Nombre completo',
    'invoiceRequest.form.namePlaceholder': 'Juan Pérez',
    'invoiceRequest.form.emailLabel': 'Correo electrónico',
    'invoiceRequest.form.emailPlaceholder': 'juan@ejemplo.com',
    'invoiceRequest.form.phoneLabel': 'Teléfono',
    'invoiceRequest.form.phonePlaceholder': '0694XXXXXX',
    'invoiceRequest.form.sending': 'Enviando…',
    'invoiceRequest.form.submit': 'Enviar la factura',
    'invoiceRequest.pending.title': 'Solicitud pendiente',
    'invoiceRequest.pending.desc': 'Esta factura ya se envió a otra dirección.',
    'invoiceRequest.pending.validationRequired': 'Validación requerida',
    'invoiceRequest.pending.info': 'Tu solicitud se ha enviado a nuestro equipo. Recibirás la factura en {{email}} una vez validada.',
    'invoiceRequest.newRequest': 'Nueva solicitud',
    'invoiceRequest.success.title': '¡Factura enviada!',
    'invoiceRequest.success.desc': 'Tu factura se ha enviado a {{email}}.',
    'invoiceRequest.success.accountCreated': '¡Cuenta de cliente creada!',
    'invoiceRequest.success.newAccountDesc': 'Tus credenciales de acceso se han enviado a {{email}}.',
    'invoiceRequest.success.sendingCredentials': 'Enviando…',
    'invoiceRequest.success.resendCredentials': 'Recibir mis credenciales por correo',
    'invoiceRequest.success.credentialsSent': 'Credenciales enviadas a {{email}}',
    'invoiceRequest.success.trackRepairs': 'Seguir mis reparaciones',
    'invoiceRequest.footer': 'R.E.Mobiles — 102 Avenue Général de Gaulle, Porte 2, 97300 Cayenne',
    'invoiceRequest.errors.search': 'Error de búsqueda',
    'invoiceRequest.errors.notFound': 'No se encontró ninguna venta con ese importe y esa hora. Verifica los datos.',
    'invoiceRequest.errors.send': 'Error al enviar',
    'invoiceRequest.errors.generic': 'Error',
    'storefront.notfound.title': 'Empresa no encontrada',
    'storefront.notfound.desc': 'Esta empresa no existe o ya no está activa.',
    'storefront.notfound.back': 'Volver al inicio',
    'storefront.tab.track': 'Seguir mi reparación',
    'storefront.tab.login': 'Área de cliente',
    'storefront.track.title': 'Seguimiento de reparación',
    'storefront.track.subtitle': 'Introduce tu referencia para seguir el avance de tu reparación',
    'storefront.track.format': 'Formato de referencia:',
    'storefront.track.submit': 'Seguir',
    'storefront.track.not_found': 'Reparación no encontrada',
    'storefront.track.ref': 'Referencia',
    'storefront.track.device': 'Dispositivo',
    'storefront.track.problem': 'Problema',
    'storefront.track.date_in': 'Fecha de entrada',
    'storefront.track.date_out': 'Fecha de salida prevista',
    'storefront.status.waiting': 'Pendiente',
    'storefront.status.in_progress': 'En curso',
    'storefront.status.done': 'Terminado',
    'storefront.status.delivered': 'Entregado',
    'storefront.status.cancelled': 'Cancelado',
    'storefront.status.unknown': 'Desconocido',
    'storefront.login.title': 'Inicio de sesión de cliente',
    'storefront.login.subtitle': 'Accede a tu área de cliente en {{name}}',
    'storefront.login.phone': 'Teléfono',
    'storefront.login.pin': 'Código PIN',
    'storefront.login.error_fields': 'Introduce tu teléfono y tu código PIN (4 o 6 dígitos)',
    'storefront.login.error_invalid': 'Credenciales incorrectas',
    'storefront.login.loading': 'Conectando...',
    'storefront.login.submit': 'Iniciar sesión',
    'storefront.login.create_account': '¿Aún no tienes cuenta? Crear una cuenta',
    'storefront.register.title': 'Crear una cuenta',
    'storefront.register.subtitle': 'Regístrate en {{name}}',
    'storefront.register.name': 'Nombre completo',
    'storefront.register.name_ph': 'Juan Pérez',
    'storefront.register.phone': 'Teléfono',
    'storefront.register.email': 'Correo electrónico (opcional)',
    'storefront.register.email_ph': 'correo@ejemplo.com',
    'storefront.register.pin': 'Código PIN',
    'storefront.register.pin_confirm': 'Confirmar PIN',
    'storefront.register.error_required': 'Nombre y teléfono obligatorios',
    'storefront.register.error_pin_short': 'El PIN debe contener al menos 4 dígitos',
    'storefront.register.error_pin_mismatch': 'Los PIN no coinciden',
    'storefront.register.error_generic': 'Error al crear la cuenta',
    'storefront.register.loading': 'Creando...',
    'storefront.register.submit': 'Crear mi cuenta',
    'storefront.register.back_to_login': '¿Ya tienes una cuenta? Iniciar sesión',
    'landing.svcScreenTitle': 'Pantalla rota',
    'landing.svcScreenDesc': 'Reemplazo de pantalla iPhone, Samsung, Huawei',
    'landing.svcBatteryTitle': 'Batería',
    'landing.svcBatteryDesc': 'Reemplazo de batería de todas las marcas',
    'landing.svcConnectorTitle': 'Conector',
    'landing.svcConnectorDesc': 'Conector de carga, jack de audio',
    'landing.svcCameraTitle': 'Cámara',
    'landing.svcCameraDesc': 'Cámara frontal y trasera',
    'landing.svcOxidationTitle': 'Desoxidación',
    'landing.svcOxidationDesc': 'Teléfono caído al agua',
    'landing.svcDiagTitle': 'Diagnóstico',
    'landing.svcDiagDesc': 'De 35 a 80 € según el dispositivo · presupuesto gratis',
    'landing.tip1': '**¡Hola!** Puedo hacer el seguimiento de su reparación o darle una estimación.',
    'landing.tip2': '**Garantía de 6 meses** en todas nuestras reparaciones, piezas y mano de obra.',
    'landing.tip3': '**Diagnóstico** de 35 a 80 € según el dispositivo, indicado antes de empezar.',
    'landing.tip4': '¿Se cayó al agua? **Apáguelo** y venga rápido: desoxidación en el taller.',
    'landing.tip5': 'Siga su reparación en directo con su referencia **REM0001**.',
    'landing.tip6': '**Microsoldadura** y recuperación de datos, aunque el dispositivo ya no encienda.',
    'landing.tip7': 'Abierto **lun–vie 9h–19h** y **sáb 9h–14h**, entrega sin cita previa.',
    'landing.tip8': '**Presupuesto gratis** en línea, enviado por correo tras la validación.',
    'landing.tip9': 'Profesionales: un **Espacio Empresa** dedicado (portal B2B).',
    'landing.tip10': 'iPhone, Samsung, Huawei, Xiaomi, tabletas y **consolas**: lo reparamos todo.',
    'landing.tipFromPrice': 'desde {{price}} — precio confirmado en tienda.',
    'landing.guideMe': 'Guíame',
    'landing.flashUntil': 'Hasta el {{date}}',
    'landing.cadbotTitle': 'CADBOT, su asistente',
    'landing.cadbotDesc': 'Seguimiento de reparaciones, estimación de presupuestos, horarios: le responde directamente en el sitio. El precio final siempre se confirma en tienda.',
    'landing.servicesTitle': 'Nuestros servicios de reparación',
    'landing.servicesDesc': 'Reparación exprés de smartphones y tabletas en Cayena, Guayana Francesa',
    'landing.seeAllPrices': 'Ver todas nuestras tarifas',
    'landing.readBlog': 'Leer nuestro blog',
    'landing.diagTitle': 'Diagnóstico en tienda',
    'landing.diagDesc': 'De 35 a 80 € según el dispositivo. El precio se le indica antes de empezar. El presupuesto en línea sigue siendo gratis.',
    'landing.tierFrom': 'desde',
    'landing.tierUpTo': 'hasta',
    'landing.tierEntryTitle': 'Gama de entrada y media',
    'landing.tierEntryDesc': 'Avería simple e identificada',
    'landing.tierRecentTitle': 'Smartphones recientes',
    'landing.tierRecentDesc': 'Varios síntomas a comprobar',
    'landing.tierComplexTitle': 'Casos complejos',
    'landing.tierComplexDesc': 'Daño por agua, microsoldadura, consolas, tabletas',
    'landing.enlarge': 'Ampliar',
    'landing.storePhotoAlt': 'Nuestra tienda Resurrection Mobile en Cayena',
    'landing.storeTag': 'Nuestra tienda · Cayena',
    'landing.enlargedPhoto': 'Foto ampliada',
    'landing.close': 'Cerrar',
    'landing.storePhotoAltSimple': 'Tienda Resurrection Mobile',
    'landing.freeQuote': 'Presupuesto gratis',
    'privacy.title': 'Política de privacidad',
    'privacy.last_updated': 'Última actualización: 19 de marzo de 2026',
    'privacy.intro.part1': 'La presente Política de privacidad describe cómo ',
    'privacy.intro.part2': ' («nosotros», «nuestro», «nuestros») recopila, utiliza, conserva y protege los datos personales de los usuarios («usted», «su») de conformidad con el ',
    'privacy.intro.rgpd': 'Reglamento General de Protección de Datos (RGPD — UE 2016/679)',
    'privacy.intro.part3': ' aplicable en Francia y en la Guayana Francesa.',
    'privacy.s1.title': 'Responsable del tratamiento',
    'privacy.s1.company_label': 'Empresa',
    'privacy.s1.status_label': 'Forma jurídica',
    'privacy.s1.controller_note': 'El responsable del tratamiento es la persona o entidad que determina los fines y los medios del tratamiento de sus datos personales.',
    'privacy.s2.title': 'Datos personales recopilados',
    'privacy.s2.sub1_title': '2.1 Datos de identificación',
    'privacy.s2.sub1_b1': 'Nombre y apellidos',
    'privacy.s2.sub1_b2': 'Dirección postal',
    'privacy.s2.sub1_b3': 'Número de teléfono',
    'privacy.s2.sub1_b4': 'Dirección de correo electrónico',
    'privacy.s2.sub1_b5': 'Nombre de la empresa (si es profesional)',
    'privacy.s2.sub2_title': '2.2 Datos relacionados con los servicios',
    'privacy.s2.sub2_b1': 'Información sobre los dispositivos confiados (marca, modelo, IMEI, número de serie)',
    'privacy.s2.sub2_b2': 'Historial de reparaciones',
    'privacy.s2.sub2_b3': 'Pedidos, presupuestos y facturas',
    'privacy.s2.sub2_b4': 'Firmas electrónicas',
    'privacy.s2.sub3_title': '2.3 Datos de pago',
    'privacy.s2.sub3_b1': 'Información de la transacción',
    'privacy.s2.sub3_b2': 'Medio de pago utilizado',
    'privacy.s2.payment_important_label': 'Importante:',
    'privacy.s2.payment_important_text': 'Nunca almacenamos sus datos bancarios completos. Los pagos son procesados por proveedores seguros (Stripe).',
    'privacy.s2.sub4_title': '2.4 Datos técnicos',
    'privacy.s2.sub4_b1': 'Dirección IP',
    'privacy.s2.sub4_b2': 'Datos de conexión',
    'privacy.s2.sub4_b3': 'Cookies y rastreadores',
    'privacy.s2.sub4_b4': 'Datos de navegación',
    'privacy.s3.title': 'Finalidades del tratamiento',
    'privacy.s3.b1': 'Prestar nuestros servicios de reparación y venta',
    'privacy.s3.b2': 'Gestionar los pedidos, presupuestos y la facturación',
    'privacy.s3.b3': 'Garantizar el seguimiento del cliente y el servicio posventa',
    'privacy.s3.b4': 'Comunicarnos con usted (SMS, correo electrónico, teléfono)',
    'privacy.s3.b5': 'Cumplir con nuestras obligaciones legales y contables',
    'privacy.s3.b6': 'Mejorar nuestros servicios y la seguridad',
    'privacy.s3.b7': 'Prevenir el fraude',
    'privacy.s4.title': 'Base jurídica del tratamiento',
    'privacy.s4.intro': 'De conformidad con el RGPD, los tratamientos se basan en:',
    'privacy.s4.i1': 'La ejecución de un contrato',
    'privacy.s4.i2': 'El cumplimiento de obligaciones legales',
    'privacy.s4.i3': 'Su consentimiento (p. ej., marketing)',
    'privacy.s4.i4': 'Nuestro interés legítimo (seguridad, mejora)',
    'privacy.s5.title': 'Destinatarios de los datos',
    'privacy.s5.b1': 'Nuestros empleados autorizados',
    'privacy.s5.b2': 'Nuestros proveedores técnicos (alojamiento, pago, SMS, correo electrónico)',
    'privacy.s5.b3': 'Las autoridades administrativas o judiciales cuando la ley lo exija',
    'privacy.s5.no_sale': 'Ningún dato personal se vende a terceros.',
    'privacy.s6.title': 'Transferencia fuera de la Unión Europea',
    'privacy.s6.text': 'Si algunos proveedores se encuentran fuera de la UE, nos aseguramos de que ofrezcan un nivel de protección adecuado conforme al RGPD (cláusulas contractuales tipo, decisiones de adecuación, etc.).',
    'privacy.s7.title': 'Plazo de conservación',
    'privacy.s7.r1_label': 'Datos de clientes',
    'privacy.s7.r1_value': '5 años tras la última relación comercial',
    'privacy.s7.r2_label': 'Datos de facturación',
    'privacy.s7.r2_value': '10 años (obligación legal)',
    'privacy.s7.r3_label': 'Datos de marketing',
    'privacy.s7.r3_value': 'Hasta la retirada del consentimiento',
    'privacy.s7.r4_label': 'Cookies',
    'privacy.s7.r4_value': 'Máximo 13 meses',
    'privacy.s8.title': 'Seguridad de los datos',
    'privacy.s8.intro': 'Aplicamos medidas técnicas y organizativas apropiadas:',
    'privacy.s8.b1': 'Acceso restringido a los datos',
    'privacy.s8.b2': 'Alojamiento seguro',
    'privacy.s8.b3': 'Cifrado cuando sea necesario',
    'privacy.s8.b4': 'Copias de seguridad periódicas',
    'privacy.s8.b5': 'Protección contra accesos no autorizados',
    'privacy.s9.title': 'Sus derechos',
    'privacy.s9.intro': 'De conformidad con el RGPD, usted dispone de los siguientes derechos:',
    'privacy.s9.r1': 'Derecho de acceso',
    'privacy.s9.r2': 'Derecho de rectificación',
    'privacy.s9.r3': 'Derecho de supresión («derecho al olvido»)',
    'privacy.s9.r4': 'Derecho a la limitación del tratamiento',
    'privacy.s9.r5': 'Derecho de oposición',
    'privacy.s9.r6': 'Derecho a la portabilidad de los datos',
    'privacy.s9.r7': 'Derecho a retirar su consentimiento',
    'privacy.s9.exercise': 'Para ejercer sus derechos, contáctenos en:',
    'privacy.s9.complaint_before': 'También puede presentar una reclamación ante la ',
    'privacy.s9.complaint_after': '.',
    'privacy.s10.title': 'Cookies',
    'privacy.s10.intro': 'Nuestro sitio puede utilizar cookies para:',
    'privacy.s10.b1': 'Garantizar el funcionamiento del sitio',
    'privacy.s10.b2': 'Medir la audiencia',
    'privacy.s10.b3': 'Mejorar la experiencia del usuario',
    'privacy.s10.manage': 'Puede gestionar sus preferencias a través de su navegador o de nuestro banner de cookies.',
    'privacy.s11.title': 'Datos de menores',
    'privacy.s11.text': 'Nuestros servicios no están destinados a menores sin autorización parental. Si se han recopilado por error los datos de un menor, contáctenos para su supresión.',
    'privacy.s12.title': 'Modificaciones de la política',
    'privacy.s12.text': 'Podemos modificar esta Política en cualquier momento para reflejar la evolución legal o técnica. La versión vigente es la publicada en nuestro sitio.',
    'privacy.s13.title': 'Contacto',
    'privacy.s13.intro': 'Para cualquier pregunta relativa a esta Política o a sus datos personales:',
    'privacy.footer': 'Al utilizar nuestros servicios, usted reconoce haber leído la presente Política de privacidad.',
    'track.title': 'Seguir mi reparación',
    'track.label_ref': 'Referencia',
    'track.label_device': 'Dispositivo',
    'track.label_received': 'Recibido el',
    'track.label_expected': 'Salida prevista',
    'track.label_completed': 'Terminado el',
    'track.label_amount': 'Importe',
    'track.status_pending': 'En espera',
    'track.see_full': 'Ver el detalle completo',
    'track.input_placeholder': 'Introduce tu referencia (ej.: REM0001)',
    'track.btn_track': 'Seguir',
    'track.scan_qr': 'Escanear el código QR de mi ticket',
    'track.err_invalid_ref': 'Referencia no válida. Formato esperado: REM0001',
    'track.err_not_found': 'Reparación no encontrada',
    'chatWidget.statusStaffOnline': 'Equipo en línea',
    'chatWidget.statusAiActive': 'IA activa — respuesta automática',
    'chatWidget.statusOffline': 'Desconectado — deja un mensaje',
    'chatWidget.launcherLabel': 'Chat y ayuda',
    'chatWidget.tabStaff': 'Chat de soporte',
    'chatWidget.tabAi': 'Ayuda IA',
    'chatWidget.newMessage': 'Nuevo mensaje',
    'chatWidget.loading': 'Cargando...',
    'chatWidget.noConversations': 'Sin conversaciones',
    'chatWidget.emptyConvoHint': 'Haz clic en «{{action}}» para contactarnos',
    'chatWidget.conversationFallback': 'Conversación',
    'chatWidget.autoReplyTitle': 'Modo de respuesta automática IA activo',
    'chatWidget.autoReplyDesc': 'El equipo está desconectado. La IA responde mientras tanto.',
    'chatWidget.staffEmptyTitle': 'Envía un mensaje al equipo',
    'chatWidget.staffEmptyDesc': 'Te responderemos lo antes posible',
    'chatWidget.aiAssistant': 'Asistente IA',
    'chatWidget.badgeAuto': 'auto',
    'chatWidget.badgeQuoteIndicative': 'presupuesto orientativo',
    'chatWidget.badgeQuotePending': 'presupuesto en preparación',
    'chatWidget.supportFallback': 'Soporte',
    'chatWidget.sending': 'Enviando...',
    'chatWidget.staffInputPlaceholder': 'Tu mensaje...',
    'chatWidget.interactiveGuides': 'Guías interactivas',
    'chatWidget.stepsCount': '{{count}} pasos',
    'chatWidget.faqTitle': 'Preguntas frecuentes',
    'chatWidget.back': 'Volver',
    'chatWidget.stepProgress': 'Paso {{current}} / {{total}}',
    'chatWidget.previous': 'Anterior',
    'chatWidget.next': 'Siguiente',
    'chatWidget.finish': 'Finalizar',
    'chatWidget.aiInputPlaceholder': 'Haz tu pregunta...',
    'chatWidget.aiError': 'Lo sentimos, se produjo un error.',
    'chatWidget.me': 'Yo',
    'chatWidget.newConversationSubject': 'Nueva conversación',
    'hours.title': 'Horario de apertura',
    'hours.rows.weekdays.label': 'Lunes - Viernes',
    'hours.rows.weekdays.hours': '9:00 - 19:00',
    'hours.rows.saturday.label': 'Sábado',
    'hours.rows.saturday.hours': '9:00 - 14:00',
    'hours.rows.sunday.label': 'Domingo',
    'hours.closed': 'Cerrado',
    'hours.unit.hour': 'h',
    'hours.unit.minute': 'min',
    'hours.unit.second': 's',
    'hours.clock': 'son las {{time}} en Cayena',
    'hours.ring.dayProgress': 'del día',
    'hours.ring.untilReopen': 'hasta la reapertura',
    'hours.state.openNow': 'Abierto ahora',
    'hours.state.closingSoon': 'Cierra pronto',
    'hours.state.closed': 'Cerrado',
    'hours.count.untilClose': 'hasta el cierre ({{hour}}:00)',
    'hours.count.untilOpen': 'hasta la apertura',
    'hours.sub.openSince': 'Abierto desde hace {{duration}}',
    'hours.sub.nextOpen': 'Próxima apertura: {{when}} a las {{hour}}:00',
    'hours.when.today': 'hoy',
    'hours.when.tomorrow': 'mañana',
    'hours.mood.closingSoon': '⏳ Recta final — ¡aún te esperamos un ratito!',
    'hours.mood.justOpened': '☕ Acabamos de abrir — ¡pásate a vernos!',
    'hours.mood.open': '🟢 Estamos abiertos, ¡pásate cuando quieras!',
    'hours.mood.opensSoon': '🚪 Abrimos en menos de una hora — ¡la persiana sube pronto!',
    'hours.mood.sundayRest': '🌴 El domingo descansamos — ¡nos vemos el lunes a las 9:00!',
    'hours.mood.morning': '🌅 ¡Buenos días! Abrimos a las {{hour}}:00, prepara tus dispositivos.',
    'hours.mood.evening': '🌙 Cerrado por esta noche — ¡hasta muy pronto!',
    'hours.dayName.0': 'domingo',
    'hours.dayName.1': 'lunes',
    'hours.dayName.2': 'martes',
    'hours.dayName.3': 'miércoles',
    'hours.dayName.4': 'jueves',
    'hours.dayName.5': 'viernes',
    'hours.dayName.6': 'sábado',
    'cadbot.welcome': 'Hola, soy **CADBOT**, el asistente de Resurrection Mobile. Escribe tu referencia **REM0001** para seguir tu reparación, o describe tu avería para una estimación.',
    'cadbot.chip.status': '¿Cómo va mi reparación?',
    'cadbot.chip.screen': 'Pantalla de iPhone 11 rota, ¿cuánto?',
    'cadbot.chip.battery': 'Batería de Galaxy S21, ¿precio?',
    'cadbot.chip.diagnostic': '¿Cuánto cuesta el diagnóstico?',
    'cadbot.chip.hours': '¿Horario y dirección?',
    'cadbot.note': 'Las estimaciones son orientativas y siempre se confirman en la tienda. El presupuesto detallado se envía por correo electrónico tras la validación de nuestro equipo.',
    'cadbot.status.online': 'en línea',
    'cadbot.resume.label': 'Retomar mi conversación',
    'cadbot.resume.title': 'Mostrar la conversación iniciada en esta pestaña',
    'cadbot.reset.label': 'Nueva conversación',
    'cadbot.reset.title': 'Borrar esta conversación y empezar de nuevo',
    'cadbot.input.label': 'Tu mensaje',
    'cadbot.input.placeholderIdentity': 'Tu nombre, teléfono o correo…',
    'cadbot.input.placeholderDefault': 'REM0001, pantalla de iPhone 13, batería…',
    'cadbot.send.aria': 'Enviar',
    'cadbot.local.greeting': '¡Hola! Soy **CADBOT**. Puedo seguir tu reparación (referencia REM0001), estimar un presupuesto o darte nuestro horario.',
    'cadbot.local.diagnostic': 'El diagnóstico en la tienda va de {{min}} a {{max}} según el dispositivo y la complejidad. El precio se te indica antes de empezar. El presupuesto en línea, en cambio, es gratuito.',
    'cadbot.local.water': 'Apágalo y no lo cargues, y tráelo a la tienda cuanto antes. La desoxidación se presupuesta tras el diagnóstico.',
    'cadbot.local.hoursLine': 'Estamos en **{{address}}**. Horario: {{hours}}. {{state}}',
    'cadbot.local.hoursOpen': '**{{state}}** — {{time}} {{countLabel}}.',
    'cadbot.local.hoursClosed': '**Cerrado** — {{sub}}.',
    'cadbot.local.closedLower': 'cerrado',
    'cadbot.local.warranty': 'Todas nuestras reparaciones tienen garantía de **6 meses**, piezas y mano de obra.',
    'cadbot.local.accounts': 'Los accesos están justo arriba: **Área Cliente** (seguimiento de tus reparaciones), **Área Empresa** (portal B2B) y **Área Staff**.',
    'cadbot.local.trackAsk': 'Indica tu referencia con el formato **REM0001** (figura en tu ticket de depósito) y te doy el avance.',
    'cadbot.local.quoteFollowup': 'Tu presupuesto se envía por correo electrónico en cuanto lo valida nuestro equipo (revisa la carpeta de spam). Si no tienes noticias en 24 h, escríbenos por WhatsApp al **{{phone}}**.',
    'cadbot.local.contact': 'Puedes contactarnos al **{{phone}}** (llamada y WhatsApp).',
    'cadbot.track.here': 'Aquí tienes el seguimiento de **{{ref}}**:',
    'cadbot.track.notFound': 'No encuentro la reparación **{{ref}}**. Comprueba la referencia en tu ticket de depósito.',
    'cadbot.track.unavailable': 'El seguimiento no está disponible por el momento, inténtalo de nuevo en un instante.',
    'cadbot.server.ackDefault': 'Gracias, un técnico te responderá muy pronto.',
    'cadbot.error.rateLimit': 'Demasiadas solicitudes a la vez: espera {{wait}} y vuelve a intentarlo.',
    'cadbot.error.waitMinutes': '{{n}} min',
    'cadbot.error.waitFallback': 'un minuto',
    'cadbot.error.server': 'No consigo conectar con el servidor. Escríbenos por WhatsApp al **{{phone}}**.',
    // ── tarifs.* (pilote i18n 2026-09-12 — à relire) ──
    'tarifs.back': 'Inicio',
    'tarifs.searchPlaceholder': 'Buscar un modelo o tipo de reparación…',
    'tarifs.loading': 'Cargando tarifas…',
    'tarifs.updateTitle': 'Tarifas en actualización',
    'tarifs.updateDesc': 'Nuestras tarifas se están actualizando. Contáctenos para un presupuesto gratuito y personalizado.',
    'tarifs.call': 'Llamar',
    'tarifs.callPrefix': 'Llamar: ',
    'tarifs.callNow': 'Llamar ahora',
    'tarifs.noResult': 'Sin resultados',
    'tarifs.soon': 'Tarifas próximamente',
    'tarifs.tryOther': 'Pruebe con otros términos',
    'tarifs.contactFree': 'Contáctenos para un presupuesto gratuito',
    'tarifs.repairBrand': 'Reparación {{brand}}',
    'tarifs.tariffsCount': '{{count}} tarifa(s) disponible(s)',
    'tarifs.colModel': 'Modelo',
    'tarifs.colRepair': 'Reparación',
    'tarifs.colPrice': 'Precio',
    'tarifs.colDelay': 'Plazo',
    'tarifs.allModels': 'Todos los modelos',
    'tarifs.whatsapp': 'WhatsApp',
    'tarifs.portal': 'Portal del cliente',
    'tarifs.faqTitle': 'Preguntas frecuentes',
    'tarifs.titleFallback': 'Precios de Reparación de Teléfonos',
    'tarifs.subtitleFallback': 'Descubra nuestras tarifas de reparación para iPhone, Samsung, Huawei y más. Reparación rápida y garantizada en Cayena, Guayana Francesa.',
    'tarifs.ctaTitleFallback': '¿Necesita un presupuesto personalizado?',
    'tarifs.ctaDescFallback': 'Cada reparación es única. Contáctenos para un diagnóstico gratuito y un presupuesto preciso adaptado a su situación.',
    'nav.activityHub': 'Centro de actividad', 'nav.salesHistory': 'Historial de ventas', 'nav.equipeMagasins': 'Equipo y tiendas', 'nav.usersLegacy': 'Usuarios (heredado)', // [i18n-P0 2026-09-12: a relire]
    _name: 'Español',
    _flag: '🇪🇸',
    'nav.dashboard': 'Panel',
    'nav.pos': 'Punto de venta',
    'nav.calcul': 'Calcular Precio',
    'nav.devis': 'Presupuestos / Facturas',
    'nav.devisDeplacement': 'Presupuesto Desplazamiento',
    'nav.commandes': 'Pedidos',
    'nav.addDevice': 'Agregar dispositivo',
    'nav.reparations': 'Reparaciones',
    'nav.clients': 'Clientes',
    'nav.stock': 'Inventario',
    'nav.addStock': 'Agregar Inventario',
    'nav.etiquettes': 'Etiquetas',
    'nav.users': 'Usuarios',
    'nav.clientPwd': 'Contraseñas Clientes',
    'nav.boutiqueOrders': 'Pedidos Tienda',
    'nav.caisseHistory': 'Historial de Caja',
    'nav.database': 'Base de datos',
    'nav.historique': 'Historial',
    'nav.paiements': 'Pagos en línea',
    'nav.chatClients': 'Chat Clientes',
    'nav.chat': 'Mensajería',
    'nav.notes': 'Notas',
    'nav.logout': 'Cerrar sesión',
    'nav.quit': 'Salir',
    'nav.admin': 'Administración',
    'nav.navigation': 'Navegación',
    'nav.b2b': 'Gestión B2B',
    'nav.b2bPayments': 'Pagos B2B',
    'nav.brandsModels': 'Marcas y Modelos',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.search': 'Buscar',
    'common.add': 'Agregar',
    'common.close': 'Cerrar',
    'common.confirm': 'Confirmar',
    'common.loading': 'Cargando...',
    'common.noData': 'Sin datos',
    'common.actions': 'Acciones',
    'common.status': 'Estado',
    'common.date': 'Fecha',
    'common.total': 'Total',
    'common.print': 'Imprimir',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.back': 'Volver',
    'common.next': 'Siguiente',
    'common.validate': 'Validar',
    'common.ref': 'Referencia',
    'common.client': 'Cliente',
    'common.phone': 'Teléfono',
    'common.email': 'Correo',
    'common.price': 'Precio',
    'common.quantity': 'Cantidad',
    'common.amount': 'Importe',
    'common.send': 'Enviar',
    'common.download': 'Descargar',
    'common.export': 'Exportar',
    'common.refresh': 'Actualizar',
    'common.filter': 'Filtrar',
    'common.all': 'Todos',
    'common.name': 'Nombre',
    'common.address': 'Dirección',
    'common.description': 'Descripción',
    'common.payment': 'Pago',
    'common.paid': 'Pagado',
    'common.pending': 'Pendiente',
    'common.accepted': 'Aceptado',
    'common.refused': 'Rechazado',
    'layout.panel': 'Panel de gestión',
    'pos.title': 'Punto de Venta',
    'pos.scanner': 'Escáner',
    'pos.searchProduct': 'Buscar un producto (ref, nombre, código de barras)...',
    'pos.outOfStock': 'Agotado',
    'pos.article': 'Artículo',
    'pos.unitPrice': 'Precio unit.',
    'pos.qty': 'Cant.',
    'pos.emptyCart': 'Carrito vacío',
    'pos.checkout': 'Cobrar',
    'pos.clientOptional': 'Cliente (opcional)',
    'pos.discount': 'Descuento',
    'pos.subtotal': 'Subtotal',
    'pos.validateSale': 'Validar la venta',
    'pos.paymentMode': 'Modo de pago',
    'pos.choosePayment': 'Elija el modo de pago:',
    'pos.cash': 'Efectivo',
    'pos.card': 'Tarjeta',
    'pos.mixed': 'Mixto',
    'pos.totalToCollect': 'Total a cobrar',
    'pos.change': 'Cambio',
    'pos.confirmPayment': 'Confirmar pago',
    'pos.validating': 'Validando...',
    'pos.lastTicket': 'Último ticket',
    'pos.caisseClosed': 'La caja está cerrada. Ábrala desde el Panel para realizar ventas.',
    'pos.insufficientCash': 'Importe en efectivo insuficiente',
    'pos.insufficientCard': 'Importe en tarjeta insuficiente',
    'pos.mixedMustEqual': 'El pago mixto debe ser igual al total',
    'pos.emptyCartAlert': 'Carrito vacío',
    'pos.selectPayment': 'Elija un modo de pago',
    'pos.saleValidated': '¡Venta validada!',
    'pos.adminOverride': 'Validación de administrador',
    'pos.outOfStockProduct': 'Producto agotado',
    'pos.adminId': 'ID administrador',
    'pos.adminCode': 'Código admin',
    'pos.manualAdd': 'Agregar artículo fuera de stock',
    'pos.designation': 'Designación',
    'pos.stockInsufficient': 'Stock insuficiente',
    'devis.title': 'Presupuestos y Facturas',
    'devis.subtitle': 'Documentos del cálculo de precio (convertibles en pedido).',
    'devis.noDoc': 'Ningún documento encontrado',
    'devis.type': 'Tipo',
    'devis.convertConfirm': '¿Convertir este presupuesto en pedido?',
    'devis.orderCreated': 'Pedido creado',
    'devis.deleteConfirm': '¿Eliminar este documento?',
    'devis.deleted': 'Documento eliminado',
    'devDep.title': 'Presupuesto Desplazamiento',
    'devDep.subtitle': 'Gestión de presupuestos para reparaciones a domicilio',
    'devDep.new': 'Nuevo presupuesto',
    'devDep.edit': 'Editar presupuesto',
    'devDep.clientName': 'Nombre del cliente',
    'devDep.clientPhone': 'Teléfono',
    'devDep.clientEmail': 'Correo',
    'devDep.clientAddress': 'Dirección',
    'devDep.repairDesc': 'Descripción de la reparación',
    'devDep.lines': 'Líneas del presupuesto',
    'devDep.addLine': 'Agregar',
    'devDep.travelFee': 'Gastos de desplazamiento',
    'devDep.sendByEmail': 'Enviar por correo',
    'devDep.sending': 'Enviando...',
    'devDep.pdfDevis': 'PDF Presupuesto',
    'devDep.pdfBon': 'PDF Orden de compra',
    'devDep.pdfFacture': 'PDF Factura',
    'devDep.searchPlaceholder': 'Buscar por ref, nombre, correo...',
    'devDep.allStatuses': 'Todos los estados',
    'devDep.pending': 'Pendiente',
    'devDep.accepted': 'Aceptado',
    'devDep.refused': 'Rechazado',
    'devDep.depositPaid': 'Anticipo pagado',
    'devDep.fullyPaid': 'Pagado',
    'devDep.stats': 'Estadísticas',
    'devDep.revenues': 'Ingresos',
    'devDep.activity30d': 'Actividad de los últimos 30 días',
    'devDep.remind': 'Recordar',
    'devDep.remindConfirm': '¿Enviar un recordatorio a clientes con presupuesto pendiente desde hace más de 3 días?',
    'devDep.noDevis': 'Ningún presupuesto creado',
    'devDep.noResults': 'Sin resultados',
    'devDep.bon': 'Orden de compra',
    'devDep.facture': 'Factura',
    'devDep.emailSent': 'Correo enviado el',
    'devDep.reminderSent': 'Recordatorio enviado el',
    'rep.title': 'Reparaciones',
    'rep.search': 'Buscar una reparación...',
    'rep.new': 'Nueva reparación',
    'rep.deviceRef': 'Ref. dispositivo',
    'rep.brand': 'Marca',
    'rep.model': 'Modelo',
    'rep.problem': 'Problema',
    'rep.technician': 'Técnico',
    'rep.timeline': 'Cronología',
    'cmd.title': 'Pedidos',
    'cmd.search': 'Buscar un pedido...',
    'cmd.piece': 'Pieza',
    'cmd.supplier': 'Proveedor',
    'cmd.deposit': 'Anticipo',
    'cmd.remaining': 'Pendiente de pago',
    'clients.title': 'Clientes',
    'clients.search': 'Buscar un cliente...',
    'clients.name': 'Nombre',
    'clients.address': 'Dirección',
    'clients.addClient': 'Nuevo cliente',
    'stock.title': 'Gestión de Inventario',
    'stock.search': 'Buscar un artículo...',
    'stock.addArticle': 'Agregar artículo',
    'stock.category': 'Categoría',
    'stock.buyPrice': 'Precio compra',
    'stock.sellPrice': 'Precio venta',
    'stock.available': 'Disponible',
    'dash.title': 'Panel de control',
    'dash.openCaisse': 'Abrir la caja',
    'dash.closeCaisse': 'Cerrar la caja',
    'dash.todaySales': 'Ventas del día',
    'dash.monthSales': 'Ventas del mes',
    'dash.activeRepairs': 'Reparaciones activas',
    'dash.pendingOrders': 'Pedidos pendientes',
    'login.title': 'Iniciar sesión',
    'login.username': 'Usuario',
    'login.password': 'Contraseña',
    'login.submit': 'Conectarse',
    'login.clientAccess': 'Acceso cliente',
    'login.staffAccess': 'Acceso personal',
    'lang.select': 'Idioma',
    'client.space': 'Espacio Cliente',
    'client.repairs': 'Reparaciones',
    'client.boutique': 'Tienda',
    'client.orders': 'Pedidos',
    'client.messages': 'Mensajes',
    'client.devis': 'Presupuestos',
    'client.trackRepairs': 'Seguimiento de sus reparaciones',
    'client.noRepairs': 'Ninguna reparación en curso',
    'client.trackOrders': 'Seguimiento de sus pedidos',
    'client.noOrders': 'Ningún pedido en curso',
    'client.shop': 'Tienda en línea',
    'client.noProducts': 'Ningún producto disponible',
    'client.addToCart': 'Agregar al carrito',
    'client.yourMessages': 'Sus mensajes',
    'client.noMessages': 'Sin mensajes',
    'client.send': 'Enviar',
    'client.brand': 'Marca',
    'client.model': 'Modelo',
    'client.problem': 'Problema',
    'client.status': 'Estado',
    'client.deposit': 'Anticipo',
    'client.remaining': 'Pendiente de pago',
    'client.total': 'Total',
    'client.timeline': 'Cronología',
    'client.noDevis': 'Ningún presupuesto por el momento',
    'client.acceptRefuse': 'Aceptar / Rechazar',
    'client.pay': 'Pagar',
    'landing.mobileRepair': 'Reparación móvil en Guayana',
    'landing.staffSpace': 'ESPACIO PERSONAL',
    'landing.staffDesc': 'Acceso equipo técnico',
    'landing.clientSpace': 'ESPACIO CLIENTE',
    'landing.clientDesc': 'Seguimiento de reparación',
    'landing.businessSpace': 'ESPACIO EMPRESA',
    'landing.businessDesc': 'Portal B2B',
    'landing.contact': 'Contacto',
    'landing.callWhatsapp': 'Llamada y WhatsApp',
    'landing.writeUs': 'Escríbanos directamente',
    'landing.hours': 'Horario de apertura',
    'landing.legal': 'Información legal',
    'landing.capital': 'con capital de',
    'landing.headquarters': 'Sede',
    'landing.allRights': 'Todos los derechos reservados',
    'landing.heroSubtitle': 'Su especialista en reparación móvil en Guayana',
    'landing.mondayFriday': 'Lunes - Viernes',
    'landing.saturday': 'Sábado',
    'landing.sunday': 'Domingo',
    'landing.closed': 'Cerrado',
    'landing.companyType': 'Sociedad por Acciones Simplificada (SAS)',
    'landing.openMaps': 'Abrir en Maps',
    'landing.rcs': 'RCS',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Punto de venta',
    'login.clientSpace': 'Espacio Cliente',
    'login.businessSpace': 'Espacio Empresa',
    'login.staffSpace': 'Espacio Personal',
    'login.connectYou': 'Conéctese',
    'login.phoneNumber': 'Número de teléfono',
    'login.proEmail': 'Correo profesional',
    'login.pin': 'Código PIN (4 o 6 dígitos)',
    'login.pinHint': 'Introduzca su código con el teclado o el teclado numérico.',
    'login.connecting': 'Conectando...',
    'login.connect': 'Conectarse',
    'login.noAccount': '¿No tiene cuenta?',
    'login.createAccount': 'Crear una cuenta',
    'login.forgotPwd': '¿Contraseña olvidada?',
    'login.notRegistered': '¿Aún no registrado?',
    'login.businessRegister': 'Registro empresa',
    'login.secure': 'Conexión segura',
    'login.caricature': 'Creo mi caricatura',
    'login.backHome': 'Volver al inicio',
    'login.wrongCredentials': 'Credenciales incorrectas',
    'login.pinError': 'El código PIN debe contener 4 o 6 dígitos',
    'login.b2bPassword': 'Contraseña',
    'login.b2bPlaceholder': 'Su contraseña',
    'login.yourId': 'Su identificador',
    'dash.hello': 'Hola',
    'dash.loggedAs': 'Conectado como',
    'dash.caisseOpen': 'Caja abierta',
    'dash.closeCaisseReminder': 'Recuerde cerrar la caja',
    'dash.noCaisse': 'Ninguna caja abierta',
    'dash.openCaisseTitle': 'Abrir la caja',
    'dash.openTotal': 'Total apertura',
    'dash.opening': 'Abriendo...',
    'dash.open': 'Abrir',
    'dash.searchPlaceholder': 'Buscar por referencia, cliente, teléfono...',
    'dash.noResults': 'Ningún resultado encontrado',
    'dash.today': 'Hoy',
    'dash.thisMonth': 'Este mes',
    'dash.completed': 'Completadas',
    'dash.repairsSub': 'reparaciones',
    'dash.inProgress': 'En curso',
    'dash.waitingParts': 'esperando piezas incluidas',
    'dash.registeredMonth': 'registradas este mes',
    'dash.statsTitle': 'Estadísticas y Análisis',
    'dash.statsDesc': 'Facturación, reparaciones, B2B, clientes',
    'dash.brandsModelsLabel': 'Marcas y Modelos',
    'dash.brandsModelsDesc': 'Gestionar el catálogo de dispositivos',
    'dash.b2bPaymentsLabel': 'Pagos B2B',
    'dash.b2bPaymentsDesc': 'Seguimiento de facturas y pagos',
    'dash.stockAlerts': 'Alertas de Inventario',
    'dash.lowStock': 'productos con stock bajo',
    'dash.outOfStock': 'agotados',
    'dash.recentRepairs': 'Últimas reparaciones',
    'dash.noClient': 'Sin cliente',
    'dash.unclosedTitle': 'Caja no cerrada',
    'dash.unclosedNotClosed': 'no fue cerrada',
    'dash.contactAdmin': 'Contacte a un administrador para cerrarla antes de continuar.',
    'dash.mustClose': 'Debe cerrarla antes de poder continuar trabajando.',
    'dash.forceClose': 'Cierre forzado',
    'dash.closing': 'Cerrando...',
    'dash.closeNormal': 'Cerrar normalmente',
    'dash.noCaisseToday': 'No hay caja abierta hoy.',
    'dash.openQuestion': '¿Desea abrir la caja ahora?',
    'dash.dontOpen': 'No abrir (continuar)',
    'dash.salesBlocked': 'Las ventas estarán bloqueadas mientras la caja no esté abierta.',
    'dash.calculation': 'Cálculo',
    'dash.repairs': 'Reparaciones',
    'dash.addDevice': 'Agregar',
    'dash.clients': 'Clientes',
    'dash.openedBy': 'abierta por',
    'dash.unknown': 'desconocido',
    'dash.forceCloseConfirm': 'Cerrar forzosamente la caja del',
    'dash.errorForceClose': 'Error al cerrar forzosamente',
    'dash.errorOpenCaisse': 'Error al abrir la caja',
    'devisAccept.error': 'Error',
    'devisAccept.notFound': 'Presupuesto no encontrado',
    'devisAccept.refused': 'Presupuesto rechazado',
    'devisAccept.refusedMsg': 'Usted ha rechazado el presupuesto',
    'devisAccept.thanks': 'Gracias por informarnos.',
    'devisAccept.accepted': '¡Presupuesto aceptado!',
    'devisAccept.acceptedMsg': 'Gracias por aceptar el presupuesto',
    'devisAccept.bonCommande': 'Orden de compra',
    'devisAccept.facture': 'Factura',
    'devisAccept.emailSent': 'Se ha enviado un correo con su orden de compra, el código de validación y sus credenciales de acceso.',
    'devisAccept.proceedPayment': 'Proceder al pago',
    'devisAccept.paymentMsg': 'Para finalizar su pedido, abone un anticipo o el pago completo:',
    'devisAccept.deposit50': 'Anticipo 50%',
    'devisAccept.fullPayment': 'Pago completo',
    'devisAccept.alreadyAccepted': 'Este presupuesto ya fue aceptado.',
    'devisAccept.alreadyRefused': 'Este presupuesto fue rechazado.',
    'devisAccept.statusMsg': 'Estado del presupuesto',
    'devisAccept.payDeposit': 'Pagar anticipo 50%',
    'devisAccept.homeRepairQuote': 'Presupuesto de reparación a domicilio',
    'devisAccept.hello': 'Hola',
    'devisAccept.findBelow': 'Encuentre a continuación el detalle de su presupuesto:',
    'devisAccept.designation': 'Designación',
    'devisAccept.travelFee': 'Gastos de desplazamiento',
    'devisAccept.tvaNote': 'IVA no aplicable, art. 293B del CGI. Presupuesto válido 30 días.',
    'devisAccept.refuse': 'Rechazar',
    'devisAccept.accept': 'Aceptar el presupuesto',
    'devisAccept.confirmRefuse': '¿Está seguro de querer rechazar este presupuesto?',
    'payment.secure': 'Pago seguro',
    'payment.error': 'Error',
    'payment.backToDevis': 'Volver al presupuesto',
    'payment.notAccepted': 'Presupuesto no aceptado',
    'payment.mustAcceptFirst': 'Debe aceptar el presupuesto antes de proceder al pago.',
    'payment.viewDevis': 'Ver el presupuesto',
    'payment.fullyPaid': 'Factura completamente pagada',
    'payment.alreadyPaid': 'ya está completamente pagada.',
    'payment.accessClient': 'Acceder a su espacio cliente',
    'payment.deposit50': 'Anticipo 50%',
    'payment.fullPayment': 'Pago completo',
    'payment.devis': 'Presupuesto',
    'payment.client': 'Cliente',
    'payment.totalDevis': 'Total del presupuesto',
    'payment.alreadyPaidAmount': 'Ya pagado',
    'payment.remaining': 'Pendiente de pago',
    'payment.depositPercent': 'Anticipo (50%)',
    'payment.amountToPay': 'Importe a pagar',
    'payment.pay': 'Pagar',
    'payment.redirecting': 'Redirigiendo a Stripe...',
    'payment.securedBy': 'Pago seguro por Stripe',
    'payment.urlNotAvailable': 'URL de pago no disponible',
    'payment.creationError': 'Error al crear el pago',
    'paySuccess.confirmed': '¡Pago confirmado!',
    'paySuccess.paymentFor': 'Su pago para el presupuesto',
    'paySuccess.registered': 'ha sido registrado con éxito.',
    'paySuccess.depositRegistered': '¡Anticipo registrado!',
    'paySuccess.depositFor': 'Su anticipo para el presupuesto',
    'paySuccess.depositDone': 'ha sido registrado.',
    'paySuccess.checking': 'Verificando...',
    'paySuccess.pleaseWait': 'Estamos verificando su pago, por favor espere.',
    'paySuccess.waitingConfirm': 'Esperando confirmación',
    'paySuccess.processing': 'Su pago se está procesando. Recibirá un correo de confirmación.',
    'paySuccess.totalInvoice': 'Total factura',
    'paySuccess.amountPaid': 'Importe pagado',
    'paySuccess.remaining': 'Pendiente de pago',
    'paySuccess.payRemaining': 'Pagar el resto',
    'paySuccess.loginClient': 'Conéctese a su espacio cliente',
    'register.clientTitle': 'Crear una cuenta de cliente',
    'register.fullName': 'Nombre completo',
    'register.phone': 'Teléfono',
    'register.email': 'Correo (opcional)',
    'register.address': 'Dirección (opcional)',
    'register.pin': 'Código PIN (4 o 6 dígitos)',
    'register.confirmPin': 'Confirmar código PIN',
    'register.creating': 'Creando...',
    'register.createAccount': 'Crear mi cuenta',
    'register.alreadyAccount': '¿Ya tiene cuenta?',
    'register.login': 'Conectarse',
    'register.backHome': 'Volver al inicio',
    'register.pinError': 'El código PIN debe contener 4 o 6 dígitos',
    'register.pinNoMatch': 'Los códigos PIN no coinciden',
    'register.pinMinLength': 'El código PIN debe contener al menos 4 dígitos',
    'b2bRegister.title': 'Registro Empresa',
    'b2bRegister.subtitle': 'Cree su cuenta profesional',
    'b2bRegister.companyName': 'Nombre de la empresa',
    'b2bRegister.managerName': 'Nombre del gerente',
    'b2bRegister.proEmail': 'Correo profesional',
    'b2bRegister.phone': 'Teléfono',
    'b2bRegister.address': 'Dirección',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Contraseña',
    'b2bRegister.confirmPassword': 'Confirmar contraseña',
    'b2bRegister.kbis': 'Extracto KBIS (PDF)',
    'b2bRegister.kbisDesc': 'Suba su extracto KBIS o cualquier documento justificativo (PDF)',
    'b2bRegister.dropFile': 'Haga clic o arrastre su archivo aquí',
    'b2bRegister.creating': 'Registrando...',
    'b2bRegister.submit': 'Registrarse',
    'b2bRegister.success': '¡Registro exitoso!',
    'b2bRegister.successMsg': 'Su cuenta empresa está en proceso de validación. Recibirá un correo de confirmación.',
    'b2bRegister.goLogin': 'Ir al inicio de sesión',
    'b2bRegister.fillAll': 'Complete todos los campos obligatorios',
    'b2bRegister.siretError': 'El SIRET debe contener 14 dígitos',
    'b2bRegister.pwdNoMatch': 'Las contraseñas no coinciden',
    'b2bRegister.pwdMinLength': 'La contraseña debe contener al menos 6 caracteres',
    'b2bRegister.kbisRequired': 'Suba su extracto KBIS',
    'b2bRegister.alreadyAccount': '¿Ya registrado?',
    'reset.forgotTitle': 'Contraseña olvidada',
    'reset.forgotDesc': 'Reciba un enlace de restablecimiento por correo',
    'reset.enterEmail': 'Introduzca su correo',
    'reset.emailSent': 'Correo enviado',
    'reset.emailSentMsg': 'Si existe una cuenta con esta dirección, recibirá un correo con un enlace para restablecer su contraseña.',
    'reset.linkValid': 'El enlace es válido durante 1 hora.',
    'reset.backLogin': 'Volver al inicio de sesión',
    'reset.clientEmail': 'Correo de su cuenta',
    'reset.sending': 'Enviando...',
    'reset.sendLink': 'Enviar enlace de restablecimiento',
    'reset.newPwdTitle': 'Nueva contraseña',
    'reset.newPwdDesc': 'Elija su nueva contraseña',
    'reset.newPwd': 'Nueva contraseña',
    'reset.confirmPwd': 'Confirmar contraseña',
    'reset.resetting': 'Restableciendo...',
    'reset.resetPwd': 'Restablecer contraseña',
    'reset.pwdReset': 'Contraseña restablecida',
    'reset.pwdResetMsg': 'Su contraseña ha sido modificada con éxito.',
    'reset.pwdMinLength': 'La contraseña debe contener al menos 4 caracteres',
    'reset.pwdNoMatch': 'Las contraseñas no coinciden',
    'reset.error': 'Ha ocurrido un error',
    'b2b.welcome': 'Bienvenido',
    'b2b.newRepair': 'Nueva reparación',
    'b2b.registerDevice': 'Registrar un dispositivo',
    'b2b.myRepairs': 'Mis reparaciones',
    'b2b.viewAll': 'Ver todas las reparaciones',
    'b2b.recentRepairs': 'Últimas reparaciones',
    'b2b.noRepairs': 'Ninguna reparación',
    'b2b.repairRegistered': 'Reparación registrada',
    'b2b.reference': 'Referencia',
    'b2b.viewDetails': 'Ver detalles',
    'b2b.anotherRepair': 'Nueva reparación',
    'b2b.deviceInfo': 'Información del dispositivo',
    'b2b.brand': 'Marca',
    'b2b.model': 'Modelo',
    'b2b.backGlass': 'Cristal trasero',
    'b2b.backGlassBroken': 'Cristal trasero roto',
    'b2b.backGlassOk': 'Cristal trasero intacto',
    'b2b.providePart': 'Yo proporciono la pieza',
    'b2b.partByShop': 'La pieza será proporcionada por R.E.Mobiles',
    'b2b.lockCode': 'Código de desbloqueo',
    'b2b.lockTypeCode': 'Código (números/letras)',
    'b2b.lockTypeSchema': 'Patrón',
    'b2b.problem': 'Problema / Descripción',
    'b2b.brokenParts': 'Piezas no funcionales',
    'b2b.deliveryMethod': 'Método de entrega',
    'b2b.inStore': 'En tienda',
    'b2b.inStoreDesc': 'Depósito en tienda',
    'b2b.postal': 'Envío postal',
    'b2b.postalDesc': 'Con número de seguimiento',
    'b2b.pickup': 'Recogida',
    'b2b.pickupDesc': 'Recogemos el dispositivo',
    'b2b.trackingNumber': 'Número de seguimiento',
    'b2b.pickupAddress': 'Dirección de recogida',
    'b2b.devicePhotos': 'Fotos del dispositivo',
    'b2b.addPhotos': 'Haga clic para agregar fotos',
    'b2b.additionalNotes': 'Notas adicionales',
    'b2b.submitting': 'Enviando...',
    'b2b.submitRepair': 'Registrar la reparación',
    'b2b.brandModelRequired': 'Marca y modelo son obligatorios',
    'b2b.noRepairFound': 'Ninguna reparación encontrada',
    'b2b.allStatus': 'Todas',
    'b2b.documents': 'Documentos y Facturas',
    'b2b.documentsDesc': 'Valide sus órdenes de compra y descargue sus facturas',
    'b2b.pendingValidation': 'Órdenes de compra por validar',
    'b2b.enterCode': 'Introduzca el código recibido por correo para validar cada orden.',
    'b2b.validate': 'Validar',
    'b2b.invoices': 'Facturas',
    'b2b.noInvoices': 'Ninguna factura disponible',
    'b2b.device': 'Dispositivo',
    'b2b.amount': 'Importe',
    'b2b.date': 'Fecha',
    'b2b.actions': 'Acciones',
    'b2b.paid': 'Pagada',
    'b2b.repairAccepted': 'Reparación aceptada por el personal',
    'b2b.repairRefused': 'Reparación rechazada por el personal',
    'b2b.orderValidated': 'Orden de compra validada',
    'b2b.noPhotos': 'Sin fotos',
    'b2b.history': 'Historial',
    'b2b.repairPrice': 'Precio reparación',
    'b2b.diagPrice': 'Precio diagnóstico',
    'b2b.priceWaiting': 'Pendiente - será fijado por R.E.Mobiles',
    'b2b.createdOn': 'Creada el',
    'b2b.clear': 'Borrar',
    'b2b.thisMonth': 'Este mes',
    'b2b.waitingReception': 'Esp. recepción',
    'b2b.received': 'Recibido',
    'b2b.inProgress': 'En Curso',
    'b2b.waitingParts': 'Esp. Piezas',
    'b2b.completed': 'Completado',
    'b2b.delivered': 'Entregado',
    'b2bDevis.title': 'Presupuesto Desplazamiento',
    'b2bDevis.pending': 'pendiente',
    'b2bDevis.noDevis': 'Sin presupuestos',
    'b2bDevis.noDevisDesc': 'No tiene presupuestos de desplazamiento por el momento.',
    'b2bDevis.travelFee': 'Gastos de desplazamiento',
    'b2bDevis.validationCode': 'Código de validación',
    'b2bDevis.codeHint': 'Introduzca el código de 6 dígitos recibido por correo.',
    'b2bDevis.acceptFirst': 'Primero acepte el presupuesto para poder validarlo.',
    'b2bDevis.payDeposit': 'Pagar anticipo 50%',
    'b2bDevis.payFull': 'Pagar total',
    'b2bDevis.payRemaining': 'Pagar el resto',
    'b2bDevis.alreadyPaid': 'Ya pagado',
    'b2bDevis.remaining': 'Pendiente de pago',
    'b2bDevis.invoiceDownload': 'Descargar factura',
    'b2bDevis.orderDownload': 'Descargar orden de compra',
    'b2bDevis.quoteDownload': 'Descargar presupuesto',
    'adminSettings.title': 'Página de inicio',
    'adminSettings.preview': 'Vista previa',
    'adminSettings.saving': 'Guardando...',
    'adminSettings.save': 'Guardar',
    'adminSettings.saved': '¡Guardado!',
    'adminSettings.error': 'Error',
    'adminSettings.heroSection': 'Hero / Encabezado',
    'adminSettings.mainTitle': 'Título principal',
    'adminSettings.subtitle': 'Subtítulo',
    'adminSettings.accentColor': 'Color acento (hex)',
    'adminSettings.bgImage': 'Imagen de fondo',
    'adminSettings.change': 'Cambiar',
    'adminSettings.companyInfo': 'Información de la empresa',
    'adminSettings.companyName': 'Nombre empresa',
    'adminSettings.companyType': 'Tipo (SAS, SARL...)',
    'adminSettings.capital': 'Capital',
    'adminSettings.rcs': 'RCS',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Sede social',
    'adminSettings.salesPoint': 'Punto de venta',
    'adminSettings.contactHours': 'Contacto y Horarios',
    'adminSettings.phone': 'Teléfono',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'Correo',
    'adminSettings.googleMaps': 'Consulta Google Maps',
    'adminSettings.gallery': 'Galería de fotos',
    'adminSettings.addImage': 'Agregar una imagen',
    'adminDb.title': 'Administración Base de Datos',
    'adminDb.subtitle': 'Exportar, importar y gestionar datos',
    'adminDb.accessDenied': 'Acceso denegado',
    'adminDb.adminOnly': 'Esta página está reservada a administradores',
    'adminDb.clients': 'Clientes',
    'adminDb.users': 'Usuarios',
    'adminDb.repairs': 'Reparaciones',
    'adminDb.stockArticles': 'Artículos de Inventario',
    'adminDb.exportTitle': 'Exportar Base de Datos',
    'adminDb.exportDesc': 'Exportar todos los datos (clientes, usuarios, inventario, reparaciones, ventas) en archivo JSON.',
    'adminDb.exportConfirm': '¿Exportar toda la base de datos?',
    'adminDb.exportBtn': 'Exportar la base completa',
    'adminDb.exportSuccess': '¡Exportación exitosa!',
    'adminDb.exportError': 'Error al exportar',
    'adminDb.importTitle': 'Importar Base de Datos',
    'adminDb.importDesc': 'Importar un archivo JSON para restaurar o migrar datos.',
    'adminDb.fileSelected': 'Archivo seleccionado',
    'adminDb.uploading': 'Subiendo archivo...',
    'adminDb.importDone': '¡Importación completada!',
    'adminDb.importSuccess': '¡Importación exitosa!',
    'adminDb.importError': 'Error al importar',
    'adminDb.importClientsBtn': 'Importar Clientes',
    'adminDb.importFullBtn': 'Importación Completa',
    'adminDb.importWarning': 'La importación completa reemplazará los datos existentes',
    'adminDb.importConfirm': 'ATENCIÓN: Esta acción reemplazará los datos existentes. ¿Continuar?',
    'adminDb.importClientsConfirm': '¿Importar clientes? Las cuentas se crearán con el número de teléfono como identificador.',
    'adminDb.selectFile': 'Seleccione un archivo',
    'adminDb.selectFileClients': 'Seleccione un archivo JSON con los clientes',
    'adminDb.logsTitle': 'Registro de operaciones',
    'adminDb.noLogs': 'Ninguna operación registrada',
    'adminB2b.title': 'Gestión B2B',
    'adminB2b.home': 'Inicio',
    'adminB2b.monthlyRecap': 'Resumen Mensual',
    'adminB2b.sending': 'Enviando...',
    'adminB2b.search': 'Buscar...',
    'adminB2b.recapTitle': 'Resultado del resumen mensual',
    'adminB2b.recapSent': 'Enviado',
    'adminB2b.recapSkipped': 'Sin reparaciones',
    'adminB2b.recapError': 'Error',
    'adminB2b.companies': 'Empresas',
    'adminB2b.b2bRepairs': 'Reparaciones B2B',
    'adminB2b.paymentHistory': 'Historial de Pagos',
    'adminB2b.all': 'Todas',
    'adminB2b.pending': 'Pendientes',
    'adminB2b.validated': 'Validadas',
    'adminB2b.refused': 'Rechazadas',
    'adminB2b.suspended': 'Suspendidas',
    'adminB2b.noCompany': 'Ninguna empresa encontrada',
    'adminB2b.phone': 'Teléfono',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Dirección',
    'adminB2b.registeredOn': 'Registrado el',
    'adminB2b.validatedBy': 'Validado por',
    'adminB2b.downloadKbis': 'Descargar KBIS',
    'adminB2b.validate': 'Validar',
    'adminB2b.refuse': 'Rechazar',
    'adminB2b.suspend': 'Suspender',
    'adminB2b.confirmValidate': '¿Desea validar esta empresa?',
    'adminB2b.confirmRefuse': '¿Desea rechazar esta empresa?',
    'adminB2b.confirmSuspend': '¿Desea suspender esta empresa?',
    'adminB2b.pendingReception': 'Pendiente de recepción',
    'adminB2b.confirmReception': 'Confirmar recepción',
    'adminB2b.ref': 'Ref',
    'adminB2b.company': 'Empresa',
    'adminB2b.brandModel': 'Marca / Modelo',
    'adminB2b.problem': 'Problema',
    'adminB2b.delivery': 'Entrega',
    'adminB2b.price': 'Precio',
    'adminB2b.status': 'Estado',
    'adminB2b.actions': 'Acciones',
    'adminB2b.noRepairs': 'Ninguna reparación B2B encontrada',
    'adminB2b.postal': 'Postal',
    'adminB2b.pickup': 'Recogida',
    'adminB2b.inStore': 'Tienda',
    'adminB2b.changeStatus': 'Cambiar estado',
    'adminB2b.setPrice': 'Fijar precio',
    'adminB2b.repairPrice': 'Precio reparación',
    'adminB2b.diagPrice': 'Precio diagnóstico',
    'adminB2b.locked': 'Bloqueado (pagado)',
    'adminB2b.total': 'Total',
    'adminB2b.existingInvoices': 'Facturas existentes',
    'adminB2b.diagnostic': 'Diagnóstico',
    'adminB2b.repair': 'Reparación',
    'adminB2b.combined': 'Combinada',
    'adminB2b.paidMethod': 'Pagada',
    'adminB2b.awaitingPayment': 'Pendiente',
    'adminB2b.markPaid': 'Pagado',
    'adminB2b.finalize': 'Finalizar facturación',
    'adminB2b.backGlassBroken': 'Cristal tras. roto',
    'adminB2b.clientPart': 'Pieza del cliente',
    'adminB2b.bcValidated': 'OC validada',
    'adminB2b.invoiceCancelled': 'Factura cancelada',
    'adminB2b.monthPrompt': '¿Mes (1-12)? Deje vacío para el mes anterior:',
    'adminB2b.yearPrompt': '¿Año?',
    'adminB2b.paymentMethodPrompt': '¿Modo de pago?',
    'adminB2b.filterCompany': 'Empresa',
    'adminB2b.filterDateStart': 'Fecha inicio',
    'adminB2b.filterDateEnd': 'Fecha fin',
    'adminB2b.filter': 'Filtrar',
    'adminB2b.clearFilter': 'Borrar',
    'adminB2b.totalCollected': 'Total cobrado',
    'adminB2b.payments': 'pago(s)',
    'adminB2b.payHistoryTitle': 'Historial de pagos B2B',
    'adminB2b.noPayments': 'Ningún pago B2B registrado',
    'adminB2b.invoice': 'Factura',
    'users.title': 'Gestión de usuarios',
    'users.count': 'usuario(s)',
    'users.new': 'Nuevo usuario',
    'users.edit': 'Editar usuario',
    'users.username': 'Nombre de usuario',
    'users.password': 'Contraseña',
    'users.newPassword': 'Nueva contraseña (dejar vacío para no cambiar)',
    'users.role': 'Rol',
    'users.roleAdmin': 'Administrador',
    'users.roleUser': 'Comercial',
    'users.roleTech': 'Técnico',
    'users.status': 'Estado',
    'users.active': 'Activo',
    'users.inactive': 'Inactivo',
    'users.createdAt': 'Creado el',
    'users.noUsers': 'Ningún usuario',
    'users.accessDenied': 'Acceso reservado a administradores',
    'users.deleteConfirm': '¿Eliminar este usuario?',
    'clients.manage': 'Gestión de Clientes',
    'clients.total': 'clientes en total',
    'clients.add': 'Agregar',
    'clients.noClients': 'Ningún cliente encontrado',
    'clients.type': 'Tipo',
    'clients.discount': 'Descuento',
    'clients.account': 'Cuenta',
    'clients.sent': 'Enviado',
    'clients.activeAccount': 'Activo',
    'clients.noEmail': 'Sin correo',
    'clients.editClient': 'Editar cliente',
    'clients.newClient': 'Nuevo cliente',
    'clients.company': 'Empresa',
    'clients.clientType': 'Tipo de cliente',
    'clients.individual': 'Particular',
    'clients.business': 'Empresa',
    'clients.discountPct': 'Descuento (%)',
    'clients.deleteConfirm': '¿Eliminar este cliente?',
    'clients.page': 'Página',
    'stats.title': 'Estadísticas y Análisis',
    'stats.revenue': 'Facturación',
    'stats.repairs': 'Reparaciones',
    'stats.b2b': 'B2B',
    'stats.clients': 'Clientes',
    'stats.back': 'Volver',
    'stats.monthlyRevenue': 'Facturación Mensual',
    'stats.revenueByType': 'Facturación por tipo',
    'stats.revenueByPayment': 'Facturación por modo de pago',
    'stats.totalRevenue': 'Facturación Total (12 meses)',
    'stats.repairsByStatus': 'Por estado',
    'stats.repairsByBrand': 'Por marca',
    'stats.topModels': 'Top modelos',
    'stats.monthly': 'Evolución mensual',
    'stats.totalRepairs': 'Total reparaciones',
    'stats.avgRepairTime': 'Duración media',
    'stats.completionRate': 'Tasa de finalización',
    'stats.b2bCompanies': 'Empresas B2B',
    'stats.b2bRepairs': 'Reparaciones B2B',
    'stats.b2bRevenue': 'Facturación B2B',
    'stats.b2bByCompany': 'Por empresa',
    'stats.totalClients': 'Total clientes',
    'stats.newThisMonth': 'Nuevos este mes',
    'stats.withAccount': 'Con cuenta',
    'stats.clientsByType': 'Por tipo',
    'stats.registrations': 'Inscripciones mensuales',
    'stats.noData': 'Sin datos',
    'rep.manage': 'Gestión de Reparaciones',
    'rep.noRepairs': 'Ninguna reparación encontrada',
    'rep.allStatuses': 'Todos los estados',
    'rep.imei': 'IMEI / Serie',
    'rep.client': 'Cliente',
    'rep.phone': 'Tel',
    'rep.date': 'Fecha',
    'rep.deposit': 'Anticipo',
    'rep.printFiche': 'Imprimir ficha',
    'rep.printEtiquette': 'Imprimir etiqueta',
    'rep.deleteConfirm': '¿Eliminar esta reparación?',
    'rep.addDeposit': 'Agregar anticipo',
    'rep.depositAmount': 'Importe anticipo',
    'rep.paymentMode': 'Modo de pago',
    'rep.depositHistory': 'Historial de anticipos',
    'rep.totalDeposits': 'Total anticipos',
    'rep.changeStatus': 'Cambiar estado',
    'rep.notes': 'Notas internas',
    'rep.sendChat': 'Enviar mensaje',
    'rep.noTimeline': 'Sin eventos',
    'cmd.manage': 'Gestión de Pedidos',
    'cmd.noOrders': 'Ningún pedido encontrado',
    'cmd.allStatuses': 'Todos los estados',
    'cmd.ordered': 'Pedido',
    'cmd.received': 'Recibido',
    'cmd.cancelled': 'Cancelado',
    'cmd.status': 'Estado',
    'cmd.ref': 'Ref',
    'cmd.addOrder': 'Nuevo pedido',
    'cmd.editOrder': 'Editar pedido',
    'cmd.deleteConfirm': '¿Eliminar este pedido?',
    'stock.manage': 'Gestión de Inventario',
    'stock.noItems': 'Ningún artículo encontrado',
    'stock.barcode': 'Código de barras',
    'stock.reference': 'Referencia',
    'stock.alert': 'Alerta',
    'stock.lowStockAlert': 'Stock bajo',
    'stock.addForm': 'Agregar un artículo',
    'stock.editForm': 'Editar artículo',
    'stock.deleteConfirm': '¿Eliminar este artículo?',
    'hist.title': 'Historial de ventas',
    'hist.search': 'Buscar una venta...',
    'hist.noSales': 'Ninguna venta encontrada',
    'hist.ref': 'Ref.',
    'hist.client': 'Cliente',
    'hist.amount': 'Importe',
    'hist.payment': 'Pago',
    'hist.date': 'Fecha',
    'hist.articles': 'Artículos',
    'hist.refund': 'Reembolsar',
    'hist.refundConfirm': '¿Reembolsar esta venta?',
    'pay.title': 'Pagos en línea',
    'pay.search': 'Buscar...',
    'pay.noPayments': 'Ningún pago encontrado',
    'pay.ref': 'Referencia',
    'pay.client': 'Cliente',
    'pay.amount': 'Importe',
    'pay.status': 'Estado',
    'pay.date': 'Fecha',
    'pay.type': 'Tipo',
    'caisse.title': 'Historial de Cajas',
    'caisse.noCaisse': 'Ninguna caja encontrada',
    'caisse.openedBy': 'Abierta por',
    'caisse.openingAmount': 'Importe apertura',
    'caisse.closingAmount': 'Importe cierre',
    'caisse.sales': 'Ventas',
    'caisse.openDate': 'Apertura',
    'caisse.closeDate': 'Cierre',
    'notes.title': 'Notas',
    'notes.new': 'Nueva nota',
    'notes.noNotes': 'Sin notas',
    'notes.deleteConfirm': '¿Eliminar esta nota?',
    'labels.title': 'Etiquetas',
    'labels.search': 'Buscar...',
    'labels.print': 'Imprimir',
    'labels.selectAll': 'Seleccionar todo',
    'labels.noLabels': 'Sin etiquetas',
    'calc.title': 'Calcular Precio',
    'calc.searchDevice': 'Buscar un dispositivo...',
    'calc.selectRepair': 'Seleccionar una reparación',
    'calc.generateQuote': 'Generar presupuesto',
    'calc.generateInvoice': 'Generar factura',
    'boutique.title': 'Pedidos Tienda',
    'boutique.noOrders': 'Sin pedidos',
    'boutique.orderRef': 'Ref. pedido',
    'boutique.clientName': 'Cliente',
    'boutique.total': 'Total',
    'boutique.status': 'Estado',
    'chat.title': 'Mensajería',
    'chat.noConversations': 'Sin conversaciones',
    'chat.typeMessage': 'Escriba su mensaje...',
    'brands.title': 'Marcas y Modelos',
    'brands.addBrand': 'Agregar marca',
    'brands.addModel': 'Agregar modelo',
    'brands.noBrands': 'Sin marcas',
    'brands.deleteConfirm': '¿Eliminar esta marca?',
    'remcaches.title': 'Reposiciones en Caché',
    'remcaches.noItems': 'Sin artículos',
    'closeCaisse.title': 'Cierre de Caja',
    'closeCaisse.countCoins': 'Conteo de efectivo',
    'closeCaisse.theoreticalTotal': 'Total teórico',
    'closeCaisse.actualTotal': 'Total real',
    'closeCaisse.difference': 'Diferencia',
    'closeCaisse.close': 'Cerrar la caja',
    'closeCaisse.closing': 'Cerrando...',
    'clientPwd.title': 'Contraseñas de Clientes',
    'clientPwd.search': 'Buscar un cliente...',
    'clientPwd.noClients': 'Ningún cliente encontrado',
    'clientPwd.generatePin': 'Generar PIN',
    'clientPwd.sendByEmail': 'Enviar por correo',
    'b2bPay.title': 'Pagos B2B',
    'b2bPay.noPayments': 'Sin pagos',
    'repForm.title': 'Agregar un dispositivo',
    'repForm.editTitle': 'Editar la reparación',
    'repForm.brand': 'Marca',
    'repForm.model': 'Modelo',
    'repForm.imei': 'IMEI / N° de serie',
    'repForm.lockCode': 'Código de desbloqueo',
    'repForm.problem': 'Problema detectado',
    'repForm.client': 'Cliente',
    'repForm.technician': 'Técnico asignado',
    'repForm.price': 'Precio de reparación',
    'repForm.submit': 'Guardar',
    'repForm.submitting': 'Guardando...',
    // SumUp
    'sumup.acceptOnlinePayment': 'Aceptar pago en línea (SumUp)', 'sumup.acceptOnlinePaymentDesc': 'El cliente podrá solicitar un enlace de pago SumUp', 'sumup.requestLink': 'Solicitar enlace de pago SumUp', 'sumup.requestSent': 'Solicitud enviada. Recibirá el enlace por correo.', 'sumup.alreadyRequested': 'Solicitud ya en curso.', 'sumup.onlinePayment': 'Pago en línea SumUp', 'sumup.receiveLink': 'Reciba un enlace de pago seguro por correo', 'sumup.linkRequested': 'Enlace solicitado', 'sumup.pendingRequests': 'Solicitudes de enlace SumUp', 'sumup.pending': 'pendiente', 'sumup.pasteLinkHere': 'Pegar enlace SumUp aquí...', 'sumup.send': 'Enviar', 'sumup.linkSent': 'Enlace SumUp enviado al cliente por correo!',
};

export default es;
